
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("C9t7g", function(module, exports) {

var $hPkGG = parcelRequire("hPkGG");


var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $5izcQ = parcelRequire("5izcQ");


var $iKHTh = parcelRequire("iKHTh");


var $fufCn = parcelRequire("fufCn");


var $bedQP = parcelRequire("bedQP");


var $hHhbz = parcelRequire("hHhbz");

var $gHaxX = parcelRequire("gHaxX");


var $12t1c = parcelRequire("12t1c");


var $ikOWI = parcelRequire("ikOWI");

var $l998X = parcelRequire("l998X");





var $eyWa4 = parcelRequire("eyWa4");





var $5hYae = parcelRequire("5hYae");

const $167cc3f1dc82a812$var$ShortcutsMenuComponent = ({ shortcutItems: shortcutItems = [], product: product, openInSameTab: openInSameTab, invitedAppProductLinks: invitedAppProductLinks })=>{
    const mappedShortcutItems = (0, $42omo.useMemo)(()=>{
        return shortcutItems.map((item)=>{
            if (item.type === 'link' && item.apsKey) {
                const key = item.apsKey;
                const filteredProductLinks = invitedAppProductLinks[item.apsKey];
                // By the time we got here, we've already decided we're eligible etc.,
                // During SSR, we don't have the product links yet
                // so we return the item without URL to ensure rendering the shortcut
                // After the product links are loaded, the shortcut will be updated with the URL
                if (!filteredProductLinks) return {
                    ...item,
                    key: key
                };
                // we only want to take single link items as we are not supporting expand menus
                if (filteredProductLinks.length === 1 && !item.url) return {
                    ...item,
                    key: key,
                    url: filteredProductLinks[0].url
                };
            }
            return null;
        }).filter(Boolean);
    }, [
        shortcutItems,
        invitedAppProductLinks
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $eyWa4.default), {
        testId: "shortcuts-menu",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iKHTh.MenuList), {
            children: mappedShortcutItems.map((shortcut)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $5hYae.ShortcutMenuItem), {
                    shortcut: shortcut,
                    product: product,
                    openInSameTab: openInSameTab
                }, shortcut.key))
        })
    });
};
const $167cc3f1dc82a812$export$4519a9392cf3004e = /*#__PURE__*/ (0, $42omo.memo)($167cc3f1dc82a812$var$ShortcutsMenuComponent);





var $culkJ = parcelRequire("culkJ");


var $4IT4p = parcelRequire("4IT4p");

const $87dae69a81f59d82$export$f96c96985b06f150 = ({ shortcutItemsConfig: shortcutItemsConfig, getCachedProductLinks: getCachedProductLinks, updateHydratedProductLinks: updateHydratedProductLinks })=>{
    const invitedAppProductLinks = (0, $42omo.useMemo)(()=>$87dae69a81f59d82$var$resolveCachedInvitedAppProductLinks(shortcutItemsConfig, getCachedProductLinks), [
        shortcutItemsConfig,
        getCachedProductLinks
    ]);
    /**
	 * Update invited app product links when getFilteredProductLinks changes
	 */ const handleUpdateInvitedAppProductLinks = (0, $42omo.useCallback)((getFilteredProductLinks)=>{
        if (typeof getFilteredProductLinks === 'function') {
            const hydratedLinks = $87dae69a81f59d82$var$resolveInvitedAppProductLinks(getFilteredProductLinks, shortcutItemsConfig);
            if (Object.keys(hydratedLinks).length > 0) updateHydratedProductLinks($87dae69a81f59d82$var$toProductLinksByProduct(hydratedLinks));
        }
    }, [
        shortcutItemsConfig,
        updateHydratedProductLinks
    ]);
    return {
        invitedAppProductLinks: invitedAppProductLinks,
        handleUpdateInvitedAppProductLinks: handleUpdateInvitedAppProductLinks
    };
};
const $87dae69a81f59d82$var$resolveInvitedAppProductLinks = (getFilteredProductLinks, shortcutItemsConfig)=>{
    // No need to resolve links if there are no shortcut items config
    if (Object.keys(shortcutItemsConfig).length === 0) return {};
    let loaded = false;
    const resolved = Object.entries(shortcutItemsConfig).reduce((acc, [, config])=>{
        if (config.type === 'link' && config.apsKey) {
            const { links: links, status: status } = getFilteredProductLinks(config.apsKey);
            // the status is same across all links, so we can use it to determine if the links are loaded
            if (status === (0, $culkJ.RequestStatus).COMPLETE) loaded = true;
            acc[config.apsKey] = links;
        }
        return acc;
    }, {});
    return loaded ? resolved : {};
};
const $87dae69a81f59d82$var$resolveCachedInvitedAppProductLinks = (shortcutItemsConfig, getCachedProductLinks)=>{
    const cachedProductLinks = getCachedProductLinks();
    if (!cachedProductLinks) return {};
    return Object.values(shortcutItemsConfig).reduce((acc, config)=>{
        if (config.type === 'link' && config.apsKey && (0, $4IT4p.isAllowedApsKey)(config.apsKey)) {
            const product = (0, $4IT4p.getAppKeyByApsKey)(config.apsKey);
            const links = cachedProductLinks[product];
            if (links) acc[config.apsKey] = links;
        }
        return acc;
    }, {});
};
const $87dae69a81f59d82$var$toProductLinksByProduct = (productLinksByApsKey)=>Object.entries(productLinksByApsKey).reduce((acc, [apsKey, links])=>{
        if ((0, $4IT4p.isAllowedApsKey)(apsKey)) {
            const product = (0, $4IT4p.getAppKeyByApsKey)(apsKey);
            acc[product] = links;
        }
        return acc;
    }, {});



var $fEmGS = parcelRequire("fEmGS");


var $jMyy4 = parcelRequire("jMyy4");


var $b3j2Y = parcelRequire("b3j2Y");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");


var $dPJCf = parcelRequire("dPJCf");


var $epLE5 = parcelRequire("epLE5");


var $jmjWc = parcelRequire("jmjWc");


var $gKr8t = parcelRequire("gKr8t");


var $9wGTI = parcelRequire("9wGTI");


var $2VQ4B = parcelRequire("2VQ4B");


var $6adZX = parcelRequire("6adZX");


var $5XsiK = parcelRequire("5XsiK");


var $6mKj3 = parcelRequire("6mKj3");

/* SimplifyNavNewUserSpotlight.tsx generated by @compiled/babel-plugin v0.36.1 */ /**
 * Spotlight anchored to the "Recent" item in the main nav (ACTIVATION-2059).
 * Shown only when: eligible for simplify-nav experiment, treatment variant, D1+,
 * Recent is in main nav, not seen/dismissed, and user hasn't opened customize dialog.
 */ 



var $aXWIB = parcelRequire("aXWIB");





var $gdv5Z = parcelRequire("gdv5Z");

var $iXCQx = parcelRequire("iXCQx");


var $k7Tf7 = parcelRequire("k7Tf7");

var $a90ar = parcelRequire("a90ar");

var $3chlW = parcelRequire("3chlW");

var $f1UQW = parcelRequire("f1UQW");

var $71521 = parcelRequire("71521");

var $aVS0S = parcelRequire("aVS0S");

var $2owmo = parcelRequire("2owmo");

var $eopLP = parcelRequire("eopLP");

var $aZQ5F = parcelRequire("aZQ5F");

var $bUJpY = parcelRequire("bUJpY");

var $fNcP1 = parcelRequire("fNcP1");

var $8tIbq = parcelRequire("8tIbq");


var $lsxnT = parcelRequire("lsxnT");


var $3IBnw = parcelRequire("3IBnw");


var $hSqtY = parcelRequire("hSqtY");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");


var $e4o8D = parcelRequire("e4o8D");

/**
 * Store and hooks for Simplify Nav New User spotlight state (ACTIVATION-2059).
 * Centralizes hasOpenedCustomize so we can clean up in one place if the experiment is abandoned.
 */ 
var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");







const $4bc89b0e707470fb$var$getInitialHasOpenedCustomize = ()=>{
    try {
        return (0, $17wUi.confluenceLocalStorageInstance)?.getItemAsBoolean((0, $1UApO.keys).SIMPLIFY_NAV_NEW_USER_SPOTLIGHT_CUSTOMIZE_OPENED) ?? false;
    } catch  {
        return false;
    }
};
const $4bc89b0e707470fb$var$getInitialHasOpenedCustomizeXflow = ()=>{
    try {
        return (0, $17wUi.confluenceLocalStorageInstance)?.getItemAsBoolean((0, $1UApO.keys).SIMPLIFY_NAV_XFLOW_SPOTLIGHT_CUSTOMIZE_OPENED) ?? false;
    } catch  {
        return false;
    }
};
const $4bc89b0e707470fb$var$SOURCE_CONFIG = {
    'new-user': {
        stateKey: 'hasOpenedCustomize',
        storageKey: (0, $1UApO.keys).SIMPLIFY_NAV_NEW_USER_SPOTLIGHT_CUSTOMIZE_OPENED
    },
    xflow: {
        stateKey: 'hasOpenedCustomizeXflow',
        storageKey: (0, $1UApO.keys).SIMPLIFY_NAV_XFLOW_SPOTLIGHT_CUSTOMIZE_OPENED
    }
};
const $4bc89b0e707470fb$var$initialState = {
    hasOpenedCustomize: $4bc89b0e707470fb$var$getInitialHasOpenedCustomize(),
    hasOpenedCustomizeXflow: $4bc89b0e707470fb$var$getInitialHasOpenedCustomizeXflow()
};
const $4bc89b0e707470fb$export$8933eed9fee477e = (0, $1P1Tu.createStore)({
    initialState: $4bc89b0e707470fb$var$initialState,
    actions: {
        setHasOpenedCustomize: (source = 'new-user')=>({ setState: setState, getState: getState })=>{
                const { stateKey: stateKey, storageKey: storageKey } = $4bc89b0e707470fb$var$SOURCE_CONFIG[source];
                if (getState()[stateKey]) return;
                if (source === 'xflow') setState({
                    hasOpenedCustomizeXflow: true
                });
                else setState({
                    hasOpenedCustomize: true
                });
                try {
                    (0, $17wUi.confluenceLocalStorageInstance)?.setItem(storageKey, 'true');
                } catch  {
                // storage unavailable
                }
            }
    },
    name: 'simplifyNavNewUserSpotlightStore'
});
const $4bc89b0e707470fb$export$5dbbd2025a13ab73 = (0, $9zUhf.createHook)($4bc89b0e707470fb$export$8933eed9fee477e, {
    selector: (state)=>state.hasOpenedCustomize
});
const $4bc89b0e707470fb$export$5a47cb23178132bb = (0, $9zUhf.createHook)($4bc89b0e707470fb$export$8933eed9fee477e, {
    selector: (state, source)=>source === 'xflow' ? state.hasOpenedCustomizeXflow : state.hasOpenedCustomize
});
const $4bc89b0e707470fb$export$9168e89189b336b6 = (0, $9zUhf.createActionsHook)($4bc89b0e707470fb$export$8933eed9fee477e);


const $e8cb5a3d9666ba33$var$spotlightHeadlineStyles = {
    headingOneLine: "_o5721q9c"
};
const $e8cb5a3d9666ba33$var$i18n = (0, $aXWIB.defineMessages)({
    spotlightHeading: {
        id: "experiment-simplify-nav-new-user.spotlight-heading",
        defaultMessage: "We added features to your sidebar"
    },
    spotlightBody: {
        id: "experiment-simplify-nav-new-user.spotlight-body",
        defaultMessage: "Customize what appears here by selecting {more} at the bottom of your sidebar."
    },
    more: {
        id: "experiment-simplify-nav-new-user.more",
        defaultMessage: "More"
    },
    gotIt: {
        id: "experiment-simplify-nav-new-user.got-it",
        defaultMessage: "Got it"
    }
});
const $e8cb5a3d9666ba33$var$SimplifyNavNewUserSpotlightComponent = ({ children: children, shouldShowSpotlight: shouldShowSpotlight = false, source: source = 'new-user' })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { PopoverContent: PopoverContent } = (0, $lsxnT.useChoreographerAssets)();
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const [hasDismissed, setHasDismissed] = (0, $42omo.useState)(false);
    const [hasSeenOrDismissed] = (0, $42omo.useState)(()=>$e8cb5a3d9666ba33$var$getHasSeenOrDismissed(source));
    const [hasOpenedCustomize] = (0, $4bc89b0e707470fb$export$5a47cb23178132bb)(source); // Parent gates with useSimplifiedNavSpotlight (eligibility, treatment, D1+). We only check session-specific conditions.
    const shouldShow = shouldShowSpotlight && !hasSeenOrDismissed && !hasOpenedCustomize && !hasDismissed && !renderServerPlaceholder;
    const handleDismiss = (0, $42omo.useCallback)((reason)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: `simplifyNavNewUserSpotlight${reason === 'dismiss-control' ? 'Dismiss' : 'CTA'}`,
                source: $e8cb5a3d9666ba33$var$getMessageId(source)
            }
        }).fire();
        $e8cb5a3d9666ba33$var$markSeenOrDismissed(source);
        setHasDismissed(true);
    }, [
        createAnalyticsEvent,
        source
    ]); // Always render PopoverProvider/PopoverTarget so children's parent never changes,
    // preserving React state (e.g., RecentItem flyout state) when spotlight visibility toggles.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k7Tf7.PopoverProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a90ar.PopoverTarget), null, children), shouldShow && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8tIbq.UNSAFE_UpdateOnChange), {
        selectors: [
            'nav#side-navigation'
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(PopoverContent, {
        messageId: $e8cb5a3d9666ba33$var$getMessageId(source),
        messageType: "engagement",
        placement: "right-end",
        offset: [
            0,
            16
        ],
        dismiss: ()=>handleDismiss('auto'),
        isVisible: shouldShow,
        onMessageDisposition: (status)=>{
            if (status === 'started') {
                createAnalyticsEvent({
                    type: 'sendScreenEvent',
                    data: {
                        name: $e8cb5a3d9666ba33$var$getScreenEventName(source),
                        attributes: {
                            source: 'RecentItem'
                        }
                    }
                }).fire();
                $e8cb5a3d9666ba33$var$markSeenOrDismissed(source);
            }
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $71521.SpotlightCard), {
        testId: "simplify-nav-new-user-spotlight"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aZQ5F.SpotlightHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUJpY.SpotlightHeadline), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $e8cb5a3d9666ba33$var$spotlightHeadlineStyles.headingOneLine
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $e8cb5a3d9666ba33$var$i18n.spotlightHeading))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aVS0S.SpotlightControls), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2owmo.SpotlightDismissControl), {
        onClick: ()=>handleDismiss('dismiss-control'),
        autoFocus: false
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f1UQW.SpotlightBody), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        ...$e8cb5a3d9666ba33$var$i18n.spotlightBody,
        values: {
            more: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
                as: "strong"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $e8cb5a3d9666ba33$var$i18n.more))
        }
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eopLP.SpotlightFooter), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3chlW.SpotlightActions), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fNcP1.SpotlightPrimaryAction), {
        onClick: ()=>handleDismiss('primary-action')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $e8cb5a3d9666ba33$var$i18n.gotIt))))))));
};
const $e8cb5a3d9666ba33$export$bbe775696798290c = ({ source: source, ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hSqtY.TransparentErrorBoundary), {
        attribution: source === 'xflow' ? (0, $3IBnw.Attribution).GROWTH_CFIND : (0, $3IBnw.Attribution).FLYWHEEL_ACTIVATION
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e8cb5a3d9666ba33$var$SimplifyNavNewUserSpotlightComponent, {
        source: source,
        ...rest
    }));
const $e8cb5a3d9666ba33$var$getMessageId = (source)=>source === 'xflow' ? 'cfind-5565-nav-spotlight' : 'simplify-nav-new-user-spotlight';
const $e8cb5a3d9666ba33$var$getScreenEventName = (source)=>source === 'xflow' ? 'Cfind5565NavSpotlight' : 'SimplifyNavNewUserSpotlight';
const $e8cb5a3d9666ba33$var$getDismissedKey = (source)=>source === 'xflow' ? (0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_SIMPLIFY_NAV_XFLOW_SPOTLIGHT_DISMISSED : (0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_SIMPLIFY_NAV_NEW_USER_SPOTLIGHT_DISMISSED;
const $e8cb5a3d9666ba33$var$getHasSeenOrDismissed = (source)=>{
    try {
        return (0, $17wUi.confluenceLocalStorageInstance)?.getItemAsBoolean($e8cb5a3d9666ba33$var$getDismissedKey(source)) ?? false;
    } catch  {
        return false;
    }
};
const $e8cb5a3d9666ba33$var$markSeenOrDismissed = (source)=>{
    try {
        (0, $17wUi.confluenceLocalStorageInstance)?.setItem($e8cb5a3d9666ba33$var$getDismissedKey(source), 'true');
    } catch  {}
};



var $41KFX = parcelRequire("41KFX");

const $02947314900d85ba$export$79c4a1ca811bb387 = ({ globalMenuItems: globalMenuItems, navStyle: navStyle, isWithinD0: isWithinD0 })=>{
    const isRecentInMainNav = globalMenuItems.some((item)=>item.menuId === 'recent');
    const isEligibleForSpotlight = isRecentInMainNav && (0, $41KFX.TREATMENT_COHORTS).has(navStyle);
    return {
        shouldShowSpotlight: isEligibleForSpotlight && !isWithinD0,
        shouldPersistCustomizeOpen: isEligibleForSpotlight
    };
};




var $8dN99 = parcelRequire("8dN99");


var $fPgmM = parcelRequire("fPgmM");


var $frIzR = parcelRequire("frIzR");


var $i4dNk = parcelRequire("i4dNk");




const $12338c25dd8aaf48$var$STANDARD_ITEMS_HIDDEN = [
    {
        menuId: 'recent',
        visible: false
    },
    {
        menuId: 'starred',
        visible: false
    },
    {
        menuId: 'companyHubShortcut',
        visible: false
    },
    {
        menuId: 'teamsShortcut',
        visible: false
    }
];
const $12338c25dd8aaf48$export$2471979fb08e1cdf = (platformCustomizations)=>{
    const $ = (0, $frIzR.c)(21);
    const { navCustomization: navCustomization } = (0, $i4dNk.useCfind4473CreationFocusedNav)(true);
    const { navStyle: navStyle, isWithinD0: isWithinD0 } = (0, $41KFX.useSimplifiedNavNewUsers)();
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = [];
        $[0] = t0;
    } else t0 = $[0];
    let customizedForExperiment = t0;
    if (navCustomization === (0, $i4dNk.loading)) {
        let t1;
        if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
            t1 = [
                ...$12338c25dd8aaf48$var$STANDARD_ITEMS_HIDDEN,
                {
                    menuId: "templates",
                    visible: false
                }
            ];
            $[1] = t1;
        } else t1 = $[1];
        customizedForExperiment = t1;
    } else if (navCustomization === (0, $i4dNk.d0)) {
        let t1;
        if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
            t1 = [
                ...$12338c25dd8aaf48$var$STANDARD_ITEMS_HIDDEN,
                {
                    menuId: "templates",
                    visible: true
                }
            ];
            $[2] = t1;
        } else t1 = $[2];
        customizedForExperiment = t1;
    } else {
        if (navCustomization === (0, $i4dNk.d1)) {
            let t1;
            if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
                t1 = [
                    {
                        menuId: "templates",
                        visible: true
                    }
                ];
                $[3] = t1;
            } else t1 = $[3];
            customizedForExperiment = t1;
        } else if (navStyle === "loading") {
            let t1;
            if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
                t1 = [
                    ...$12338c25dd8aaf48$var$STANDARD_ITEMS_HIDDEN,
                    {
                        menuId: "templates",
                        visible: false
                    }
                ];
                $[4] = t1;
            } else t1 = $[4];
            customizedForExperiment = t1;
        } else {
            if (navStyle === "default-templates") {
                if (isWithinD0) {
                    let t1;
                    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
                        t1 = [
                            ...$12338c25dd8aaf48$var$STANDARD_ITEMS_HIDDEN
                        ];
                        $[5] = t1;
                    } else t1 = $[5];
                    customizedForExperiment = t1;
                }
            } else if (navStyle === "pin-templates") {
                let t1;
                if ($[6] !== isWithinD0) {
                    let t2;
                    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
                        t2 = {
                            menuId: "templates",
                            visible: true
                        };
                        $[8] = t2;
                    } else t2 = $[8];
                    t1 = [
                        ...isWithinD0 ? $12338c25dd8aaf48$var$STANDARD_ITEMS_HIDDEN : [],
                        t2
                    ];
                    $[6] = isWithinD0;
                    $[7] = t1;
                } else t1 = $[7];
                customizedForExperiment = t1;
            }
        }
    }
    let t1;
    if ($[9] !== platformCustomizations) {
        t1 = new Set(platformCustomizations.map($12338c25dd8aaf48$var$_temp));
        $[9] = platformCustomizations;
        $[10] = t1;
    } else t1 = $[10];
    const customizedMenuIds = t1;
    let t2;
    if ($[11] !== customizedForExperiment || $[12] !== customizedMenuIds) {
        t2 = customizedForExperiment.filter((item_0)=>!customizedMenuIds.has(item_0.menuId));
        $[11] = customizedForExperiment;
        $[12] = customizedMenuIds;
        $[13] = t2;
    } else t2 = $[13];
    const itemsToCustomize = t2;
    let t3;
    if ($[14] !== itemsToCustomize || $[15] !== platformCustomizations) {
        t3 = [
            ...platformCustomizations,
            ...itemsToCustomize
        ];
        $[14] = itemsToCustomize;
        $[15] = platformCustomizations;
        $[16] = t3;
    } else t3 = $[16];
    const platformCustomizationsWithSimplifyNav = t3;
    let t4;
    if ($[17] !== isWithinD0 || $[18] !== navStyle || $[19] !== platformCustomizationsWithSimplifyNav) {
        t4 = {
            platformCustomizationsWithSimplifyNav: platformCustomizationsWithSimplifyNav,
            navStyle: navStyle,
            isWithinD0: isWithinD0
        };
        $[17] = isWithinD0;
        $[18] = navStyle;
        $[19] = platformCustomizationsWithSimplifyNav;
        $[20] = t4;
    } else t4 = $[20];
    return t4;
};
function $12338c25dd8aaf48$var$_temp(item) {
    return item.menuId;
}



var $1uFsv = parcelRequire("1uFsv");








var $5d9b4 = parcelRequire("5d9b4");


var $5spQU = parcelRequire("5spQU");





var $1NBp8 = parcelRequire("1NBp8");


var $1ytiN = parcelRequire("1ytiN");


var $cEgMD = parcelRequire("cEgMD");


var $eSLr0 = parcelRequire("eSLr0");


var $6ld6a = parcelRequire("6ld6a");








var $eI95o = parcelRequire("eI95o");


var $1jJCz = parcelRequire("1jJCz");


var $h7d8T = parcelRequire("h7d8T");

const $5cb9965cd3125e0a$var$AuthenticationEnumMap = {
    //0 least privileged, 3 most privileged
    [(0, $d9tcB.AccessStatus).ANONYMOUS_ACCESS]: 0,
    [(0, $d9tcB.AccessStatus).EXTERNAL_COLLABORATOR_ACCESS]: 1,
    [(0, $d9tcB.AccessStatus).EXTERNAL_SHARE_ACCESS]: 0,
    [(0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS]: 3,
    [(0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS]: 2,
    [(0, $d9tcB.AccessStatus).NOT_PERMITTED]: 0,
    [(0, $d9tcB.AccessStatus).UNLICENSED_AUTHENTICATED_ACCESS]: 1
};
// Default configuration for all possible top-level items in Confluence Global Nav
const $5cb9965cd3125e0a$var$defaultMenuConfiguration = {
    customHome: {
        defaultVisibility: true,
        authenticationLevelRequired: (0, $d9tcB.AccessStatus).ANONYMOUS_ACCESS,
        isCustomizable: false
    },
    yourWork: {
        defaultVisibility: true,
        authenticationLevelRequired: (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS,
        isCustomizable: false
    },
    companyHub: {
        defaultVisibility: true,
        authenticationLevelRequired: (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS,
        isCustomizable: false
    },
    recent: {
        defaultVisibility: true,
        authenticationLevelRequired: (0, $d9tcB.AccessStatus).UNLICENSED_AUTHENTICATED_ACCESS,
        isCustomizable: true
    },
    starred: {
        defaultVisibility: true,
        authenticationLevelRequired: (0, $d9tcB.AccessStatus).UNLICENSED_AUTHENTICATED_ACCESS,
        isCustomizable: true
    },
    spaces: {
        defaultVisibility: true,
        authenticationLevelRequired: (0, $d9tcB.AccessStatus).ANONYMOUS_ACCESS,
        isCustomizable: true
    },
    apps: {
        defaultVisibility: true,
        authenticationLevelRequired: (0, $d9tcB.AccessStatus).ANONYMOUS_ACCESS,
        isCustomizable: true
    },
    goals: {
        //todo: where does this go?
        defaultVisibility: false,
        authenticationLevelRequired: (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS,
        isCustomizable: true,
        href: '#',
        apsKey: 'GOALS'
    },
    topics: {
        //todo: where does this go?
        defaultVisibility: false,
        authenticationLevelRequired: (0, $d9tcB.AccessStatus).ANONYMOUS_ACCESS,
        isCustomizable: true,
        href: '#'
    },
    teams: {
        defaultVisibility: true,
        authenticationLevelRequired: (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS,
        isCustomizable: true,
        href: (0, $1NBp8.CONFLUENCE_PEOPLE_DIRECTORY_SEARCH).toUrl()
    },
    drafts: {
        defaultVisibility: false,
        authenticationLevelRequired: (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS,
        isCustomizable: true,
        href: (0, $1NBp8.HOME).toUrl({
            view: 'drafts'
        })
    },
    tasks: {
        defaultVisibility: false,
        authenticationLevelRequired: (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS,
        isCustomizable: true,
        href: (0, $1NBp8.HOME).toUrl({
            view: 'tasks'
        })
    },
    templates: {
        defaultVisibility: false,
        authenticationLevelRequired: (0, $d9tcB.AccessStatus).ANONYMOUS_ACCESS,
        isCustomizable: true,
        href: (0, $1NBp8.TEMPLATE_GALLERY).toUrl()
    },
    companyHubShortcut: {
        defaultVisibility: true,
        authenticationLevelRequired: (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS,
        isCustomizable: true,
        isAppShortcut: true,
        href: (0, $1NBp8.COMPANY_HUB).toUrl()
    },
    jiraShortcut: {
        defaultVisibility: true,
        authenticationLevelRequired: (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS,
        isCustomizable: true,
        isAppShortcut: true,
        apsKey: 'JIRA_SOFTWARE'
    },
    loomShortcut: {
        defaultVisibility: true,
        authenticationLevelRequired: (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS,
        isCustomizable: true,
        isAppShortcut: true,
        apsKey: 'LOOM'
    },
    teamsShortcut: {
        defaultVisibility: true,
        authenticationLevelRequired: (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS,
        isCustomizable: true,
        isAppShortcut: true,
        apsKey: 'TEAMS'
    },
    customize: {
        defaultVisibility: false,
        authenticationLevelRequired: (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS,
        isCustomizable: false
    }
};
const $5cb9965cd3125e0a$var$defaultPlatformCustomizationList = Object.entries($5cb9965cd3125e0a$var$defaultMenuConfiguration).filter(([, { isCustomizable: isCustomizable }])=>isCustomizable).map(([menuId, { defaultVisibility: defaultVisibility, isAppShortcut: isAppShortcut }])=>({
        menuId: menuId,
        visible: defaultVisibility,
        isAppShortcut: isAppShortcut || false
    }));
const $5cb9965cd3125e0a$var$mergeCustomizationsWithDefaults = (0, (/*@__PURE__*/$parcel$interopDefault($5d9b4)))((platformCustomizations)=>{
    const validatedCustomizations = [];
    const customizedMenuIds = new Set();
    platformCustomizations?.forEach((item)=>{
        if ($5cb9965cd3125e0a$var$defaultMenuConfiguration[item.menuId]) {
            validatedCustomizations.push(item);
            customizedMenuIds.add(item.menuId);
        }
    });
    // These items always appear first
    const finalMenuItems = [
        {
            menuId: 'customHome',
            visible: true
        },
        {
            menuId: 'yourWork',
            visible: true
        }
    ];
    // Add any customized menu items
    validatedCustomizations.forEach((item)=>{
        finalMenuItems.push(item);
    });
    // Add any default items that were not customized
    $5cb9965cd3125e0a$var$defaultPlatformCustomizationList.forEach((item)=>{
        if (!customizedMenuIds.has(item.menuId)) finalMenuItems.push(item);
    });
    // Company Hub is an app shortcut.
    finalMenuItems.push({
        menuId: 'companyHub',
        visible: true
    });
    // Customize always appears last
    finalMenuItems.push({
        menuId: 'customize',
        visible: true
    });
    return finalMenuItems;
});
const $5cb9965cd3125e0a$var$createMenuItem = (menuId, config)=>({
        menuId: menuId,
        isCustomizable: config.isCustomizable,
        ...config.href && {
            href: config.href
        },
        ...config.isAppShortcut && {
            isAppShortcut: config.isAppShortcut
        }
    });
const $5cb9965cd3125e0a$var$createMenuItemNext = (menuId, config, visible)=>({
        menuId: menuId,
        visible: visible,
        isNotCustomizable: !config.isCustomizable,
        isNotToggleable: !config.isCustomizable,
        ...config.href && {
            href: config.href
        },
        ...config.isAppShortcut && {
            isAppShortcut: config.isAppShortcut
        }
    });
const $5cb9965cd3125e0a$export$9ef0020da7b7dcc4 = (showCustomization, accessStatus, platformCustomizations, visibilityOverrides, getFilteredProductLinks, fallbackUrls)=>{
    const globalMenuItems = [];
    const moreMenuItems = [];
    const appShortcutMenuItems = [];
    const allMenuItems = [];
    const orderedItems = $5cb9965cd3125e0a$var$mergeCustomizationsWithDefaults(platformCustomizations);
    const customizeItemId = 'customize';
    orderedItems.forEach((item)=>{
        const menuId = item.menuId;
        const defaultConfig = $5cb9965cd3125e0a$var$defaultMenuConfiguration[menuId];
        const accessStatusLevel = accessStatus && $5cb9965cd3125e0a$var$AuthenticationEnumMap[accessStatus] || 0; //if accessStatus is null, we default to anon level access
        if (//check if auth level is equal to or greater than what's required for each menu item
        $5cb9965cd3125e0a$var$AuthenticationEnumMap[defaultConfig.authenticationLevelRequired] <= accessStatusLevel && visibilityOverrides?.[menuId] !== false && menuId !== customizeItemId && !defaultConfig.isAppShortcut) {
            const menuItem = $5cb9965cd3125e0a$var$createMenuItem(menuId, defaultConfig);
            (item.visible ? globalMenuItems : moreMenuItems).push(menuItem);
            allMenuItems.push($5cb9965cd3125e0a$var$createMenuItemNext(menuId, defaultConfig, item.visible));
        }
        // APP SHORTCUTS
        if (visibilityOverrides?.[menuId] && defaultConfig.isAppShortcut) {
            const pushConfig = {
                ...defaultConfig
            };
            if (getFilteredProductLinks && defaultConfig.apsKey) pushConfig.href = getFilteredProductLinks(defaultConfig.apsKey)?.links[0]?.url ?? fallbackUrls?.[menuId];
            if (pushConfig.apsKey && pushConfig.href || !pushConfig.apsKey) {
                appShortcutMenuItems.push($5cb9965cd3125e0a$var$createMenuItemNext(item.menuId, pushConfig, item.visible));
                if (!item.visible) moreMenuItems.push($5cb9965cd3125e0a$var$createMenuItem(item.menuId, pushConfig));
            }
        }
    });
    // customize sidebar item should be the last item of the more items menu
    // unless there are no items, then it should be in the global menu items
    if (showCustomization && visibilityOverrides?.[customizeItemId] !== false) {
        const customizeItem = $5cb9965cd3125e0a$var$createMenuItem(customizeItemId, $5cb9965cd3125e0a$var$defaultMenuConfiguration[customizeItemId]);
        (moreMenuItems.length === 0 ? globalMenuItems : moreMenuItems).push(customizeItem);
    }
    return {
        globalMenuItems: globalMenuItems,
        moreMenuItems: moreMenuItems,
        allMenuItems: allMenuItems,
        appShortcutMenuItems: appShortcutMenuItems
    };
};
const $5cb9965cd3125e0a$export$aad046bd9909db8f = (showCustomization, accessStatus, platformCustomizations, getFilteredProductLinks)=>{
    const $ = (0, $frIzR.c)(28);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = {
            location: (0, $eSLr0.SYSTEM_HEADER_LEFT),
            allowedWebItems: [
                $5cb9965cd3125e0a$export$8fa81f0104234d32,
                $5cb9965cd3125e0a$export$78f3e9dc1aa1d31d
            ]
        };
        $[0] = t0;
    } else t0 = $[0];
    const { loading: webItemsLoading, webItems: webItems } = (0, $6ld6a.useWebItemLocation)(t0);
    const fallbackUrls = (0, $h7d8T.useFallbackUrls)();
    const { hasJira: hasJira, hasLoom: hasLoom } = (0, $1jJCz.useLicensedProducts)();
    const { homepageUri: homepageUri } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    const { isPeopleVisible: isPeopleVisible, isCompanyHubVisible: isCompanyHubVisible } = (0, $eI95o.useShortcutVisibilityOverrides)();
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $5XsiK.isTeamsAppEnabled)();
        $[1] = t1;
    } else t1 = $[1];
    const teamsAppEnabled = t1;
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = !(0, $5spQU.isFeatureEnabled)("confluence", "confluence-forge-apps-sidebar") && !(0, $9wGTI.fg)("forge-apps-sidebar-enabled-in-isolated-cloud");
        $[2] = t2;
    } else t2 = $[2];
    const shouldHideAppsSideBarInIsolatedCloud = t2;
    let t3;
    if ($[3] !== webItems || $[4] !== webItemsLoading) {
        t3 = !webItemsLoading && !!webItems.find($5cb9965cd3125e0a$var$_temp);
        $[3] = webItems;
        $[4] = webItemsLoading;
        $[5] = t3;
    } else t3 = $[5];
    const isSpacesVisible = t3;
    let t4;
    if ($[6] !== homepageUri || $[7] !== isCompanyHubVisible) {
        t4 = isCompanyHubVisible && homepageUri.includes((0, $cEgMD.getCompanyHubSpaceKey)());
        $[6] = homepageUri;
        $[7] = isCompanyHubVisible;
        $[8] = t4;
    } else t4 = $[8];
    const isCompanyHubSetAsCustomHome = t4;
    let t5;
    if ($[9] !== homepageUri || $[10] !== isCompanyHubSetAsCustomHome) {
        t5 = !isCompanyHubSetAsCustomHome && ![
            "/spa.action",
            "",
            "homepageUri"
        ].includes(homepageUri);
        $[9] = homepageUri;
        $[10] = isCompanyHubSetAsCustomHome;
        $[11] = t5;
    } else t5 = $[11];
    const isCustomHomeVisible = t5;
    let t6;
    if ($[12] !== isCompanyHubVisible) {
        t6 = isCompanyHubVisible && !(0, $9wGTI.fg)("nav4_global_links_confluence");
        $[12] = isCompanyHubVisible;
        $[13] = t6;
    } else t6 = $[13];
    const t7 = isPeopleVisible && !teamsAppEnabled;
    let t8;
    if ($[14] !== accessStatus || $[15] !== fallbackUrls || $[16] !== getFilteredProductLinks || $[17] !== hasJira || $[18] !== hasLoom || $[19] !== isCompanyHubVisible || $[20] !== isCustomHomeVisible || $[21] !== isPeopleVisible || $[22] !== isSpacesVisible || $[23] !== platformCustomizations || $[24] !== showCustomization || $[25] !== t6 || $[26] !== t7) {
        const visibilityOverrides = {
            customHome: isCustomHomeVisible,
            companyHub: t6,
            spaces: isSpacesVisible,
            teams: t7,
            topics: false,
            goals: false,
            templates: true,
            drafts: true,
            apps: !shouldHideAppsSideBarInIsolatedCloud,
            tasks: true,
            customize: true,
            companyHubShortcut: isCompanyHubVisible && (0, $9wGTI.fg)("nav4_global_links_confluence"),
            jiraShortcut: hasJira && (0, $9wGTI.fg)("nav4_global_links_confluence"),
            loomShortcut: hasLoom && (0, $9wGTI.fg)("nav4_global_links_confluence"),
            teamsShortcut: isPeopleVisible && teamsAppEnabled
        };
        t8 = $5cb9965cd3125e0a$export$9ef0020da7b7dcc4(showCustomization, accessStatus, platformCustomizations, visibilityOverrides, getFilteredProductLinks, fallbackUrls);
        $[14] = accessStatus;
        $[15] = fallbackUrls;
        $[16] = getFilteredProductLinks;
        $[17] = hasJira;
        $[18] = hasLoom;
        $[19] = isCompanyHubVisible;
        $[20] = isCustomHomeVisible;
        $[21] = isPeopleVisible;
        $[22] = isSpacesVisible;
        $[23] = platformCustomizations;
        $[24] = showCustomization;
        $[25] = t6;
        $[26] = t7;
        $[27] = t8;
    } else t8 = $[27];
    return t8;
};
const $5cb9965cd3125e0a$export$8fa81f0104234d32 = 'com.atlassian.confluence.plugins.confluence-space-ia:header-spaces-link';
const $5cb9965cd3125e0a$export$78f3e9dc1aa1d31d = 'com.atlassian.confluence.plugins.confluence-space-ia:header-people-link';
function $5cb9965cd3125e0a$var$_temp(item) {
    return item.completeKey === $5cb9965cd3125e0a$export$8fa81f0104234d32;
}









var $l5LHO = parcelRequire("l5LHO");

var $hND3b = parcelRequire("hND3b");

var $lNGn6 = parcelRequire("lNGn6");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $jh864 = parcelRequire("jh864");


var $9x2sR = parcelRequire("9x2sR");


var $jItTa = parcelRequire("jItTa");


var $63PsI = parcelRequire("63PsI");














var $8tdj3 = parcelRequire("8tdj3");


var $lAFHW = parcelRequire("lAFHW");














var $7aRa9 = parcelRequire("7aRa9");


var $7zgzO = parcelRequire("7zgzO");


var $ep3mz = parcelRequire("ep3mz");











var $1kHsc = parcelRequire("1kHsc");


const $d3915af5fe8217ec$var$lazyOnClick = async (args)=>{
    const { companyHubItemCallback: companyHubItemCallback } = await (parcelRequire("1pi2u"));
    await companyHubItemCallback(args);
};
const $d3915af5fe8217ec$export$40e9528e11a75d6b = (0, $7aRa9.withFlags)(/*#__PURE__*/ (0, $42omo.memo)((t0)=>{
    const $ = (0, $frIzR.c)(13);
    const { children: children, flags: flags, navVersion: navVersion } = t0;
    const companyHubName = (0, $63PsI.useCompanyHubName)();
    const { match: match, push: push } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const routeName = match?.name;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    let t1;
    if ($[0] !== createAnalyticsEvent || $[1] !== experienceTracker || $[2] !== flags || $[3] !== navVersion || $[4] !== push || $[5] !== routeName) {
        t1 = async ()=>{
            $d3915af5fe8217ec$var$lazyOnClick({
                createAnalyticsEvent: createAnalyticsEvent,
                experienceTracker: experienceTracker,
                flags: flags,
                isFirstTimeVisit: false,
                push: push,
                routeName: routeName,
                navVersion: navVersion
            });
        };
        $[0] = createAnalyticsEvent;
        $[1] = experienceTracker;
        $[2] = flags;
        $[3] = navVersion;
        $[4] = push;
        $[5] = routeName;
        $[6] = t1;
    } else t1 = $[6];
    const onClick = t1;
    let t2;
    if ($[7] !== children || $[8] !== companyHubName || $[9] !== onClick || $[10] !== routeName || $[11] !== spaceKey) {
        const isSelected = routeName === (0, $1NBp8.COMPANY_HUB).name || routeName !== (0, $1NBp8.ADMIN_COMPANY_HUB_PERMISSIONS).name && routeName !== (0, $1NBp8.COMPANY_HUB_ANALYTICS).name && routeName !== (0, $1NBp8.COMPANY_HUB_SETTINGS).name && (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey);
        t2 = children({
            companyHubName: companyHubName,
            isSelected: isSelected,
            namedRoute: (0, $1NBp8.COMPANY_HUB),
            onClick: onClick
        });
        $[7] = children;
        $[8] = companyHubName;
        $[9] = onClick;
        $[10] = routeName;
        $[11] = spaceKey;
        $[12] = t2;
    } else t2 = $[12];
    return t2;
}));


const $67a256fbfa808886$var$DEFAULT_COMPANY_HUB_NAME = 'Company Hub';
const $67a256fbfa808886$var$i18n = (0, $aXWIB.defineMessages)({
    CompanyHubName: {
        id: "side-navigation.custom.company-hub.shortcut-name",
        defaultMessage: "Company Hub"
    }
});
const $67a256fbfa808886$export$7d5e579a7612f1c2 = (t0)=>{
    const $ = (0, $frIzR.c)(2);
    const { isHidden: isHidden, onClick: onClick } = t0;
    if (isHidden) return null;
    let t1;
    if ($[0] !== onClick) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d3915af5fe8217ec$export$40e9528e11a75d6b), {
            navVersion: "4"
        }, (t2)=>{
            const { companyHubName: companyHubName, isSelected: isSelected, namedRoute: namedRoute, onClick: onAbstractCompanyHubItemClick } = t2;
            const elemBefore = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAFHW.HubIcon), {
                size: "xsmall"
            });
            const elemAfter = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8tdj3))), {
                label: "",
                spacing: "spacious",
                size: "small"
            });
            const onMenuLinkItemClick = ()=>{
                onClick?.();
                onAbstractCompanyHubItemClick();
            };
            const isDefaultCompanyHubName = companyHubName === $67a256fbfa808886$var$DEFAULT_COMPANY_HUB_NAME;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9x2sR.LinkMenuItem), {
                elemAfter: elemAfter,
                elemBefore: elemBefore,
                href: namedRoute?.toUrl() || "#",
                isSelected: isSelected,
                onClick: onMenuLinkItemClick,
                target: "_blank"
            }, isDefaultCompanyHubName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $67a256fbfa808886$var$i18n.CompanyHubName) : companyHubName);
        });
        $[0] = onClick;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
};



var $1LksZ = parcelRequire("1LksZ");


var $cxU8R = parcelRequire("cxU8R");


const $6bf303f52478ae0b$var$AddFeaturesSidebarSpotlightLoader = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "zs9s-",
    name: "AddFeaturesSidebarSpotlightLoader",
    loader: async ()=>(await (parcelRequire("iMhjI"))).AddFeaturesSidebarSpotlight
});
const $6bf303f52478ae0b$export$e967513bbeba0537 = ({ moreMenuItems: moreMenuItems, isOpen: isOpen, toggleMenu: toggleMenu, onClick: onClick, peekingId: peekingId, isCollapsed: isCollapsed })=>{
    const companyHubName = (0, $63PsI.useCompanyHubName)();
    const iconByMenuId = (0, $cxU8R.useIconByMenuId)();
    if (!moreMenuItems || moreMenuItems?.length <= 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $l5LHO.Popup), {
        isOpen: isOpen
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6bf303f52478ae0b$var$AddFeaturesSidebarSpotlightLoader, {
        isCollapsed: isCollapsed
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lNGn6.PopupTrigger), null, (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jh864.ButtonMenuItem), {
            ...triggerProps,
            elemBefore: (0, $cxU8R.MoreIconComponent),
            onClick: toggleMenu
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $1LksZ.i18n).more)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $6bf303f52478ae0b$var$popupContentContainerStyles,
        role: "listitem"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hND3b.PopupContent), {
        placement: "bottom-start",
        // Offset the top margin of the menu section.
        // This will keep an even spacing of menu items between those inside the dropdown and those above,
        // and keep the icons aligned
        offset: [
            -4,
            4
        ],
        onClose: toggleMenu,
        shouldRenderToParent: true,
        strategy: "absolute",
        shouldFitContainer: true
    }, ()=>{
        // The number of visible / non-null menu items so that proper dividers can be added.
        let nonNullMenuItemCount = 0;
        const menuItems = moreMenuItems.map(({ menuId: menuId, href: href, isAppShortcut: isAppShortcut })=>{
            if (peekingId && menuId === peekingId) return null; //if an item is peeking, do not render it in this menu
            ++nonNullMenuItemCount;
            if (menuId === 'companyHub') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, nonNullMenuItemCount !== 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jItTa.Divider), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $67a256fbfa808886$export$7d5e579a7612f1c2), {
                key: menuId,
                onClick: ()=>onClick(menuId),
                setIsCustomizeSidebarDialogVisible: ()=>{}
            }));
            let node;
            if (href) node = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9x2sR.LinkMenuItem), {
                href: href,
                onClick: ()=>onClick(menuId),
                elemBefore: iconByMenuId[menuId],
                key: menuId,
                target: isAppShortcut ? '_blank' : undefined
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
                ...(0, $1LksZ.i18n)[menuId],
                values: menuId === 'companyHubShortcut' ? {
                    companyHubName: companyHubName
                } : {}
            }));
            else node = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jh864.ButtonMenuItem), {
                onClick: ()=>onClick(menuId),
                elemBefore: iconByMenuId[menuId],
                key: menuId
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
                ...(0, $1LksZ.i18n)[menuId],
                values: menuId === 'companyHubShortcut' ? {
                    companyHubName: companyHubName
                } : {}
            }));
            // The item "Customize sidebar" is visually divided from the preceeding global items and/or app shortcuts:
            if (node && nonNullMenuItemCount !== 1 && menuId === 'customize') node = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jItTa.Divider), null), node);
            return node;
        });
        // PopupContent has an `xcss` prop, but it casts its value to `string` and thus isn't suitable.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $6bf303f52478ae0b$var$popupContentStyles,
            role: "list"
        }, menuItems);
    })));
};
const $6bf303f52478ae0b$var$popupContentContainerStyles = (0, $ecnYn.xcss)({
    position: 'relative',
    marginInline: 'space.negative.050',
    height: '0'
});
const $6bf303f52478ae0b$var$popupContentStyles = (0, $ecnYn.xcss)({
    paddingTop: 'space.050',
    paddingBottom: 'space.050',
    paddingLeft: 'space.050',
    paddingRight: 'space.050'
});






const $56093378b3ff8f83$export$ab2ae7fe36e2ecef = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "OtuwS",
    name: "GlobalAppShortcutsSectionLoader",
    loader: async ()=>(await (parcelRequire("fydXz"))).GlobalAppShortcutsSection
});


















var $jlIaF = parcelRequire("jlIaF");













const $15140e42b692bfde$var$i18n = (0, $aXWIB.defineMessages)({
    CustomHomeLink: {
        id: "side-navigation.custom.home.link",
        defaultMessage: "Custom Home Page"
    }
});

const $15140e42b692bfde$var$useLazyClickAnalytics = (0, $epLE5.createLazyCallbackHook)(async ()=>(await (parcelRequire("bfhzz"))).fireCustomHomepageClickedAnalytics);
const $15140e42b692bfde$export$adaf351fc9d12cd2 = ()=>{
    const $ = (0, $frIzR.c)(10);
    const { location: location, match: match } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const fireClickAnalytics = $15140e42b692bfde$var$useLazyClickAnalytics(createAnalyticsEvent, match?.name);
    const { homepageUri: homepageUri, homepageTitle: homepageTitle } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    let t0;
    if ($[0] !== homepageUri || $[1] !== location) {
        t0 = !!location && location.pathname === `${0, $jlIaF.CONTEXT_PATH}${homepageUri}` && location.search.includes("mode=global");
        $[0] = homepageUri;
        $[1] = location;
        $[2] = t0;
    } else t0 = $[2];
    const isSelected = t0;
    const t1 = `${(0, $jlIaF.CONTEXT_PATH)}${homepageUri}?mode=global`;
    let t2;
    if ($[3] !== homepageTitle) {
        t2 = homepageTitle || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $15140e42b692bfde$var$i18n.CustomHomeLink);
        $[3] = homepageTitle;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== fireClickAnalytics || $[6] !== isSelected || $[7] !== t1 || $[8] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9x2sR.LinkMenuItem), {
            href: t1,
            elemBefore: (0, $cxU8R.HomeIconComponent),
            isSelected: isSelected,
            onClick: fireClickAnalytics
        }, t2);
        $[5] = fireClickAnalytics;
        $[6] = isSelected;
        $[7] = t1;
        $[8] = t2;
        $[9] = t3;
    } else t3 = $[9];
    return t3;
};



























var $gnkil = parcelRequire("gnkil");


var $efvKr = parcelRequire("efvKr");


var $9vJRo = parcelRequire("9vJRo");


var $de2j9 = parcelRequire("de2j9");








var $aKkeT = parcelRequire("aKkeT");








var $4ByCJ = parcelRequire("4ByCJ");


const $b9c6e796d679cd96$var$EditorForYouSpotlightLoader = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "js-_l",
    name: "EditorForYouSpotlightLoader",
    loader: async ()=>(await (parcelRequire("jQODQ"))).EditorForYouSpotlight
});

const $b9c6e796d679cd96$var$useLazyClickAnalytics = (0, $epLE5.createLazyCallbackHook)(async ()=>(await (parcelRequire("bfhzz"))).fireHomeClickedAnalytics);
const $b9c6e796d679cd96$var$isOnHomeSelector = {
    selector: (routeUrl)=>{
        if (!routeUrl) return false;
        return routeUrl === (0, $1NBp8.HOME).toUrl() || routeUrl === (0, $1NBp8.WIKI).toUrl();
    }
};
const $b9c6e796d679cd96$export$bad442268319468b = ()=>{
    const $ = (0, $frIzR.c)(9);
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const fireClickAnalytics = $b9c6e796d679cd96$var$useLazyClickAnalytics(createAnalyticsEvent, routeDataRef);
    const isSelected = (0, $dPJCf.useRouteUrl)($b9c6e796d679cd96$var$isOnHomeSelector);
    const [t0] = (0, $efvKr.useLivePageMode)();
    const { isEditMode: isLiveEditMode } = t0;
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $1NBp8.HOME).toUrl();
        $[0] = t1;
    } else t1 = $[0];
    const homeUrl = t1;
    const t2 = !(isLiveEditMode || isOnEditRoute) ? (0, $gnkil.GO_HOME_SHORTCUT) : undefined;
    let t3;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $1LksZ.i18n).forYou);
        $[1] = t3;
    } else t3 = $[1];
    let t4;
    if ($[2] !== fireClickAnalytics || $[3] !== isSelected) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9vJRo.HomeOnboardingTakeoverV2HomeNudge), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b9c6e796d679cd96$var$EditorForYouSpotlightLoader, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9x2sR.LinkMenuItem), {
            href: homeUrl,
            elemBefore: (0, $cxU8R.ForYouIconComponent),
            isSelected: isSelected,
            onClick: fireClickAnalytics
        }, t3)));
        $[2] = fireClickAnalytics;
        $[3] = isSelected;
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] !== fireClickAnalytics || $[6] !== t2 || $[7] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aKkeT.KeyboardShortcutWrapper), {
            href: homeUrl,
            deprecatedKeyboardShortcut: t2,
            keyboardShortcut: (0, $gnkil.UNIVERSAL_GO_HOME_SHORTCUT),
            isAppNavigationShortcut: true,
            onShortcutTriggered: fireClickAnalytics
        }, t4);
        $[5] = fireClickAnalytics;
        $[6] = t2;
        $[7] = t4;
        $[8] = t5;
    } else t5 = $[8];
    return t5;
};
const $b9c6e796d679cd96$export$e0de4d71efbccd92 = ()=>{
    const $ = (0, $frIzR.c)(7);
    const { forYouItem: forYouItem } = (0, $4ByCJ.useForYouConfig)();
    if (!forYouItem) return null;
    const { isSelected: isSelected, ItemWrapper: ItemWrapper } = forYouItem;
    const url = forYouItem.url ?? "";
    const Wrapper = ItemWrapper ?? (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment;
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $1LksZ.i18n).forYou);
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== isSelected || $[2] !== url) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9x2sR.LinkMenuItem), {
            href: url,
            elemBefore: (0, $cxU8R.ForYouIconComponent),
            isSelected: isSelected
        }, t0);
        $[1] = isSelected;
        $[2] = url;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== Wrapper || $[5] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Wrapper, null, t1);
        $[4] = Wrapper;
        $[5] = t1;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
};
const $b9c6e796d679cd96$export$d16f83425c70386f = (props)=>{
    const $ = (0, $frIzR.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = (0, $9wGTI.fg)("navx-global-side-nav-confluence") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b9c6e796d679cd96$export$e0de4d71efbccd92, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b9c6e796d679cd96$export$bad442268319468b, props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
};















var $NlNUL = parcelRequire("NlNUL");

var $g5d7N = parcelRequire("g5d7N");

var $j3gDz = parcelRequire("j3gDz");














var $irVI7 = parcelRequire("irVI7");





var $aJPUt = parcelRequire("aJPUt");


























var $XO4by = parcelRequire("XO4by");


var $9cHD3 = parcelRequire("9cHD3");










const $3bf409fa34ce0763$export$27f33b8cbd60853b = (menuId, isSelected, isHidden, peekingId, setPeekingId)=>{
    const $ = (0, $frIzR.c)(14);
    const isPeeking = isSelected && isHidden;
    const [isAnyFlyoutPeeking] = (0, $6adZX.useIsFlyoutOpen)(peekingId);
    let t0;
    if ($[0] !== isAnyFlyoutPeeking || $[1] !== isPeeking || $[2] !== menuId || $[3] !== peekingId || $[4] !== setPeekingId) {
        t0 = ()=>{
            const peekingInState = peekingId === menuId;
            if (setPeekingId) {
                if (isPeeking && !peekingInState && !isAnyFlyoutPeeking) setPeekingId(menuId);
                if (!isPeeking && peekingInState) setPeekingId(undefined);
            }
        };
        $[0] = isAnyFlyoutPeeking;
        $[1] = isPeeking;
        $[2] = menuId;
        $[3] = peekingId;
        $[4] = setPeekingId;
        $[5] = t0;
    } else t0 = $[5];
    let t1;
    if ($[6] !== isAnyFlyoutPeeking || $[7] !== isHidden || $[8] !== isPeeking || $[9] !== isSelected || $[10] !== menuId || $[11] !== peekingId || $[12] !== setPeekingId) {
        t1 = [
            isHidden,
            peekingId,
            setPeekingId,
            menuId,
            isSelected,
            isPeeking,
            isAnyFlyoutPeeking
        ];
        $[6] = isAnyFlyoutPeeking;
        $[7] = isHidden;
        $[8] = isPeeking;
        $[9] = isSelected;
        $[10] = menuId;
        $[11] = peekingId;
        $[12] = setPeekingId;
        $[13] = t1;
    } else t1 = $[13];
    (0, $42omo.useEffect)(t0, t1);
    return !!(isHidden && !isPeeking);
};



const $43bbe423a7434a33$export$af1f39df90a1145e = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "r-0zb",
    name: "RecentContentMenuLoader",
    loader: async ()=>(await (parcelRequire("c2Z3L"))).RecentContentMenu,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9cHD3.ContentMenuLoadingState), null)
});

const $43bbe423a7434a33$var$useLazyClickAnalytics = (0, $epLE5.createLazyCallbackHook)(async ()=>(await (parcelRequire("bfhzz"))).fireRecentsClickedAnalytics);
const $43bbe423a7434a33$var$MENU_ID = 'recent';
const $43bbe423a7434a33$export$f1cccf52bb5faf3f = (t0)=>{
    const $ = (0, $frIzR.c)(37);
    const { isHidden: isHidden, peekingId: peekingId, setPeekingId: setPeekingId } = t0;
    const { isFlyoutOpen: isFlyoutOpen, openFlyout: openFlyout, closeFlyout: closeFlyout } = (0, $6adZX.useFlyout)($43bbe423a7434a33$var$MENU_ID);
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const hasBeenOpenedBefore = (0, $42omo.useRef)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const fireClickAnalytics = $43bbe423a7434a33$var$useLazyClickAnalytics(createAnalyticsEvent, routeDataRef);
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const [t1] = (0, $efvKr.useLivePageMode)();
    const { isEditMode: isLiveEditMode } = t1;
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    let t2;
    if ($[0] !== experienceTracker) {
        t2 = ()=>{
            experienceTracker.abort({
                name: (0, $irVI7.APP_NAV_PAGES_DROPDOWN_EXPERIENCE),
                reason: "Primary dropdown menu: closed by user",
                attributes: {
                    navVersion: "4",
                    dropdownType: "recent"
                }
            });
        };
        $[0] = experienceTracker;
        $[1] = t2;
    } else t2 = $[1];
    const abortExperienceTracker = t2;
    let t3;
    if ($[2] !== experienceTracker) {
        t3 = ()=>{
            experienceTracker.start({
                name: (0, $irVI7.APP_NAV_PAGES_DROPDOWN_EXPERIENCE),
                timeout: (0, $aJPUt.ExperienceTimeout).NAVIGATION_LOAD,
                attributes: {
                    navVersion: "4",
                    dropdownType: "recent"
                }
            });
        };
        $[2] = experienceTracker;
        $[3] = t3;
    } else t3 = $[3];
    const startExperienceTracker = t3;
    let t4;
    if ($[4] !== abortExperienceTracker || $[5] !== closeFlyout || $[6] !== fireClickAnalytics || $[7] !== isFlyoutOpen || $[8] !== openFlyout) {
        t4 = (newIsOpen)=>{
            if (!newIsOpen) {
                abortExperienceTracker();
                isFlyoutOpen && closeFlyout();
                if (hasBeenOpenedBefore.current) fireClickAnalytics(false);
            } else {
                openFlyout();
                hasBeenOpenedBefore.current = true;
            }
        };
        $[4] = abortExperienceTracker;
        $[5] = closeFlyout;
        $[6] = fireClickAnalytics;
        $[7] = isFlyoutOpen;
        $[8] = openFlyout;
        $[9] = t4;
    } else t4 = $[9];
    const onOpenChange = t4;
    let t5;
    if ($[10] !== fireClickAnalytics || $[11] !== isFlyoutOpen || $[12] !== isHidden || $[13] !== openFlyout || $[14] !== startExperienceTracker) {
        t5 = ()=>{
            if (!isFlyoutOpen) {
                fireClickAnalytics(true, true, isHidden);
                startExperienceTracker();
                openFlyout();
            }
        };
        $[10] = fireClickAnalytics;
        $[11] = isFlyoutOpen;
        $[12] = isHidden;
        $[13] = openFlyout;
        $[14] = startExperienceTracker;
        $[15] = t5;
    } else t5 = $[15];
    const onShortcutTriggered = t5;
    let t6;
    if ($[16] !== closeFlyout || $[17] !== fireClickAnalytics || $[18] !== isFlyoutOpen || $[19] !== openFlyout || $[20] !== startExperienceTracker) {
        t6 = ()=>{
            if (!isFlyoutOpen) {
                openFlyout();
                startExperienceTracker();
                fireClickAnalytics(true);
            } else closeFlyout();
        };
        $[16] = closeFlyout;
        $[17] = fireClickAnalytics;
        $[18] = isFlyoutOpen;
        $[19] = openFlyout;
        $[20] = startExperienceTracker;
        $[21] = t6;
    } else t6 = $[21];
    const onClick = t6;
    let t7;
    if ($[22] !== cloudId || $[23] !== isFlyoutOpen) {
        t7 = ()=>{
            if (!isFlyoutOpen) {
                $43bbe423a7434a33$export$af1f39df90a1145e.preload();
                (0, $XO4by.preloadRecentContentMenu)(cloudId);
            }
        };
        $[22] = cloudId;
        $[23] = isFlyoutOpen;
        $[24] = t7;
    } else t7 = $[24];
    const onHover = t7;
    const isSelected = (0, $dPJCf.useRouteUrl)($43bbe423a7434a33$var$isOnRecentRoute);
    const shouldHide = (0, $3bf409fa34ce0763$export$27f33b8cbd60853b)($43bbe423a7434a33$var$MENU_ID, isSelected || isFlyoutOpen, isHidden, peekingId, setPeekingId);
    const t8 = !(isLiveEditMode || isOnEditRoute) ? (0, $gnkil.GO_TO_RECENT_SHORTCUT) : undefined;
    let t9;
    if ($[25] !== closeFlyout || $[26] !== isFlyoutOpen || $[27] !== isSelected || $[28] !== onClick || $[29] !== onHover || $[30] !== onOpenChange || $[31] !== shouldHide) {
        t9 = !shouldHide && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            onMouseEnter: onHover,
            onFocus: onHover
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $NlNUL.FlyoutMenuItem), {
            onOpenChange: onOpenChange,
            isOpen: isFlyoutOpen
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $j3gDz.FlyoutMenuItemTrigger), {
            elemBefore: (0, $cxU8R.ClockIconComponent),
            onClick: onClick,
            isSelected: isSelected
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $1LksZ.i18n).recent)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $g5d7N.FlyoutMenuItemContent), {
            onClose: ()=>isFlyoutOpen && closeFlyout(),
            autoFocus: false
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($43bbe423a7434a33$export$af1f39df90a1145e, null))));
        $[25] = closeFlyout;
        $[26] = isFlyoutOpen;
        $[27] = isSelected;
        $[28] = onClick;
        $[29] = onHover;
        $[30] = onOpenChange;
        $[31] = shouldHide;
        $[32] = t9;
    } else t9 = $[32];
    let t10;
    if ($[33] !== onShortcutTriggered || $[34] !== t8 || $[35] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aKkeT.KeyboardShortcutWrapper), {
            deprecatedKeyboardShortcut: t8,
            keyboardShortcut: (0, $gnkil.UNIVERSAL_GO_TO_RECENT_SHORTCUT),
            isAppNavigationShortcut: true,
            onShortcutTriggered: onShortcutTriggered
        }, t9);
        $[33] = onShortcutTriggered;
        $[34] = t8;
        $[35] = t9;
        $[36] = t10;
    } else t10 = $[36];
    return t10;
};
const $43bbe423a7434a33$var$isOnRecentRoute = {
    selector: (routeUrl)=>routeUrl === (0, $1NBp8.HOME).toUrl({
            view: 'recent'
        })
};
































































var $eLFsG = parcelRequire("eLFsG");






const $d78d93494cd6b93d$export$17b89e6a36c6b530 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "ayHpY",
    name: "StarredContentMenuLoader",
    loader: async ()=>(await (parcelRequire("5RIc1"))).StarredContentMenu,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9cHD3.ContentMenuLoadingState), null)
});

const $d78d93494cd6b93d$var$useLazyClickAnalytics = (0, $epLE5.createLazyCallbackHook)(async ()=>(await (parcelRequire("bfhzz"))).fireStarredClickedAnalytics);
const $d78d93494cd6b93d$var$MENU_ID = 'starred';
const $d78d93494cd6b93d$export$d11aa717bebc8f86 = (t0)=>{
    const $ = (0, $frIzR.c)(46);
    const { isHidden: isHidden, peekingId: peekingId, setPeekingId: setPeekingId } = t0;
    const { isFlyoutOpen: isFlyoutOpen, openFlyout: openFlyout, closeFlyout: closeFlyout } = (0, $6adZX.useFlyout)($d78d93494cd6b93d$var$MENU_ID);
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const hasBeenOpenedBefore = (0, $42omo.useRef)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const fireClickAnalytics = $d78d93494cd6b93d$var$useLazyClickAnalytics(createAnalyticsEvent, routeDataRef);
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const [t1] = (0, $efvKr.useLivePageMode)();
    const { isEditMode: isLiveEditMode } = t1;
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    let t2;
    if ($[0] !== experienceTracker) {
        t2 = ()=>{
            experienceTracker.abort({
                name: (0, $irVI7.APP_NAV_PAGES_DROPDOWN_EXPERIENCE),
                reason: "Primary dropdown menu: closed by user",
                attributes: {
                    navVersion: "4",
                    dropdownType: "starred"
                }
            });
        };
        $[0] = experienceTracker;
        $[1] = t2;
    } else t2 = $[1];
    const abortExperienceTracker = t2;
    let t3;
    if ($[2] !== experienceTracker) {
        t3 = ()=>{
            experienceTracker.start({
                name: (0, $irVI7.APP_NAV_PAGES_DROPDOWN_EXPERIENCE),
                timeout: (0, $aJPUt.ExperienceTimeout).NAVIGATION_LOAD,
                attributes: {
                    navVersion: "4",
                    dropdownType: "starred"
                }
            });
        };
        $[2] = experienceTracker;
        $[3] = t3;
    } else t3 = $[3];
    const startExperienceTracker = t3;
    let t4;
    if ($[4] !== abortExperienceTracker || $[5] !== closeFlyout || $[6] !== fireClickAnalytics || $[7] !== isFlyoutOpen || $[8] !== openFlyout) {
        t4 = (newIsOpen)=>{
            if (!newIsOpen) {
                abortExperienceTracker();
                if (hasBeenOpenedBefore.current) fireClickAnalytics(false);
                isFlyoutOpen && closeFlyout();
            } else {
                openFlyout();
                hasBeenOpenedBefore.current = true;
            }
        };
        $[4] = abortExperienceTracker;
        $[5] = closeFlyout;
        $[6] = fireClickAnalytics;
        $[7] = isFlyoutOpen;
        $[8] = openFlyout;
        $[9] = t4;
    } else t4 = $[9];
    const onOpenChange = t4;
    let t5;
    if ($[10] !== fireClickAnalytics || $[11] !== isFlyoutOpen || $[12] !== isHidden || $[13] !== openFlyout || $[14] !== startExperienceTracker) {
        t5 = ()=>{
            if (!isFlyoutOpen) {
                fireClickAnalytics(true, true, isHidden);
                startExperienceTracker();
                openFlyout();
            }
        };
        $[10] = fireClickAnalytics;
        $[11] = isFlyoutOpen;
        $[12] = isHidden;
        $[13] = openFlyout;
        $[14] = startExperienceTracker;
        $[15] = t5;
    } else t5 = $[15];
    const onShortcutTriggered = t5;
    let t6;
    if ($[16] !== closeFlyout || $[17] !== fireClickAnalytics || $[18] !== isFlyoutOpen || $[19] !== openFlyout || $[20] !== startExperienceTracker) {
        t6 = ()=>{
            if (!isFlyoutOpen) {
                openFlyout();
                startExperienceTracker();
                fireClickAnalytics(true);
            } else closeFlyout();
        };
        $[16] = closeFlyout;
        $[17] = fireClickAnalytics;
        $[18] = isFlyoutOpen;
        $[19] = openFlyout;
        $[20] = startExperienceTracker;
        $[21] = t6;
    } else t6 = $[21];
    const onClick = t6;
    let t7;
    if ($[22] !== isFlyoutOpen) {
        t7 = ()=>{
            if (!isFlyoutOpen) {
                $d78d93494cd6b93d$export$17b89e6a36c6b530.preload();
                (0, $eLFsG.preloadStarredContentMenu)();
            }
        };
        $[22] = isFlyoutOpen;
        $[23] = t7;
    } else t7 = $[23];
    const onHover = t7;
    const isSelected = (0, $dPJCf.useRouteUrl)($d78d93494cd6b93d$var$isOnStarredRoute);
    const shouldHide = (0, $3bf409fa34ce0763$export$27f33b8cbd60853b)($d78d93494cd6b93d$var$MENU_ID, isSelected || isFlyoutOpen, isHidden, peekingId, setPeekingId);
    if (shouldHide) return null;
    const t8 = !(isLiveEditMode || isOnEditRoute) ? (0, $gnkil.GO_TO_STARRED_SHORTCUT) : undefined;
    let t9;
    if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $1LksZ.i18n).starred);
        $[24] = t9;
    } else t9 = $[24];
    let t10;
    if ($[25] !== isSelected || $[26] !== onClick) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $j3gDz.FlyoutMenuItemTrigger), {
            elemBefore: (0, $cxU8R.StarIconComponent),
            onClick: onClick,
            isSelected: isSelected
        }, t9);
        $[25] = isSelected;
        $[26] = onClick;
        $[27] = t10;
    } else t10 = $[27];
    let t11;
    if ($[28] !== closeFlyout || $[29] !== isFlyoutOpen) {
        t11 = ()=>isFlyoutOpen && closeFlyout();
        $[28] = closeFlyout;
        $[29] = isFlyoutOpen;
        $[30] = t11;
    } else t11 = $[30];
    let t12;
    if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d78d93494cd6b93d$export$17b89e6a36c6b530, null);
        $[31] = t12;
    } else t12 = $[31];
    let t13;
    if ($[32] !== t11) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $g5d7N.FlyoutMenuItemContent), {
            onClose: t11,
            autoFocus: false
        }, t12);
        $[32] = t11;
        $[33] = t13;
    } else t13 = $[33];
    let t14;
    if ($[34] !== isFlyoutOpen || $[35] !== onOpenChange || $[36] !== t10 || $[37] !== t13) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $NlNUL.FlyoutMenuItem), {
            onOpenChange: onOpenChange,
            isOpen: isFlyoutOpen
        }, t10, t13);
        $[34] = isFlyoutOpen;
        $[35] = onOpenChange;
        $[36] = t10;
        $[37] = t13;
        $[38] = t14;
    } else t14 = $[38];
    let t15;
    if ($[39] !== onHover || $[40] !== t14) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            onMouseEnter: onHover,
            onFocus: onHover
        }, t14);
        $[39] = onHover;
        $[40] = t14;
        $[41] = t15;
    } else t15 = $[41];
    let t16;
    if ($[42] !== onShortcutTriggered || $[43] !== t15 || $[44] !== t8) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aKkeT.KeyboardShortcutWrapper), {
            deprecatedKeyboardShortcut: t8,
            keyboardShortcut: (0, $gnkil.UNIVERSAL_GO_TO_STARRED_SHORTCUT),
            isAppNavigationShortcut: true,
            onShortcutTriggered: onShortcutTriggered
        }, t15);
        $[42] = onShortcutTriggered;
        $[43] = t15;
        $[44] = t8;
        $[45] = t16;
    } else t16 = $[45];
    return t16;
};
const $d78d93494cd6b93d$var$isOnStarredRoute = {
    selector: (routeUrl)=>routeUrl === (0, $1NBp8.HOME).toUrl({
            view: 'starred'
        })
};



























var $5WLjq = parcelRequire("5WLjq");

















var $2QHO0 = parcelRequire("2QHO0");


const $cfadde74afe3d902$export$68470bf7ec67edb4 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "KNvxq",
    name: "SpacesDropdown",
    loader: async ()=>(await (parcelRequire("eHV9G"))).SpacesDropdown
});

const $cfadde74afe3d902$export$91338486f2063670 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "HMmAB",
    name: "SpacesDropdownLoader",
    loader: async ()=>(await (parcelRequire("eHV9G"))).SpacesDropdown,
    loading: (0, $2QHO0.LoadingState)
});






























const $b163ca06b80c33e1$var$MENU_ID = 'spaces';

const $b163ca06b80c33e1$var$useLazyClickAnalytics = (0, $epLE5.createLazyCallbackHook)(async ()=>(await (parcelRequire("bfhzz"))).fireSpacesClickedAnalytics);
const $b163ca06b80c33e1$export$e60b35895fc7fef7 = (t0)=>{
    const $ = (0, $frIzR.c)(38);
    const { isHidden: isHidden, peekingId: peekingId, setPeekingId: setPeekingId } = t0;
    const { isFlyoutOpen: isFlyoutOpen, openFlyout: openFlyout, closeFlyout: closeFlyout } = (0, $6adZX.useFlyout)($b163ca06b80c33e1$var$MENU_ID);
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const selectedSpaceKey = spaceKey;
    const { isLicensed: isLicensed } = (0, $bQm3c.useSessionData)();
    const isMounted = (0, $42omo.useRef)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const fireClickAnalytics = $b163ca06b80c33e1$var$useLazyClickAnalytics(createAnalyticsEvent, routeDataRef);
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    let t1;
    if ($[0] !== experienceTracker) {
        t1 = ()=>{
            experienceTracker.abort({
                name: (0, $irVI7.APP_NAV_SPACES_DROPDOWN_EXPERIENCE),
                reason: "Primary dropdown menu: closed by user",
                attributes: {
                    navVersion: "4",
                    dropdownType: "spaces"
                }
            });
        };
        $[0] = experienceTracker;
        $[1] = t1;
    } else t1 = $[1];
    const abortExperienceTracker = t1;
    let t2;
    if ($[2] !== experienceTracker) {
        t2 = ()=>{
            experienceTracker.start({
                name: (0, $irVI7.APP_NAV_SPACES_DROPDOWN_EXPERIENCE),
                timeout: (0, $aJPUt.ExperienceTimeout).NAVIGATION_LOAD,
                attributes: {
                    navVersion: "4",
                    dropdownType: "spaces"
                }
            });
        };
        $[2] = experienceTracker;
        $[3] = t2;
    } else t2 = $[3];
    const startExperienceTracker = t2;
    let t3;
    if ($[4] !== abortExperienceTracker || $[5] !== closeFlyout || $[6] !== fireClickAnalytics || $[7] !== isFlyoutOpen || $[8] !== openFlyout) {
        t3 = (newIsOpen)=>{
            if (!isMounted.current) {
                isMounted.current = true;
                return;
            }
            if (!newIsOpen) {
                abortExperienceTracker();
                fireClickAnalytics(false);
                isFlyoutOpen && closeFlyout();
            } else openFlyout();
        };
        $[4] = abortExperienceTracker;
        $[5] = closeFlyout;
        $[6] = fireClickAnalytics;
        $[7] = isFlyoutOpen;
        $[8] = openFlyout;
        $[9] = t3;
    } else t3 = $[9];
    const onOpenChange = t3;
    let t4;
    if ($[10] !== closeFlyout || $[11] !== fireClickAnalytics || $[12] !== isFlyoutOpen || $[13] !== openFlyout || $[14] !== startExperienceTracker) {
        t4 = ()=>{
            if (!isFlyoutOpen) {
                openFlyout();
                startExperienceTracker();
                fireClickAnalytics(true);
            } else closeFlyout();
        };
        $[10] = closeFlyout;
        $[11] = fireClickAnalytics;
        $[12] = isFlyoutOpen;
        $[13] = openFlyout;
        $[14] = startExperienceTracker;
        $[15] = t4;
    } else t4 = $[15];
    const onClick = t4;
    let t5;
    if ($[16] !== isFlyoutOpen || $[17] !== isLicensed || $[18] !== selectedSpaceKey) {
        t5 = ()=>{
            if (!isFlyoutOpen) {
                (0, $cfadde74afe3d902$export$91338486f2063670).preload();
                if (selectedSpaceKey) (0, $5WLjq.preloadSpacesList)({
                    isLicensed: isLicensed,
                    selectedSpaceKey: selectedSpaceKey
                });
            }
        };
        $[16] = isFlyoutOpen;
        $[17] = isLicensed;
        $[18] = selectedSpaceKey;
        $[19] = t5;
    } else t5 = $[19];
    const onMouseEnter = t5;
    const isSelected = (0, $dPJCf.useRouteName)($b163ca06b80c33e1$var$isOnSpacesRoute);
    const shouldHide = (0, $3bf409fa34ce0763$export$27f33b8cbd60853b)($b163ca06b80c33e1$var$MENU_ID, isSelected || isFlyoutOpen, isHidden, peekingId, setPeekingId);
    if (shouldHide) return null;
    let t6;
    if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $1LksZ.i18n).spaces);
        $[20] = t6;
    } else t6 = $[20];
    let t7;
    if ($[21] !== isSelected || $[22] !== onClick) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $j3gDz.FlyoutMenuItemTrigger), {
            elemBefore: (0, $6mKj3.expVal)("confluence_space_icon_update", "isEnabled", false) ? (0, $cxU8R.SpacesIconComponent) : (0, $cxU8R.GlobeIconComponent),
            onClick: onClick,
            isSelected: isSelected
        }, t6);
        $[21] = isSelected;
        $[22] = onClick;
        $[23] = t7;
    } else t7 = $[23];
    let t8;
    if ($[24] !== closeFlyout || $[25] !== isFlyoutOpen) {
        t8 = ()=>isFlyoutOpen && closeFlyout();
        $[24] = closeFlyout;
        $[25] = isFlyoutOpen;
        $[26] = t8;
    } else t8 = $[26];
    let t9;
    if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = (0, $9wGTI.fg)("platform_dst_nav4_flyout_menu_slots_close_button") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cfadde74afe3d902$export$91338486f2063670), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $b163ca06b80c33e1$var$fixFocus
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cfadde74afe3d902$export$91338486f2063670), null));
        $[27] = t9;
    } else t9 = $[27];
    let t10;
    if ($[28] !== t8) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $g5d7N.FlyoutMenuItemContent), {
            onClose: t8,
            autoFocus: false
        }, t9);
        $[28] = t8;
        $[29] = t10;
    } else t10 = $[29];
    let t11;
    if ($[30] !== isFlyoutOpen || $[31] !== onOpenChange || $[32] !== t10 || $[33] !== t7) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $NlNUL.FlyoutMenuItem), {
            onOpenChange: onOpenChange,
            isOpen: isFlyoutOpen
        }, t7, t10);
        $[30] = isFlyoutOpen;
        $[31] = onOpenChange;
        $[32] = t10;
        $[33] = t7;
        $[34] = t11;
    } else t11 = $[34];
    let t12;
    if ($[35] !== onMouseEnter || $[36] !== t11) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            onMouseEnter: onMouseEnter,
            onFocus: onMouseEnter
        }, t11));
        $[35] = onMouseEnter;
        $[36] = t11;
        $[37] = t12;
    } else t12 = $[37];
    return t12;
};
const $b163ca06b80c33e1$var$fixFocus = (0, $ecnYn.xcss)({
    //@ts-expect-error styling is applying but property does not exist for SafeCSSObject
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    a: {
        ':focus-visible': {
            outlineOffset: `${"var(--ds-space-negative-025, -2px)"}`
        }
    }
});
const $b163ca06b80c33e1$var$isOnSpacesRoute = {
    selector: (routeName)=>routeName === (0, $1NBp8.SPACE_DIRECTORY).name
};












var $QU6QS = parcelRequire("QU6QS");





var $1CdLs = parcelRequire("1CdLs");

var $YQCfa = parcelRequire("YQCfa");

var $8INvs = parcelRequire("8INvs");























var $3b6WO = parcelRequire("3b6WO");






























var $kpYGL = parcelRequire("kpYGL");


var $aGrg7 = parcelRequire("aGrg7");
















var $7p8VW = parcelRequire("7p8VW");

var $c8gOp = parcelRequire("c8gOp");








var $9fBoq = parcelRequire("9fBoq");








var $5tgcI = parcelRequire("5tgcI");


var $g0ob9 = parcelRequire("g0ob9");





const $f16994fe41446773$var$AsyncDiscoverSection = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "ABCqb",
    name: "AsyncDiscoverSection",
    loader: async ()=>(await (parcelRequire("2yoLO"))).DiscoverSection
});
const $f16994fe41446773$var$DISCOVER_URL = `${(0, $jlIaF.CONTEXT_PATH)}/marketplace`;
const $f16994fe41446773$export$a8ebc8242442c256 = (t0)=>{
    const $ = (0, $frIzR.c)(27);
    const { loading: loading, webItems: webItems, extensions: extensions } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    let t1;
    if ($[0] !== createAnalyticsEvent) {
        t1 = (itemId)=>()=>{
                createAnalyticsEvent({
                    type: "sendUIEvent",
                    data: {
                        action: "clicked",
                        actionSubject: "navigationItem",
                        actionSubjectId: "appsNavigationMenuItem",
                        source: "globalNavigation",
                        attributes: {
                            navigationLayer: "global",
                            navigationContainer: "sidebar",
                            navVersion: "4",
                            componentType: "customItem",
                            itemType: "app",
                            itemId: itemId,
                            section: "yourApps"
                        }
                    }
                }).fire();
            };
        $[0] = createAnalyticsEvent;
        $[1] = t1;
    } else t1 = $[1];
    const fireAppsNavigationItemClicked = t1;
    const location = (0, $QU6QS.useLocation)();
    const hasApps = webItems.length > 0 || extensions.length > 0;
    const displayApps = hasApps && !loading;
    let t2;
    if ($[2] !== displayApps) {
        t2 = displayApps && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c8gOp.MenuSectionHeading), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $f16994fe41446773$var$i18n.yourApps));
        $[2] = displayApps;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== displayApps || $[5] !== extensions || $[6] !== fireAppsNavigationItemClicked || $[7] !== location?.pathname || $[8] !== webItems) {
        t3 = displayApps && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f16994fe41446773$var$AppItems, {
            webItems: webItems,
            extensions: extensions,
            pathname: location?.pathname || "",
            fireAppsNavigationItemClicked: fireAppsNavigationItemClicked
        });
        $[4] = displayApps;
        $[5] = extensions;
        $[6] = fireAppsNavigationItemClicked;
        $[7] = location?.pathname;
        $[8] = webItems;
        $[9] = t3;
    } else t3 = $[9];
    let t4;
    if ($[10] !== loading) {
        t4 = loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f16994fe41446773$var$LoadingSkeletons, null);
        $[10] = loading;
        $[11] = t4;
    } else t4 = $[11];
    let t5;
    if ($[12] !== t3 || $[13] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iKHTh.MenuList), null, t3, t4);
        $[12] = t3;
        $[13] = t4;
        $[14] = t5;
    } else t5 = $[14];
    let t6;
    if ($[15] !== t2 || $[16] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7p8VW.MenuSection), null, t2, t5);
        $[15] = t2;
        $[16] = t5;
        $[17] = t6;
    } else t6 = $[17];
    let t7;
    if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = (0, $9wGTI.fg)("confluence_nav_4_apps_menu_recommend") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f16994fe41446773$var$AsyncDiscoverSection, null);
        $[18] = t7;
    } else t7 = $[18];
    let t8;
    if ($[19] !== fireAppsNavigationItemClicked || $[20] !== hasApps || $[21] !== loading || $[22] !== location?.pathname) {
        t8 = (0, $5spQU.isFeatureEnabled)("adminhub", "adminhub-apps-discovery") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7p8VW.MenuSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iKHTh.MenuList), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9x2sR.LinkMenuItem), {
            isSelected: location?.pathname?.includes($f16994fe41446773$var$DISCOVER_URL),
            href: $f16994fe41446773$var$DISCOVER_URL,
            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aGrg7))), {
                label: "",
                color: "currentColor"
            }),
            onClick: fireAppsNavigationItemClicked("exploreApps")
        }, loading || hasApps ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $f16994fe41446773$var$i18n.exploreMoreApps) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $f16994fe41446773$var$i18n.exploreApps))));
        $[19] = fireAppsNavigationItemClicked;
        $[20] = hasApps;
        $[21] = loading;
        $[22] = location?.pathname;
        $[23] = t8;
    } else t8 = $[23];
    let t9;
    if ($[24] !== t6 || $[25] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t6, t7, t8);
        $[24] = t6;
        $[25] = t8;
        $[26] = t9;
    } else t9 = $[26];
    return t9;
};
const $f16994fe41446773$var$AppItems = (t0)=>{
    const $ = (0, $frIzR.c)(17);
    const { webItems: webItems, extensions: extensions, pathname: pathname, fireAppsNavigationItemClicked: fireAppsNavigationItemClicked } = t0;
    const intl = (0, $aXWIB.useIntl)();
    let t1;
    if ($[0] !== fireAppsNavigationItemClicked || $[1] !== intl || $[2] !== pathname || $[3] !== webItems) {
        let t2;
        if ($[5] !== fireAppsNavigationItemClicked || $[6] !== intl || $[7] !== pathname) {
            t2 = (t3)=>{
                const { id: id, url: url, label: label, icon: icon, completeKey: completeKey, styleClass: styleClass } = t3;
                const title = completeKey === (0, $5tgcI.ANALYTICS_KEY) && (0, $6mKj3.expValEquals)("ccpi_move_analytics_side_nav_item_label_to_fe", "isEnabled", true) ? intl.formatMessage($f16994fe41446773$var$i18n.analyticsTitle) : label;
                const href = $f16994fe41446773$var$fixWebItemUrl(url, completeKey);
                const injectStyleClass = (element)=>{
                    if (element === null) return;
                    if (typeof styleClass !== "string" || styleClass.length === 0) return;
                    const classList = styleClass.split(" ");
                    element.classList.add(...classList);
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9x2sR.LinkMenuItem), {
                    key: id,
                    ref: injectStyleClass,
                    href: href,
                    elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $g0ob9.AppIcon), {
                        url: icon?.path,
                        completeKey: completeKey
                    }),
                    isSelected: $f16994fe41446773$var$getIsSelected(pathname, href),
                    onClick: fireAppsNavigationItemClicked(completeKey)
                }, title);
            };
            $[5] = fireAppsNavigationItemClicked;
            $[6] = intl;
            $[7] = pathname;
            $[8] = t2;
        } else t2 = $[8];
        t1 = webItems.map(t2);
        $[0] = fireAppsNavigationItemClicked;
        $[1] = intl;
        $[2] = pathname;
        $[3] = webItems;
        $[4] = t1;
    } else t1 = $[4];
    let t2;
    if ($[9] !== extensions || $[10] !== pathname) {
        let t3;
        if ($[12] !== pathname) {
            t3 = (extension)=>{
                const href_0 = (0, $1NBp8.GLOBAL_PAGE_FORGE).toUrl({
                    appId: extension.appId,
                    envId: extension.environmentId,
                    forgeManifestRoute: extension.properties.route
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9x2sR.LinkMenuItem), {
                    key: extension.key,
                    href: href_0,
                    isSelected: $f16994fe41446773$var$getIsSelected(pathname, href_0),
                    elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $g0ob9.AppIcon), {
                        url: extension.properties.icon
                    })
                }, (0, $9fBoq.extensionTitle)(extension));
            };
            $[12] = pathname;
            $[13] = t3;
        } else t3 = $[13];
        t2 = extensions.map(t3);
        $[9] = extensions;
        $[10] = pathname;
        $[11] = t2;
    } else t2 = $[11];
    let t3;
    if ($[14] !== t1 || $[15] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t1, t2);
        $[14] = t1;
        $[15] = t2;
        $[16] = t3;
    } else t3 = $[16];
    return t3;
};
const $f16994fe41446773$var$LoadingSkeletons = ()=>{
    const $ = (0, $frIzR.c)(1);
    const skeletonBorderRadius = (0, $9wGTI.fg)("confluence_frontend_tokenize_border") ? "var(--ds-radius-small, 4px)" : "3px";
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            paddingBlockStart: "space.100",
            testId: "loading"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
            width: "100%",
            height: "20px",
            borderRadius: skeletonBorderRadius
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
            width: "100%",
            height: "20px",
            borderRadius: skeletonBorderRadius
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
            width: "100%",
            height: "20px",
            borderRadius: skeletonBorderRadius
        })));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
};
const $f16994fe41446773$var$absoluteUrlCheck = new RegExp('^(?:[a-z]+:)?//', 'i');
const $f16994fe41446773$var$fixWebItemUrl = (url, completeKey)=>{
    if (!url) return '#';
    if (completeKey === (0, $5tgcI.ANALYTICS_KEY) || completeKey === (0, $5tgcI.ANALYTICS_KEY_MODERATE)) return (0, $1NBp8.SITE_ANALYTICS).toUrl();
    if ($f16994fe41446773$var$absoluteUrlCheck.test(url)) return url;
    if (url.startsWith((0, $jlIaF.CONTEXT_PATH))) return url;
    return `${0, $jlIaF.CONTEXT_PATH}${url}`;
};
const $f16994fe41446773$var$getIsSelected = (pathname, href)=>{
    const hrefWithoutQuery = href.split('?')[0];
    return pathname === hrefWithoutQuery;
};
const $f16994fe41446773$var$i18n = (0, $aXWIB.defineMessages)({
    yourApps: {
        id: "side-navigation.global.apps.your-apps",
        defaultMessage: "Your apps"
    },
    exploreApps: {
        id: "side-navigation.global.apps.explore-apps",
        defaultMessage: "Explore apps"
    },
    exploreMoreApps: {
        id: "side-navigation.global.apps.explore-more-apps",
        defaultMessage: "Explore more apps"
    },
    analyticsTitle: {
        id: "side-navigation.global.apps.analytics.label",
        defaultMessage: "Analytics"
    }
});












var $9VJDA = parcelRequire("9VJDA");





var $1qfLF = parcelRequire("1qfLF");


var $lGgRw = parcelRequire("lGgRw");


var $cGtPE = parcelRequire("cGtPE");

var $2SlZp = parcelRequire("2SlZp");














const $b1f880ba7abf8fa5$var$useLazyClickMoreActionsAnalytics = (0, $epLE5.createLazyCallbackHook)(async ()=>(await (parcelRequire("h8IEo"))).fireAppsMoreActionsButtonClicked);

const $b1f880ba7abf8fa5$var$useLazyClickMoreActionsItemAnalytics = (0, $epLE5.createLazyCallbackHook)(async ()=>(await (parcelRequire("h8IEo"))).fireAppsMoreActionsDropdownItemClicked);
const $b1f880ba7abf8fa5$export$a70b62f9ab9df290 = ()=>{
    const $ = (0, $frIzR.c)(8);
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const fireClickMoreActionsAnalytics = $b1f880ba7abf8fa5$var$useLazyClickMoreActionsAnalytics(createAnalyticsEvent);
    let t0;
    if ($[0] !== fireClickMoreActionsAnalytics) {
        t0 = ()=>{
            setIsOpen($b1f880ba7abf8fa5$var$_temp);
            fireClickMoreActionsAnalytics();
        };
        $[0] = fireClickMoreActionsAnalytics;
        $[1] = t0;
    } else t0 = $[1];
    const onClick = t0;
    let t1;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>setIsOpen(false);
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== onClick) {
        t2 = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
                icon: $b1f880ba7abf8fa5$var$_temp3,
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $b1f880ba7abf8fa5$var$i18n.moreActions),
                onClick: onClick,
                spacing: "compact",
                appearance: "subtle",
                ...triggerProps
            });
        $[3] = onClick;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== isOpen || $[6] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lGgRw.default), {
            isOpen: isOpen,
            onClose: t1,
            content: $b1f880ba7abf8fa5$var$_temp2,
            trigger: t2,
            placement: "bottom-start",
            shouldRenderToParent: true
        });
        $[5] = isOpen;
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
};
const $b1f880ba7abf8fa5$var$AppsMoreActionsMenuContent = ()=>{
    const $ = (0, $frIzR.c)(13);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { environment: environment, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const fireClickMoreActionsItemManageAppsAnalytics = $b1f880ba7abf8fa5$var$useLazyClickMoreActionsItemAnalytics(createAnalyticsEvent, "manageApps");
    const fireClickMoreActionsItemAppAuditLogsAnalytics = $b1f880ba7abf8fa5$var$useLazyClickMoreActionsItemAnalytics(createAnalyticsEvent, "appAuditLogs");
    const fireClickMoreActionsItemViewAppRequestsAnalytics = $b1f880ba7abf8fa5$var$useLazyClickMoreActionsItemAnalytics(createAnalyticsEvent, "viewAppRequests");
    const adminHubBaseUrl = environment == "PRODUCTION" ? "https://admin.atlassian.com" : "https://admin.stg.atlassian.com";
    const adminHubAppRequestsUrl = `${adminHubBaseUrl}/s/${cloudId}/user-connected-apps/tab/requested`;
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $1NBp8.DEFAULT_ADMIN_MANAGE_APPS).toUrl();
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $b1f880ba7abf8fa5$var$i18n.manageApps);
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== fireClickMoreActionsItemManageAppsAnalytics) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cGtPE.default), {
            href: t0,
            target: "_blank",
            onClick: fireClickMoreActionsItemManageAppsAnalytics
        }, t1);
        $[2] = fireClickMoreActionsItemManageAppsAnalytics;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== fireClickMoreActionsItemAppAuditLogsAnalytics) {
        t3 = (0, $9wGTI.fg)("show_app_audit_logs_upm_dep") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cGtPE.default), {
            href: (0, $1NBp8.ADMIN_APP_AUDIT_LOGS).toUrl(),
            target: "_blank",
            onClick: fireClickMoreActionsItemAppAuditLogsAnalytics
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $b1f880ba7abf8fa5$var$i18n.appAuditLogs));
        $[4] = fireClickMoreActionsItemAppAuditLogsAnalytics;
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] !== adminHubAppRequestsUrl || $[7] !== fireClickMoreActionsItemViewAppRequestsAnalytics) {
        t4 = (0, $9wGTI.fg)("confluence_frontend_enduser-emcee-discover") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cGtPE.default), {
            href: (0, $9wGTI.fg)("should_redirect_to_admin-hub_for_app_requests") ? adminHubAppRequestsUrl : (0, $1NBp8.MARKETPLACE_APP_REQUESTS).toUrl(),
            target: "_blank",
            onClick: fireClickMoreActionsItemViewAppRequestsAnalytics
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $b1f880ba7abf8fa5$var$i18n.viewAppRequests));
        $[6] = adminHubAppRequestsUrl;
        $[7] = fireClickMoreActionsItemViewAppRequestsAnalytics;
        $[8] = t4;
    } else t4 = $[8];
    let t5;
    if ($[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2SlZp.default), null, t2, t3, t4);
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
};
const $b1f880ba7abf8fa5$var$i18n = (0, $aXWIB.defineMessages)({
    moreActions: {
        id: "side-navigation.global.apps.more-actions",
        defaultMessage: "More actions"
    },
    manageApps: {
        id: "side-navigation.global.apps.manage-apps",
        defaultMessage: "Manage apps"
    },
    appAuditLogs: {
        id: "side-navigation.global.apps.app-audit-log",
        defaultMessage: "App audit logs"
    },
    viewAppRequests: {
        id: "side-navigation.global.apps.view-app-requests",
        defaultMessage: "View app requests"
    }
});
function $b1f880ba7abf8fa5$var$_temp(v) {
    return !v;
}
function $b1f880ba7abf8fa5$var$_temp2() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b1f880ba7abf8fa5$var$AppsMoreActionsMenuContent, null);
}
function $b1f880ba7abf8fa5$var$_temp3(iconProps) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))), {
        ...iconProps,
        size: "small"
    });
}



var $8dUjs = parcelRequire("8dUjs");


const $9b893ee6ed889345$var$useLazyClickAnalytics = (0, $epLE5.createLazyCallbackHook)(async ()=>(await (parcelRequire("bfhzz"))).fireAppsClickedAnalytics);
const $9b893ee6ed889345$export$4c83861e794746b0 = (t0)=>{
    const $ = (0, $frIzR.c)(33);
    const { isHidden: isHidden, peekingId: peekingId, setPeekingId: setPeekingId } = t0;
    const { edition: edition, accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const isAdmin = accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS;
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const fireClickAnalytics = $9b893ee6ed889345$var$useLazyClickAnalytics(createAnalyticsEvent, routeDataRef);
    let t1;
    if ($[0] !== accessStatus || $[1] !== edition) {
        t1 = (0, $8dUjs.getGlobalAppsParams)({
            edition: edition,
            accessStatus: accessStatus
        });
        $[0] = accessStatus;
        $[1] = edition;
        $[2] = t1;
    } else t1 = $[2];
    const { webItemParams: webItemParams, forgeExtensionParams: forgeExtensionParams } = t1;
    const { webItems: webItems, loading: webItemsLoading, error: webItemsError } = (0, $6ld6a.useWebItemLocation)(webItemParams);
    const { extensions: extensions, loading: extensionsLoading, error: extensionsError } = (0, $3b6WO.useExtensionList)(forgeExtensionParams);
    let t2;
    if ($[3] !== webItems) {
        t2 = webItems.map($9b893ee6ed889345$var$_temp);
        $[3] = webItems;
        $[4] = t2;
    } else t2 = $[4];
    const webItemUrls = t2;
    let t3;
    if ($[5] !== extensions) {
        t3 = extensions.map($9b893ee6ed889345$var$_temp2);
        $[5] = extensions;
        $[6] = t3;
    } else t3 = $[6];
    const extensionsUrls = t3;
    const location = (0, $QU6QS.useLocation)();
    let t4;
    if ($[7] !== extensionsUrls || $[8] !== location?.pathname || $[9] !== webItemUrls) {
        t4 = {
            selector: (routeUrl)=>{
                const path = routeUrl || location?.pathname;
                return webItemUrls.some((appUrl_0)=>path.includes(appUrl_0)) || extensionsUrls.some((appUrl)=>path.includes(appUrl)) || path.includes(`${(0, $jlIaF.CONTEXT_PATH)}/marketplace`);
            }
        };
        $[7] = extensionsUrls;
        $[8] = location?.pathname;
        $[9] = webItemUrls;
        $[10] = t4;
    } else t4 = $[10];
    const isOnAppsRoute = (0, $dPJCf.useRouteUrl)(t4);
    const loading = webItemsLoading || extensionsLoading;
    const shouldHide = (0, $3bf409fa34ce0763$export$27f33b8cbd60853b)("apps", isOnAppsRoute, isHidden, peekingId, setPeekingId);
    if (shouldHide) return null;
    let t5;
    if ($[11] !== fireClickAnalytics) {
        t5 = (_, __, analyticsAttributes)=>{
            const { isExpanded: isExpanded } = analyticsAttributes;
            fireClickAnalytics(isExpanded);
        };
        $[11] = fireClickAnalytics;
        $[12] = t5;
    } else t5 = $[12];
    const onClick = t5;
    let t6;
    if ($[13] !== isAdmin) {
        t6 = isAdmin && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b1f880ba7abf8fa5$export$a70b62f9ab9df290), null);
        $[13] = isAdmin;
        $[14] = t6;
    } else t6 = $[14];
    let t7;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $1LksZ.i18n).apps);
        $[15] = t7;
    } else t7 = $[15];
    let t8;
    if ($[16] !== onClick || $[17] !== t6) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8INvs.ExpandableMenuItemTrigger), {
            elemBefore: (0, $cxU8R.AppsIconComponent),
            actionsOnHover: t6,
            onClick: onClick
        }, t7);
        $[16] = onClick;
        $[17] = t6;
        $[18] = t8;
    } else t8 = $[18];
    let t9;
    if ($[19] !== extensions || $[20] !== loading || $[21] !== webItems) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $YQCfa.ExpandableMenuItemContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f16994fe41446773$export$a8ebc8242442c256), {
            loading: loading,
            webItems: webItems,
            extensions: extensions
        }));
        $[19] = extensions;
        $[20] = loading;
        $[21] = webItems;
        $[22] = t9;
    } else t9 = $[22];
    let t10;
    if ($[23] !== isOnAppsRoute || $[24] !== t8 || $[25] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1CdLs.ExpandableMenuItem), {
            isDefaultExpanded: isOnAppsRoute
        }, t8, t9);
        $[23] = isOnAppsRoute;
        $[24] = t8;
        $[25] = t9;
        $[26] = t10;
    } else t10 = $[26];
    let t11;
    if ($[27] !== extensionsError || $[28] !== webItemsError) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($9b893ee6ed889345$var$ErrorFlag, {
            webItemsError: webItemsError,
            extensionsError: extensionsError
        });
        $[27] = extensionsError;
        $[28] = webItemsError;
        $[29] = t11;
    } else t11 = $[29];
    let t12;
    if ($[30] !== t10 || $[31] !== t11) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t10, t11);
        $[30] = t10;
        $[31] = t11;
        $[32] = t12;
    } else t12 = $[32];
    return t12;
};
const $9b893ee6ed889345$var$ErrorFlag = (0, $7aRa9.withFlags)(({ webItemsError: webItemsError, extensionsError: extensionsError, flags: flags })=>{
    (0, $42omo.useEffect)(()=>{
        if (webItemsError || extensionsError) flags.showFlag({
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $9b893ee6ed889345$var$errorI18n.errorTitle),
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $9b893ee6ed889345$var$errorI18n.errorDescription),
            type: 'error',
            close: 'auto'
        });
    }, [
        webItemsError,
        extensionsError,
        flags
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, webItemsError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: webItemsError
    }), extensionsError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: extensionsError
    }));
});
const $9b893ee6ed889345$var$errorI18n = (0, $aXWIB.defineMessages)({
    errorTitle: {
        id: "side-navigation.global.apps.error-title",
        defaultMessage: "We couldn\u2019t load apps"
    },
    errorDescription: {
        id: "side-navigation.global.apps.error-description",
        defaultMessage: "Refresh and try again."
    }
});
function $9b893ee6ed889345$var$_temp(webItem) {
    return (webItem.url || "").split("?")[0];
}
function $9b893ee6ed889345$var$_temp2(extension) {
    return (0, $1NBp8.GLOBAL_PAGE_FORGE).toUrl({
        appId: extension.appId,
        envId: extension.environmentId,
        forgeManifestRoute: extension.properties.route
    });
}





















const $7313825a48cf91f9$export$67e928cbe0262396 = (t0)=>{
    const $ = (0, $frIzR.c)(1);
    const { isHidden: isHidden, peekingId: peekingId, setPeekingId: setPeekingId } = t0;
    const shouldHide = (0, $3bf409fa34ce0763$export$27f33b8cbd60853b)("topics", false, isHidden, peekingId, setPeekingId);
    if (shouldHide) return null;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9x2sR.LinkMenuItem), {
            href: "#",
            elemBefore: (0, $cxU8R.HashIconComponent)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $1LksZ.i18n).topics));
        $[0] = t1;
    } else t1 = $[0];
    return t1;
};





















const $d18e4b06ef32e11b$export$cb6e506fa0abf530 = (t0)=>{
    const $ = (0, $frIzR.c)(1);
    const { isHidden: isHidden, peekingId: peekingId, setPeekingId: setPeekingId } = t0;
    const shouldHide = (0, $3bf409fa34ce0763$export$27f33b8cbd60853b)("goals", false, isHidden, peekingId, setPeekingId);
    if (shouldHide) return null;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9x2sR.LinkMenuItem), {
            href: "#",
            elemBefore: (0, $cxU8R.GoalIconComponent)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $1LksZ.i18n).goals));
        $[0] = t1;
    } else t1 = $[0];
    return t1;
};


































const $12bdfaacd20fcb4d$var$useLazyClickAnalytics = (0, $epLE5.createLazyCallbackHook)(async ()=>(await (parcelRequire("bfhzz"))).fireTeamsClickedAnalytics);
const $12bdfaacd20fcb4d$var$isOnPeopleRouteArgs = {
    selector: (routeName)=>{
        if (!routeName) return false;
        return routeName === (0, $1NBp8.PEOPLE_DIRECTORY).name;
    }
};
const $12bdfaacd20fcb4d$export$31c02f8c1cc69561 = (t0)=>{
    const $ = (0, $frIzR.c)(5);
    const { isHidden: isHidden, peekingId: peekingId, setPeekingId: setPeekingId } = t0;
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const isSelected = (0, $dPJCf.useRouteName)($12bdfaacd20fcb4d$var$isOnPeopleRouteArgs);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const fireClickedAnalytics = $12bdfaacd20fcb4d$var$useLazyClickAnalytics(createAnalyticsEvent, routeDataRef);
    const shouldHide = (0, $3bf409fa34ce0763$export$27f33b8cbd60853b)("teams", isSelected, isHidden, peekingId, setPeekingId);
    if (shouldHide) return null;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $1NBp8.CONFLUENCE_PEOPLE_DIRECTORY_SEARCH).toUrl();
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $1LksZ.i18n).teams);
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== fireClickedAnalytics || $[3] !== isSelected) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9x2sR.LinkMenuItem), {
            href: t1,
            isSelected: isSelected,
            elemBefore: (0, $cxU8R.TeamsIconComponent),
            onClick: fireClickedAnalytics
        }, t2);
        $[2] = fireClickedAnalytics;
        $[3] = isSelected;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
};


































const $b246fff4221da373$var$useLazyClickAnalytics = (0, $epLE5.createLazyCallbackHook)(async ()=>(await (parcelRequire("bfhzz"))).fireDraftsClickedAnalytics);
const $b246fff4221da373$var$onDraftSelector = {
    selector: (routeUrl)=>{
        if (!routeUrl) return false;
        return routeUrl === (0, $1NBp8.HOME).toUrl({
            view: 'drafts'
        });
    }
};
const $b246fff4221da373$export$cf67e987117d08e0 = (t0)=>{
    const $ = (0, $frIzR.c)(6);
    const { isHidden: isHidden, peekingId: peekingId, setPeekingId: setPeekingId } = t0;
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const fireClickAnalytics = $b246fff4221da373$var$useLazyClickAnalytics(createAnalyticsEvent, routeDataRef);
    const isSelected = (0, $dPJCf.useRouteUrl)($b246fff4221da373$var$onDraftSelector);
    const shouldHide = (0, $3bf409fa34ce0763$export$27f33b8cbd60853b)("drafts", isSelected, isHidden, peekingId, setPeekingId);
    if (shouldHide) return null;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $1NBp8.HOME).toUrl({
            view: "drafts"
        });
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $1LksZ.i18n).drafts);
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== fireClickAnalytics || $[3] !== isSelected || $[4] !== t1) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9x2sR.LinkMenuItem), {
            href: t1,
            elemBefore: (0, $cxU8R.EditIconComponent),
            isSelected: isSelected,
            onClick: fireClickAnalytics
        }, t2);
        $[2] = fireClickAnalytics;
        $[3] = isSelected;
        $[4] = t1;
        $[5] = t3;
    } else t3 = $[5];
    return t3;
};


































const $708853e8a76c69ca$var$useLazyClickAnalytics = (0, $epLE5.createLazyCallbackHook)(async ()=>(await (parcelRequire("bfhzz"))).fireTasksClickedAnalytics);
const $708853e8a76c69ca$var$onTasksSelector = {
    selector: (routeUrl)=>{
        if (!routeUrl) return false;
        return routeUrl === (0, $1NBp8.HOME).toUrl({
            view: 'tasks'
        });
    }
};
const $708853e8a76c69ca$export$a0a057c2941dc0bc = (t0)=>{
    const $ = (0, $frIzR.c)(6);
    const { isHidden: isHidden, peekingId: peekingId, setPeekingId: setPeekingId } = t0;
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const fireClickAnalytics = $708853e8a76c69ca$var$useLazyClickAnalytics(createAnalyticsEvent, routeDataRef);
    const isSelected = (0, $dPJCf.useRouteUrl)($708853e8a76c69ca$var$onTasksSelector);
    const shouldHide = (0, $3bf409fa34ce0763$export$27f33b8cbd60853b)("tasks", isSelected, isHidden, peekingId, setPeekingId);
    if (shouldHide) return null;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $1NBp8.HOME).toUrl({
            view: "tasks"
        });
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $1LksZ.i18n).tasks);
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== fireClickAnalytics || $[3] !== isSelected || $[4] !== t1) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9x2sR.LinkMenuItem), {
            href: t1,
            elemBefore: (0, $cxU8R.TaskIconComponent),
            isSelected: isSelected,
            onClick: fireClickAnalytics
        }, t2);
        $[2] = fireClickAnalytics;
        $[3] = isSelected;
        $[4] = t1;
        $[5] = t3;
    } else t3 = $[5];
    return t3;
};


































const $6f20c917496dda1e$var$useLazyClickAnalytics = (0, $epLE5.createLazyCallbackHook)(async ()=>(await (parcelRequire("bfhzz"))).fireTemplatesClickedAnalytics);
const $6f20c917496dda1e$var$isOnTemplatesSelector = {
    selector: (routeUrl)=>{
        if (!routeUrl) return false;
        return routeUrl.includes((0, $1NBp8.TEMPLATE_GALLERY).toUrl()); //templates adds a bunch of query components
    }
};
const $6f20c917496dda1e$export$9e7802a7d1db8cfc = (t0)=>{
    const $ = (0, $frIzR.c)(5);
    const { isHidden: isHidden, peekingId: peekingId, setPeekingId: setPeekingId } = t0;
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const fireClickAnalytics = $6f20c917496dda1e$var$useLazyClickAnalytics(createAnalyticsEvent, routeDataRef);
    const isSelected = (0, $dPJCf.useRouteUrl)($6f20c917496dda1e$var$isOnTemplatesSelector);
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $1NBp8.TEMPLATE_GALLERY).toUrl();
        $[0] = t1;
    } else t1 = $[0];
    const templateUrl = t1;
    const shouldHide = (0, $3bf409fa34ce0763$export$27f33b8cbd60853b)("templates", isSelected, isHidden, peekingId, setPeekingId);
    if (shouldHide) return null;
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $1LksZ.i18n).templates);
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== fireClickAnalytics || $[3] !== isSelected) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9x2sR.LinkMenuItem), {
            href: templateUrl,
            elemBefore: (0, $cxU8R.TemplatesIconComponent),
            isSelected: isSelected,
            onClick: fireClickAnalytics
        }, t2);
        $[2] = fireClickAnalytics;
        $[3] = isSelected;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
};































const $95245a9bd03c7ad9$var$useLazyClickAnalytics = (0, $epLE5.createLazyCallbackHook)(async ()=>(await (parcelRequire("bfhzz"))).fireCustomizeSidebarClickedAnalytics);
const $95245a9bd03c7ad9$export$249a65f26e2bc7f5 = (t0)=>{
    const $ = (0, $frIzR.c)(6);
    const { isHidden: isHidden, peekingId: peekingId, setPeekingId: setPeekingId, setIsCustomizeSidebarDialogVisible: setIsCustomizeSidebarDialogVisible } = t0;
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const fireClickAnalytics = $95245a9bd03c7ad9$var$useLazyClickAnalytics(createAnalyticsEvent, routeDataRef);
    let t1;
    if ($[0] !== fireClickAnalytics || $[1] !== setIsCustomizeSidebarDialogVisible) {
        t1 = ()=>{
            setIsCustomizeSidebarDialogVisible(true);
            fireClickAnalytics();
        };
        $[0] = fireClickAnalytics;
        $[1] = setIsCustomizeSidebarDialogVisible;
        $[2] = t1;
    } else t1 = $[2];
    const onClick = t1;
    const shouldHide = (0, $3bf409fa34ce0763$export$27f33b8cbd60853b)("customize", false, isHidden, peekingId, setPeekingId);
    if (shouldHide) return null;
    let t2;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $1LksZ.i18n).customize);
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== onClick) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jh864.ButtonMenuItem), {
            elemBefore: (0, $cxU8R.CustomizeIconComponent),
            onClick: onClick
        }, t2);
        $[4] = onClick;
        $[5] = t3;
    } else t3 = $[5];
    return t3;
};






const $19a89177b077740c$export$d6688983e7eca068 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "SqNIQ",
    name: "TeamsAppShortcutLoader",
    loader: async ()=>(await (parcelRequire("gJfOY"))).TeamsAppShortcutItem
});






var $hcKPT = parcelRequire("hcKPT");

const $ddfb598ef229bd1a$export$7bd12ce5959bde45 = (t0)=>{
    const $ = (0, $frIzR.c)(3);
    const { shortcutsConfig: shortcutsConfig, customizationMenuConfig: customizationMenuConfig, children: children } = t0;
    const orderedShortcuts = (0, $hcKPT.useOrderedAppShortcuts)(shortcutsConfig, customizationMenuConfig);
    let t1;
    if ($[0] !== children || $[1] !== orderedShortcuts) {
        t1 = children({
            shortcuts: orderedShortcuts
        });
        $[0] = children;
        $[1] = orderedShortcuts;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
};


const $7b79f828379224e7$var$RemovedSpotlightTarget = (0, $bedQP.componentWithFG)('remove_unused_spotlight_targets', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children), ({ name: name, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5izcQ.default), {
        name: name
    }, children));

const $7b79f828379224e7$var$CustomizationModalLoader = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "Vj9xc",
    name: "CustomizationModalLoader",
    loader: async ()=>{
        const { CustomizationModalComponent: CustomizationModalComponent } = await (parcelRequire("1PYmG"));
        return CustomizationModalComponent;
    }
});
const $7b79f828379224e7$export$311d3c02bd72bcc0 = 'confluence.sidebar.';

const $7b79f828379224e7$var$useLazyClickAnalytics = (0, $epLE5.createLazyCallbackHook)(async ()=>(await (parcelRequire("bfhzz"))).fireMoreMenuClickedAnalytics);
const $7b79f828379224e7$var$hasAccess = (accessStatus)=>![
        (0, $d9tcB.AccessStatus).ANONYMOUS_ACCESS,
        (0, $d9tcB.AccessStatus).UNLICENSED_AUTHENTICATED_ACCESS,
        null
    ].includes(accessStatus);
const $7b79f828379224e7$var$hasGlobalAppShortcutsAccess = (accessStatus)=>![
        (0, $d9tcB.AccessStatus).ANONYMOUS_ACCESS,
        (0, $d9tcB.AccessStatus).EXTERNAL_SHARE_ACCESS,
        (0, $d9tcB.AccessStatus).EXTERNAL_COLLABORATOR_ACCESS,
        (0, $d9tcB.AccessStatus).NOT_PERMITTED,
        null
    ].includes(accessStatus);
const $7b79f828379224e7$var$GlobalItemComponents = {
    customHome: (0, $15140e42b692bfde$export$adaf351fc9d12cd2),
    yourWork: (0, $b9c6e796d679cd96$export$d16f83425c70386f),
    companyHub: (0, $8dN99.CompanyHubItem),
    recent: (0, $43bbe423a7434a33$export$f1cccf52bb5faf3f),
    starred: (0, $d78d93494cd6b93d$export$d11aa717bebc8f86),
    spaces: (0, $b163ca06b80c33e1$export$e60b35895fc7fef7),
    apps: (0, $9b893ee6ed889345$export$4c83861e794746b0),
    goals: (0, $d18e4b06ef32e11b$export$cb6e506fa0abf530),
    topics: (0, $7313825a48cf91f9$export$67e928cbe0262396),
    teams: (0, $12bdfaacd20fcb4d$export$31c02f8c1cc69561),
    drafts: (0, $b246fff4221da373$export$cf67e987117d08e0),
    tasks: (0, $708853e8a76c69ca$export$a0a057c2941dc0bc),
    templates: (0, $6f20c917496dda1e$export$9e7802a7d1db8cfc),
    customize: (0, $95245a9bd03c7ad9$export$249a65f26e2bc7f5)
};
const $7b79f828379224e7$export$f83d6aa785dd4970 = ({ productSideNavigation: productSideNavigation, isOnAnySettingsScreen: isOnAnySettingsScreen, isCollapsed: isCollapsed })=>{
    const { accessStatus: accessStatus, cloudId: cloudId, userId: userId, activationId: activationId } = (0, $bQm3c.useSessionData)();
    const [peekingId, setPeekingId] = (0, $42omo.useState)(undefined);
    const [isMoreMenuOpen, setIsMoreMenuOpen] = (0, $42omo.useState)(false);
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const fireClickAnalytics = $7b79f828379224e7$var$useLazyClickAnalytics(createAnalyticsEvent, routeDataRef);
    const { openFlyout: openFlyout, closeFlyout: closeFlyout } = (0, $6adZX.useFlyoutActions)();
    const transitionId = (0, $dPJCf.useTransitionId)();
    const teamsAppEnabled = (0, $5XsiK.isTeamsAppEnabled)();
    const [getFilteredProductLinks, setGetFilteredProductLinks] = (0, $42omo.useState)(undefined);
    const [isCustomizeSidebarDialogVisible, setIsCustomizeSidebarDialogVisible] = (0, $42omo.useState)(false);
    const jiraShortcut = (0, $12t1c.useJira)('');
    const invitedAppShortcutsExperiment = (0, $fPgmM.useResolveInvitedAppShortcuts)();
    const isEligibleToSeeInvitedAppShortcuts = (0, $42omo.useMemo)(()=>// we split the kill-switch gate and targeting gate to avoid the overrides precedence issue
        // eslint-disable-next-line confluence-feature-gating/no-preconditioning
        (0, $9wGTI.fg)('twcg-460-personalised-invite-notifications-m2-gate') && invitedAppShortcutsExperiment.ineligibilityReason === null && invitedAppShortcutsExperiment.invitedApps?.jira?.eligible === true, [
        invitedAppShortcutsExperiment
    ]);
    (0, $42omo.useEffect)(()=>{
        if (transitionId && transitionId > 0) //on any transition close open flyout. On initial Load transitionId = 0
        closeFlyout();
    }, [
        closeFlyout,
        transitionId
    ]);
    const { setHasOpenedCustomize: setHasOpenedCustomize } = (0, $4bc89b0e707470fb$export$9168e89189b336b6)();
    const { data: data, error: error } = (0, $jMyy4.useQueryInterop)($7b79f828379224e7$var$GlobalNavigationComponentQuery, {
        client: (0, $gKr8t.getAGGClient)(),
        variables: {
            entityAri: (0, $hHhbz.ConfluenceWorkspaceAri).create({
                siteId: cloudId,
                activationId: activationId
            }).toString(),
            ownerAri: userId ? (0, $gHaxX.IdentityUserAri).create({
                userId: userId
            }).toString() : ''
        },
        skip: !userId || !activationId
    });
    const platformCustomizations = (0, $42omo.useMemo)(()=>{
        if (data?.settings_navigationCustomisation?.sidebar?.nodes) return data.settings_navigationCustomisation.sidebar.nodes.filter((node)=>node != null).map((node_0)=>({
                menuId: node_0.menuId?.replace($7b79f828379224e7$export$311d3c02bd72bcc0, ''),
                visible: Boolean(node_0.visible)
            }));
        return [];
    }, [
        data
    ]);
    const { platformCustomizationsWithSimplifyNav: platformCustomizationsWithSimplifyNav, navStyle: navStyle, isWithinD0: isWithinD0 } = (0, $12338c25dd8aaf48$export$2471979fb08e1cdf)(platformCustomizations);
    //only show customization and fetch data if we meet these conditions
    const showCustomization = !!activationId && $7b79f828379224e7$var$hasAccess(accessStatus);
    // only render global app shortcuts if we meet these conditions
    const showGlobalAppShortcuts = $7b79f828379224e7$var$hasGlobalAppShortcutsAccess(accessStatus);
    const { globalMenuItems: globalMenuItems, moreMenuItems: moreMenuItems, appShortcutMenuItems: appShortcutMenuItems, allMenuItems: allMenuItems } = (0, $5cb9965cd3125e0a$export$aad046bd9909db8f)(showCustomization, accessStatus, platformCustomizationsWithSimplifyNav, getFilteredProductLinks);
    const { shouldShowSpotlight: shouldShowSpotlight, shouldPersistCustomizeOpen: shouldPersistCustomizeOpen } = (0, $02947314900d85ba$export$79c4a1ca811bb387)({
        globalMenuItems: globalMenuItems,
        navStyle: navStyle,
        isWithinD0: isWithinD0
    });
    const moreMenuOnClickCallback = (0, $42omo.useCallback)((menuId)=>{
        setIsMoreMenuOpen(!isMoreMenuOpen);
        // TODO: it would be great if we could refactor the following menu-specific logic into the respective menu components
        if (menuId === 'customize') {
            setIsCustomizeSidebarDialogVisible(true);
            // Persist for treatment users with Recent in main nav (includes D0) — so D0 users who open customize don't see spotlight when they become D1+
            if (shouldPersistCustomizeOpen) setHasOpenedCustomize();
            fireClickAnalytics('customiseSidebar');
        } else fireClickAnalytics(menuId);
        if (menuId === 'recent' || menuId === 'starred' || menuId === 'spaces') {
            openFlyout(menuId);
            setPeekingId(menuId);
        }
        if (menuId === 'apps') push('/wiki/marketplace/discover');
    }, [
        fireClickAnalytics,
        isMoreMenuOpen,
        openFlyout,
        push,
        setHasOpenedCustomize,
        shouldPersistCustomizeOpen
    ]);
    const visibleMenuIds = (0, $42omo.useMemo)(()=>{
        return appShortcutMenuItems.reduce((acc, item)=>item.visible ? [
                ...acc,
                item.menuId
            ] : acc, []);
    }, [
        appShortcutMenuItems
    ]);
    const isInvitedAppShortcutsEnabled = (0, $42omo.useMemo)(()=>isEligibleToSeeInvitedAppShortcuts && (0, $6mKj3.expVal)('twcg-460-personalised-invite-notifications-m2', 'isEnabled', false), [
        isEligibleToSeeInvitedAppShortcuts
    ]);
    const invitedAppShortcutsConfig = (0, $42omo.useMemo)(()=>{
        if (!isInvitedAppShortcutsEnabled) return {};
        return {
            jira: jiraShortcut
        };
    }, [
        isInvitedAppShortcutsEnabled,
        jiraShortcut
    ]);
    const { invitedAppProductLinks: invitedAppProductLinks, handleUpdateInvitedAppProductLinks: handleUpdateInvitedAppProductLinks } = (0, $87dae69a81f59d82$export$f96c96985b06f150)({
        shortcutItemsConfig: invitedAppShortcutsConfig,
        getCachedProductLinks: invitedAppShortcutsExperiment.getCachedProductLinks,
        updateHydratedProductLinks: invitedAppShortcutsExperiment.updateHydratedProductLinks
    });
    (0, $42omo.useEffect)(()=>{
        if (getFilteredProductLinks && (0, $9wGTI.fg)('twcg-460-personalised-invite-notifications-m2-gate')) invitedAppShortcutsExperiment.updateFromAppAccessFilter({
            getFilteredProductLinks: getFilteredProductLinks,
            limitToOnlyApsKeys: [
                'JIRA_SOFTWARE'
            ],
            visibleMenuIds: visibleMenuIds
        });
    }, [
        appShortcutMenuItems,
        getFilteredProductLinks,
        invitedAppShortcutsExperiment,
        visibleMenuIds
    ]);
    // The visible app shortcuts:
    // "Company Hub" is the first and only app shortcut at the time of this writing so the naming and abstraction here are as simple as possible.
    let companyHubAppShortcut = null;
    // The item "Customize sidebar" when it's one of the visible global items and app shortcuts:
    let globalCustomizeMenuItem = null;
    const moreMenuItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6bf303f52478ae0b$export$e967513bbeba0537), {
        moreMenuItems: moreMenuItems,
        isOpen: isMoreMenuOpen,
        onClick: moreMenuOnClickCallback,
        toggleMenu: ()=>setIsMoreMenuOpen(!isMoreMenuOpen),
        peekingId: peekingId,
        isCollapsed: isCollapsed
    });
    (0, $42omo.useEffect)(()=>{
        if (isEligibleToSeeInvitedAppShortcuts) invitedAppShortcutsExperiment.fireFeatureExposed({
            isEnabled: (0, $6mKj3.expVal)('twcg-460-personalised-invite-notifications-m2', 'isEnabled', false)
        });
    }, [
        isEligibleToSeeInvitedAppShortcuts,
        invitedAppShortcutsExperiment
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7b79f828379224e7$var$RemovedSpotlightTarget, {
        name: "nav4-spotlight-0"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iKHTh.MenuList), null, !isOnAnySettingsScreen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5izcQ.default), {
        name: "enhance-orientation-spotlight-tour-target-3"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-vc": "nav4-globalItems"
    }, globalMenuItems.map(({ menuId: menuId_0 })=>{
        const Component = $7b79f828379224e7$var$GlobalItemComponents[menuId_0];
        let node_1 = null;
        if (Component) {
            const baseNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Component, {
                key: menuId_0,
                setIsCustomizeSidebarDialogVisible: setIsCustomizeSidebarDialogVisible
            });
            // Spotlight anchored to Recent when in main nav (ACTIVATION-2059).
            // Always render the wrapper and pass `shouldShowSpotlight`; when not eligible,
            // the wrapper returns only the Recent item with no spotlight UI.
            node_1 = menuId_0 === 'recent' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e8cb5a3d9666ba33$export$bbe775696798290c), {
                key: menuId_0,
                shouldShowSpotlight: shouldShowSpotlight
            }, baseNode) : baseNode;
            // All global items stay together and all app shortcuts stay together, they are separate groups.
            // I.e. the app shortcuts should be after a peeking global item (if any).
            // This is the render of the global items section so skip the app shortcuts (of which there is only Company Hub at Team '25 US) here and render them later.
            if (menuId_0 === 'companyHub') {
                companyHubAppShortcut = node_1;
                return null;
            } else if (menuId_0 === 'customize') {
                // The item "Customize sidebar" should be:
                // - after the app shortcuts if any;
                // - visually divided from the preceeding global items or app shortcuts.
                globalCustomizeMenuItem = node_1;
                return null;
            }
        }
        return node_1;
    }), // we split the kill-switch gate and targeting gate to avoid the overrides precedence issue
    // eslint-disable-next-line confluence-feature-gating/no-preconditioning
    isInvitedAppShortcutsEnabled && showGlobalAppShortcuts && (0, $9wGTI.fg)('nav4_global_links_confluence') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ikOWI.InvitedAppShortcutsContainer), {
        shortcutsConfig: invitedAppShortcutsConfig,
        resolverResult: invitedAppShortcutsExperiment
    }, ({ referrableShortcuts: referrableShortcuts })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ddfb598ef229bd1a$export$7bd12ce5959bde45), {
            shortcutsConfig: referrableShortcuts,
            customizationMenuConfig: platformCustomizationsWithSimplifyNav
        }, ({ shortcuts: shortcuts })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $167cc3f1dc82a812$export$4519a9392cf3004e), {
                shortcutItems: shortcuts,
                product: "confluence",
                invitedAppProductLinks: invitedAppProductLinks
            }))), moreMenuItems.map((result)=>{
        const Component_0 = $7b79f828379224e7$var$GlobalItemComponents[result.menuId];
        return Component_0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Component_0, {
            key: result.menuId,
            isHidden: true,
            peekingId: peekingId,
            setPeekingId: setPeekingId,
            setIsCustomizeSidebarDialogVisible: setIsCustomizeSidebarDialogVisible
        });
    }), companyHubAppShortcut && !(0, $9wGTI.fg)('nav4_global_links_confluence') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fufCn.TopLevelSpacer), null), companyHubAppShortcut), teamsAppEnabled && !(0, $9wGTI.fg)('nav4_global_links_confluence') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, !companyHubAppShortcut && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fufCn.TopLevelSpacer), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $19a89177b077740c$export$d6688983e7eca068), null)), globalCustomizeMenuItem && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fufCn.TopLevelSpacer), null), globalCustomizeMenuItem), showCustomization && !(0, $9wGTI.fg)('nav4_global_links_confluence') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, (companyHubAppShortcut || teamsAppEnabled) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fufCn.TopLevelSpacer), null), moreMenuItem, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fufCn.TopLevelSpacer), null)), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    }), isCustomizeSidebarDialogVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7b79f828379224e7$var$CustomizationModalLoader, {
        onClose: ()=>setIsCustomizeSidebarDialogVisible(false),
        productItemsData: allMenuItems,
        appItemsData: (0, $9wGTI.fg)('nav4_global_links_confluence') ? appShortcutMenuItems : [],
        navigationCustomisationId: data?.settings_navigationCustomisation?.id || ''
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2VQ4B.PageSegmentLoadEnd), {
        metric: (0, $1uFsv.GLOBAL_NAVIGATION_METRIC)
    }))), (0, $9wGTI.fg)('nav4_global_links_confluence') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fufCn.TopLevelSpacer), null)), productSideNavigation, !isOnAnySettingsScreen && showGlobalAppShortcuts && (0, $9wGTI.fg)('nav4_global_links_confluence') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iKHTh.MenuList), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fufCn.TopLevelSpacer), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $56093378b3ff8f83$export$ab2ae7fe36e2ecef), {
        orderedMenuConfig: platformCustomizationsWithSimplifyNav,
        onUpdateGetFilteredProductLinks: (fn)=>{
            setGetFilteredProductLinks(()=>fn);
            handleUpdateInvitedAppProductLinks(fn);
        },
        isInvitedAppShortcutsEnabled: isInvitedAppShortcutsEnabled
    }), moreMenuItem));
};
const $7b79f828379224e7$export$94a5e0cf2e657dff = (variables, nodes, id)=>{
    (0, $fEmGS.writeQueryInterop)({
        query: $7b79f828379224e7$var$GlobalNavigationComponentQuery,
        variables: variables,
        data: {
            settings_navigationCustomisation: {
                __typename: 'SettingsNavigationCustomisation',
                id: id,
                sidebar: {
                    __typename: 'SettingsMenuItemConnection',
                    nodes: nodes
                }
            }
        }
    });
};
const $7b79f828379224e7$var$GlobalNavigationComponentQuery = (0, $hPkGG.default);
module.exports["PLATFORM_MENU_ID_PREFIX"] = $7b79f828379224e7$export$311d3c02bd72bcc0;
module.exports["GlobalNavigationComponent"] = $7b79f828379224e7$export$f83d6aa785dd4970;
module.exports["updateNavigationCustomization"] = $7b79f828379224e7$export$94a5e0cf2e657dff;

});

parcelRegister("hPkGG", function(module, exports) {
/**
 * @generated SignedSource<<38a548b3f605de659a28f52a35e18b64>>
 * @relayHash ee5a91706bc8d2c36266138f1556fa8e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7f7a8c5a405e165722f55d2fb38fba615d09b5f4c08ede00a7a9fe5741f08c7a
const $62aeb16db236e807$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "entityAri"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "ownerAri"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "entityAri",
                    "variableName": "entityAri"
                },
                {
                    "kind": "Variable",
                    "name": "ownerAri",
                    "variableName": "ownerAri"
                }
            ],
            "concreteType": "SettingsNavigationCustomisation",
            "kind": "LinkedField",
            "name": "settings_navigationCustomisation",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "SettingsMenuItemConnection",
                    "kind": "LinkedField",
                    "name": "sidebar",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "SettingsMenuItem",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "menuId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "visible"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "GlobalNavigationComponentQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "GlobalNavigationComponentQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "ee5a91706bc8d2c36266138f1556fa8e",
            "id": "7f7a8c5a405e165722f55d2fb38fba615d09b5f4c08ede00a7a9fe5741f08c7a",
            "metadata": {},
            "name": "GlobalNavigationComponentQuery",
            "operationKind": "query",
            "text": "query GlobalNavigationComponentQuery($entityAri:ID!,$ownerAri:ID!){settings_navigationCustomisation(entityAri:$entityAri,ownerAri:$ownerAri){id,sidebar{nodes{menuId,visible}}}}"
        }
    };
}();
$62aeb16db236e807$var$node.hash = "0e74e77d53a00c9095e60ae7930a7cf3";
var $62aeb16db236e807$export$2e2bcd8739ae039 = $62aeb16db236e807$var$node;
module.exports["default"] = $62aeb16db236e807$export$2e2bcd8739ae039;

});

parcelRegister("iKHTh", function(module, exports) {

var $aJT7b = parcelRequire("aJT7b");

const $19720d3977b4df3f$export$d4c4e98c5044dc8 = (0, $aJT7b.List);
module.exports["MenuList"] = $19720d3977b4df3f$export$d4c4e98c5044dc8;

});

parcelRegister("aJT7b", function(module, exports) {
/* list.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

function $002d225363d96747$var$_List({ children: children, testId: testId, xcss: xcss }, forwardedRef) {
    return(/**
     * We are using `role="list"` instead of a `ul` element to enable more flexible
     * composition. By using ARIA roles we can validly have elements between a list
     * and list items, as long as those in-between elements have no semantics.
     */ /*#__PURE__*/ (0, $l998X.jsx)("div", {
        role: "list",
        ref: forwardedRef,
        className: xcss,
        "data-testid": testId,
        children: children
    }));
}
const $002d225363d96747$export$54c2e3dc7acea9f5 = /*#__PURE__*/ (0, $42omo.forwardRef)($002d225363d96747$var$_List);
module.exports["List"] = $002d225363d96747$export$54c2e3dc7acea9f5;

});

parcelRegister("hHhbz", function(module, exports) {

var $5O1YC = parcelRequire("5O1YC");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/confluence/workspace/manifest.ts
var $ce23c8815c812c15$var$confluenceWorkspaceAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $5O1YC.ConfluenceWorkspaceAriResourceOwner),
    resourceType: (0, $5O1YC.ConfluenceWorkspaceAriResourceType),
    resourceIdSlug: "{activationId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/
    }
};
// src/confluence/workspace/index.ts
var $ce23c8815c812c15$export$d47d8a7e69df1865 = class _ConfluenceWorkspaceAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $ce23c8815c812c15$var$confluenceWorkspaceAriStaticOpts.qualifier,
            platformQualifier: $ce23c8815c812c15$var$confluenceWorkspaceAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $ce23c8815c812c15$var$confluenceWorkspaceAriStaticOpts.resourceOwner,
            resourceType: $ce23c8815c812c15$var$confluenceWorkspaceAriStaticOpts.resourceType,
            resourceId: `${opts.activationId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $ce23c8815c812c15$var$confluenceWorkspaceAriStaticOpts);
        return new _ConfluenceWorkspaceAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $ce23c8815c812c15$var$confluenceWorkspaceAriStaticOpts);
        return new _ConfluenceWorkspaceAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId;
    }
};
module.exports["ConfluenceWorkspaceAri"] = $ce23c8815c812c15$export$d47d8a7e69df1865;

});

parcelRegister("5O1YC", function(module, exports) {
// src/confluence/workspace/types.ts
var $43a327cfc847ac6c$export$19f1a63686ec0369 = "confluence", $43a327cfc847ac6c$export$f1c423a93fbc71 = "workspace";
module.exports["ConfluenceWorkspaceAriResourceOwner"] = $43a327cfc847ac6c$export$19f1a63686ec0369;
module.exports["ConfluenceWorkspaceAriResourceType"] = $43a327cfc847ac6c$export$f1c423a93fbc71;

});

parcelRegister("6adZX", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $059c9f3c8066ba5d$var$initialState = {
    openFlyoutId: null
};
const $059c9f3c8066ba5d$export$3d79379112bcd772 = (0, $1P1Tu.createStore)({
    name: 'FlyoutStore',
    initialState: $059c9f3c8066ba5d$var$initialState,
    actions: {
        openFlyout: (menuId)=>({ setState: setState })=>{
                setState({
                    openFlyoutId: menuId
                });
            },
        closeFlyout: (menuId = null)=>({ setState: setState, getState: getState })=>{
                if (!menuId || menuId === getState().openFlyoutId) setState({
                    openFlyoutId: null
                });
            }
    }
});
const $059c9f3c8066ba5d$export$377168f986312a4 = (0, $9zUhf.createHook)($059c9f3c8066ba5d$export$3d79379112bcd772, {
    selector: (state, menuId)=>state.openFlyoutId === menuId
});
const $059c9f3c8066ba5d$export$3f64b5809402b3ff = (menuId)=>{
    const [isFlyoutOpen, flyoutActions] = $059c9f3c8066ba5d$export$377168f986312a4(menuId);
    const openFlyout = (0, $42omo.useCallback)(()=>flyoutActions.openFlyout(menuId), [
        flyoutActions,
        menuId
    ]);
    const closeFlyout = (0, $42omo.useCallback)(()=>flyoutActions.closeFlyout(menuId), [
        flyoutActions,
        menuId
    ]);
    return {
        isFlyoutOpen: isFlyoutOpen,
        openFlyout: openFlyout,
        closeFlyout: closeFlyout
    };
};
const $059c9f3c8066ba5d$export$285f2f1642666795 = (0, $9zUhf.createActionsHook)($059c9f3c8066ba5d$export$3d79379112bcd772);
module.exports["useIsFlyoutOpen"] = $059c9f3c8066ba5d$export$377168f986312a4;
module.exports["useFlyout"] = $059c9f3c8066ba5d$export$3f64b5809402b3ff;
module.exports["useFlyoutActions"] = $059c9f3c8066ba5d$export$285f2f1642666795;

});

parcelRegister("41KFX", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $dBcar = parcelRequire("dBcar");


var $ivb8S = parcelRequire("ivb8S");


var $6Dfc9 = parcelRequire("6Dfc9");


var $879OR = parcelRequire("879OR");

const $73d6907ec9f8e642$export$fce5991a3cbd7c5a = new Set([
    'default-templates',
    'pin-templates'
]);
const $73d6907ec9f8e642$var$DEFAULT_RESULT = {
    navStyle: 'control',
    isWithinD0: false,
    source: null
};
function $73d6907ec9f8e642$export$9e39472fc9788dd0() {
    if ((0, $9wGTI.fg)('cfind_5565_creation_focused_nav_xflow_preload')) return [
        ...(0, $dBcar.NAV_EXPERIMENT_ONBOARDING_KEYS),
        (0, $dBcar.CFIND_5565_CREATION_FOCUSED_NAV_XFLOW).START_AT
    ];
    return [
        ...(0, $dBcar.NAV_EXPERIMENT_ONBOARDING_KEYS)
    ];
}
const $73d6907ec9f8e642$export$aed714501b2c585 = ()=>{
    const { data: onboardingStateData, loading: onboardingStateLoading, error: onboardingStateError } = (0, $ivb8S.useGetOnboardingState)($73d6907ec9f8e642$export$9e39472fc9788dd0(), !(0, $9wGTI.fg)('cc_activation_simplify_nav_preloader_enabled'));
    const { isEligible: isEligibleForSimplifyNavXflow, isLoading: isLoadingIsEligibleForSimplifyNavXflow, hasError: hasEligibleForSimplifyNavXflowError, isWithinD0Window: isWithinD0WindowForSimplifyNavXflow } = (0, $879OR.useIsEligibleForSimplifyNavXflow)({
        onboardingStateData: onboardingStateData,
        onboardingStateLoading: onboardingStateLoading,
        onboardingStateError: onboardingStateError,
        skip: !(0, $9wGTI.fg)('cfind_5565_creation_focused_nav_xflow_eligibility')
    });
    if (onboardingStateLoading) {
        if ((0, $9wGTI.fg)('cc_activation_simplify_nav_preloader_enabled')) return {
            navStyle: 'loading',
            isWithinD0: false,
            source: null
        };
        return $73d6907ec9f8e642$var$DEFAULT_RESULT;
    }
    if (onboardingStateError) return $73d6907ec9f8e642$var$DEFAULT_RESULT;
    const entries = onboardingStateData?.onboardingState;
    if (!entries) return $73d6907ec9f8e642$var$DEFAULT_RESULT;
    const eligibleEntry = entries.find((s)=>s.key === (0, $dBcar.SIMPLIFY_NAV_NEW_USER).NTH_USER_D0_SIMPLIFIED_NAV_ELIGIBLE);
    if (eligibleEntry?.value !== 'true') {
        // Not eligible for new user experiment, but might be for xflow.
        if (// eslint-disable-next-line confluence-feature-gating/no-preconditioning
        (0, $9wGTI.fg)('cfind_5565_creation_focused_nav_xflow_preload') && (0, $9wGTI.fg)('cfind_5565_creation_focused_nav_xflow_eligibility')) {
            if (isLoadingIsEligibleForSimplifyNavXflow) // This may happen if TAP traits are loading, although they should generally be preloaded.
            // Case of onboarding state loading is handled in previous conditionals.
            return {
                navStyle: 'loading',
                isWithinD0: false,
                source: null
            };
            if (hasEligibleForSimplifyNavXflowError) return $73d6907ec9f8e642$var$DEFAULT_RESULT;
            if (isEligibleForSimplifyNavXflow) {
                const navStyle = (0, $6mKj3.expVal)('cfind_5565_creation_focused_nav_xflow', 'cohort', 'control');
                if ($73d6907ec9f8e642$export$fce5991a3cbd7c5a.has(navStyle)) return {
                    navStyle: navStyle,
                    isWithinD0: isWithinD0WindowForSimplifyNavXflow,
                    source: 'xflow'
                };
            }
        }
        return $73d6907ec9f8e642$var$DEFAULT_RESULT;
    }
    const navStyle = (0, $6mKj3.expVal)('cc_activation_simplify_nav_new_user', 'cohort', 'control');
    if (!$73d6907ec9f8e642$export$fce5991a3cbd7c5a.has(navStyle)) return $73d6907ec9f8e642$var$DEFAULT_RESULT;
    const startAtEntry = entries.find((s)=>s.key === (0, $dBcar.SIMPLIFY_NAV_NEW_USER).NTH_USER_D0_SIMPLIFIED_NAV_START_AT);
    return {
        navStyle: navStyle,
        isWithinD0: (0, $6Dfc9.isWithinD0Window)(startAtEntry?.value),
        source: 'new-user'
    };
};
module.exports["TREATMENT_COHORTS"] = $73d6907ec9f8e642$export$fce5991a3cbd7c5a;
module.exports["useSimplifiedNavNewUsers"] = $73d6907ec9f8e642$export$aed714501b2c585;

});

parcelRegister("6Dfc9", function(module, exports) {

var $8uR5k = parcelRequire("8uR5k");

var $cFEpk = parcelRequire("cFEpk");

var $da71s = parcelRequire("da71s");

function $e250b9cfd6dd2931$export$46cbbdfdd4d2fcb(isoTimestamp) {
    if (!isoTimestamp) return false;
    const parsed = (0, $da71s.default)(isoTimestamp);
    return (0, $cFEpk.default)(parsed) && (0, $8uR5k.default)(new Date(), parsed) < 24;
}
function $e250b9cfd6dd2931$export$193a557a4d23c9aa(epochMs) {
    const date = new Date(epochMs);
    return (0, $cFEpk.default)(date) && (0, $8uR5k.default)(new Date(), date) < 24;
}
module.exports["isWithinD0Window"] = $e250b9cfd6dd2931$export$46cbbdfdd4d2fcb;

});

parcelRegister("8uR5k", function(module, exports) {
$parcel$export(module.exports, "default", () => $62fa4da7b1bddd96$export$2e2bcd8739ae039);

var $jx0NF = parcelRequire("jx0NF");


var $62guz = parcelRequire("62guz");


var $b5utg = parcelRequire("b5utg");


var $fls5L = parcelRequire("fls5L");

function $62fa4da7b1bddd96$export$2e2bcd8739ae039(dateLeft, dateRight, options) {
    (0, $b5utg.default)(2, arguments);
    var diff = (0, $62guz.default)(dateLeft, dateRight) / (0, $jx0NF.millisecondsInHour);
    return (0, $fls5L.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

});

parcelRegister("jx0NF", function(module, exports) {
/**
 * Days in 1 week.
 *
 * @name daysInWeek
 * @constant
 * @type {number}
 * @default
 */ var $e381b83e7c88ee8c$export$dfd9b671c89acc8e = 7;
var $e381b83e7c88ee8c$export$3913210603d8e9ae = 365.2425;
var $e381b83e7c88ee8c$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
var $e381b83e7c88ee8c$export$91246f0b9bd9beff = 60000;
var $e381b83e7c88ee8c$export$7f72910d6dfd237a = 3600000;
var $e381b83e7c88ee8c$export$397c2d5776aa9055 = 1000;
var $e381b83e7c88ee8c$export$4dec998e48f9c246 = -$e381b83e7c88ee8c$export$81caae6e1cc7a622;
var $e381b83e7c88ee8c$export$f2f5ae5a8e2d8f9f = 60;
var $e381b83e7c88ee8c$export$3c58128db900d44e = 3;
var $e381b83e7c88ee8c$export$80d7e435f744f319 = 12;
var $e381b83e7c88ee8c$export$4db7641526e3241f = 4;
var $e381b83e7c88ee8c$export$698aec755e92c695 = 3600;
var $e381b83e7c88ee8c$export$a77c1a7ebebe2a5a = 60;
var $e381b83e7c88ee8c$export$815a9362476d2fe3 = $e381b83e7c88ee8c$export$698aec755e92c695 * 24;
var $e381b83e7c88ee8c$export$34804a017b31e2fe = $e381b83e7c88ee8c$export$815a9362476d2fe3 * 7;
var $e381b83e7c88ee8c$export$7271e9e3478110d1 = $e381b83e7c88ee8c$export$815a9362476d2fe3 * $e381b83e7c88ee8c$export$3913210603d8e9ae;
var $e381b83e7c88ee8c$export$8e6600bbdee7dabb = $e381b83e7c88ee8c$export$7271e9e3478110d1 / 12;
var $e381b83e7c88ee8c$export$be1dccf2de902d31 = $e381b83e7c88ee8c$export$8e6600bbdee7dabb * 3;
module.exports["millisecondsInMinute"] = $e381b83e7c88ee8c$export$91246f0b9bd9beff;
module.exports["millisecondsInHour"] = $e381b83e7c88ee8c$export$7f72910d6dfd237a;
module.exports["millisecondsInSecond"] = $e381b83e7c88ee8c$export$397c2d5776aa9055;

});

parcelRegister("62guz", function(module, exports) {
$parcel$export(module.exports, "default", () => $464fb8f83176ac12$export$2e2bcd8739ae039);

var $egXhZ = parcelRequire("egXhZ");


var $b5utg = parcelRequire("b5utg");

function $464fb8f83176ac12$export$2e2bcd8739ae039(dateLeft, dateRight) {
    (0, $b5utg.default)(2, arguments);
    return (0, $egXhZ.default)(dateLeft).getTime() - (0, $egXhZ.default)(dateRight).getTime();
}

});

parcelRegister("fls5L", function(module, exports) {
var $b2be9bac2e487919$var$roundingMap = {
    ceil: Math.ceil,
    round: Math.round,
    floor: Math.floor,
    trunc: function trunc(value) {
        return value < 0 ? Math.ceil(value) : Math.floor(value);
    } // Math.trunc is not supported by IE
};
var $b2be9bac2e487919$var$defaultRoundingMethod = 'trunc';
function $b2be9bac2e487919$export$b6474a47258c1211(method) {
    return method ? $b2be9bac2e487919$var$roundingMap[method] : $b2be9bac2e487919$var$roundingMap[$b2be9bac2e487919$var$defaultRoundingMethod];
}
module.exports["getRoundingMethod"] = $b2be9bac2e487919$export$b6474a47258c1211;

});

parcelRegister("da71s", function(module, exports) {
$parcel$export(module.exports, "default", () => $9951a80eb1f73a12$export$2e2bcd8739ae039);

var $jx0NF = parcelRequire("jx0NF");


var $b5utg = parcelRequire("b5utg");


var $jZ39j = parcelRequire("jZ39j");

function $9951a80eb1f73a12$export$2e2bcd8739ae039(argument, options) {
    var _options$additionalDi;
    (0, $b5utg.default)(1, arguments);
    var additionalDigits = (0, $jZ39j.default)((_options$additionalDi = options === null || options === void 0 ? void 0 : options.additionalDigits) !== null && _options$additionalDi !== void 0 ? _options$additionalDi : 2);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
    if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
    var dateStrings = $9951a80eb1f73a12$var$splitDateString(argument);
    var date;
    if (dateStrings.date) {
        var parseYearResult = $9951a80eb1f73a12$var$parseYear(dateStrings.date, additionalDigits);
        date = $9951a80eb1f73a12$var$parseDate(parseYearResult.restDateString, parseYearResult.year);
    }
    if (!date || isNaN(date.getTime())) return new Date(NaN);
    var timestamp = date.getTime();
    var time = 0;
    var offset;
    if (dateStrings.time) {
        time = $9951a80eb1f73a12$var$parseTime(dateStrings.time);
        if (isNaN(time)) return new Date(NaN);
    }
    if (dateStrings.timezone) {
        offset = $9951a80eb1f73a12$var$parseTimezone(dateStrings.timezone);
        if (isNaN(offset)) return new Date(NaN);
    } else {
        var dirtyDate = new Date(timestamp + time);
        // js parsed string assuming it's in UTC timezone
        // but we need it to be parsed in our timezone
        // so we use utc values to build date in our timezone.
        // Year values from 0 to 99 map to the years 1900 to 1999
        // so set year explicitly with setFullYear.
        var result = new Date(0);
        result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
        result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
        return result;
    }
    return new Date(timestamp + time + offset);
}
var $9951a80eb1f73a12$var$patterns = {
    dateTimeDelimiter: /[T ]/,
    timeZoneDelimiter: /[Z ]/i,
    timezone: /([Z+-].*)$/
};
var $9951a80eb1f73a12$var$dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var $9951a80eb1f73a12$var$timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var $9951a80eb1f73a12$var$timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function $9951a80eb1f73a12$var$splitDateString(dateString) {
    var dateStrings = {};
    var array = dateString.split($9951a80eb1f73a12$var$patterns.dateTimeDelimiter);
    var timeString;
    // The regex match should only return at maximum two array elements.
    // [date], [time], or [date, time].
    if (array.length > 2) return dateStrings;
    if (/:/.test(array[0])) timeString = array[0];
    else {
        dateStrings.date = array[0];
        timeString = array[1];
        if ($9951a80eb1f73a12$var$patterns.timeZoneDelimiter.test(dateStrings.date)) {
            dateStrings.date = dateString.split($9951a80eb1f73a12$var$patterns.timeZoneDelimiter)[0];
            timeString = dateString.substr(dateStrings.date.length, dateString.length);
        }
    }
    if (timeString) {
        var token = $9951a80eb1f73a12$var$patterns.timezone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], '');
            dateStrings.timezone = token[1];
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $9951a80eb1f73a12$var$parseYear(dateString, additionalDigits) {
    var regex = new RegExp('^(?:(\\d{4}|[+-]\\d{' + (4 + additionalDigits) + '})|(\\d{2}|[+-]\\d{' + (2 + additionalDigits) + '})$)');
    var captures = dateString.match(regex);
    // Invalid ISO-formatted year
    if (!captures) return {
        year: NaN,
        restDateString: ''
    };
    var year = captures[1] ? parseInt(captures[1]) : null;
    var century = captures[2] ? parseInt(captures[2]) : null;
    // either year or century is null, not both
    return {
        year: century === null ? year : century * 100,
        restDateString: dateString.slice((captures[1] || captures[2]).length)
    };
}
function $9951a80eb1f73a12$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return new Date(NaN);
    var captures = dateString.match($9951a80eb1f73a12$var$dateRegex);
    // Invalid ISO-formatted string
    if (!captures) return new Date(NaN);
    var isWeekDate = !!captures[4];
    var dayOfYear = $9951a80eb1f73a12$var$parseDateUnit(captures[1]);
    var month = $9951a80eb1f73a12$var$parseDateUnit(captures[2]) - 1;
    var day = $9951a80eb1f73a12$var$parseDateUnit(captures[3]);
    var week = $9951a80eb1f73a12$var$parseDateUnit(captures[4]);
    var dayOfWeek = $9951a80eb1f73a12$var$parseDateUnit(captures[5]) - 1;
    if (isWeekDate) {
        if (!$9951a80eb1f73a12$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $9951a80eb1f73a12$var$dayOfISOWeekYear(year, week, dayOfWeek);
    } else {
        var date = new Date(0);
        if (!$9951a80eb1f73a12$var$validateDate(year, month, day) || !$9951a80eb1f73a12$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
        return date;
    }
}
function $9951a80eb1f73a12$var$parseDateUnit(value) {
    return value ? parseInt(value) : 1;
}
function $9951a80eb1f73a12$var$parseTime(timeString) {
    var captures = timeString.match($9951a80eb1f73a12$var$timeRegex);
    if (!captures) return NaN; // Invalid ISO-formatted time
    var hours = $9951a80eb1f73a12$var$parseTimeUnit(captures[1]);
    var minutes = $9951a80eb1f73a12$var$parseTimeUnit(captures[2]);
    var seconds = $9951a80eb1f73a12$var$parseTimeUnit(captures[3]);
    if (!$9951a80eb1f73a12$var$validateTime(hours, minutes, seconds)) return NaN;
    return hours * (0, $jx0NF.millisecondsInHour) + minutes * (0, $jx0NF.millisecondsInMinute) + seconds * 1000;
}
function $9951a80eb1f73a12$var$parseTimeUnit(value) {
    return value && parseFloat(value.replace(',', '.')) || 0;
}
function $9951a80eb1f73a12$var$parseTimezone(timezoneString) {
    if (timezoneString === 'Z') return 0;
    var captures = timezoneString.match($9951a80eb1f73a12$var$timezoneRegex);
    if (!captures) return 0;
    var sign = captures[1] === '+' ? -1 : 1;
    var hours = parseInt(captures[2]);
    var minutes = captures[3] && parseInt(captures[3]) || 0;
    if (!$9951a80eb1f73a12$var$validateTimezone(hours, minutes)) return NaN;
    return sign * (hours * (0, $jx0NF.millisecondsInHour) + minutes * (0, $jx0NF.millisecondsInMinute));
}
function $9951a80eb1f73a12$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
// February is null to handle the leap year (using ||)
var $9951a80eb1f73a12$var$daysInMonths = [
    31,
    null,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $9951a80eb1f73a12$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $9951a80eb1f73a12$var$validateDate(year, month, date) {
    return month >= 0 && month <= 11 && date >= 1 && date <= ($9951a80eb1f73a12$var$daysInMonths[month] || ($9951a80eb1f73a12$var$isLeapYearIndex(year) ? 29 : 28));
}
function $9951a80eb1f73a12$var$validateDayOfYearDate(year, dayOfYear) {
    return dayOfYear >= 1 && dayOfYear <= ($9951a80eb1f73a12$var$isLeapYearIndex(year) ? 366 : 365);
}
function $9951a80eb1f73a12$var$validateWeekDate(_year, week, day) {
    return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function $9951a80eb1f73a12$var$validateTime(hours, minutes, seconds) {
    if (hours === 24) return minutes === 0 && seconds === 0;
    return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function $9951a80eb1f73a12$var$validateTimezone(_hours, minutes) {
    return minutes >= 0 && minutes <= 59;
}

});

parcelRegister("879OR", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8uR5k = parcelRequire("8uR5k");


var $inPa6 = parcelRequire("inPa6");


var $9wGTI = parcelRequire("9wGTI");


var $bQm3c = parcelRequire("bQm3c");


var $f7MuR = parcelRequire("f7MuR");


var $kOUwv = parcelRequire("kOUwv");


var $dBcar = parcelRequire("dBcar");


var $ivb8S = parcelRequire("ivb8S");


var $1KHQh = parcelRequire("1KHQh");


var $6Dfc9 = parcelRequire("6Dfc9");

const $1f55678574e67c8a$var$CONFLUENCE_FIRST_ACTIVE_TRAIT = 'confluence_first_active';
const $1f55678574e67c8a$var$FIRST_ACTIVATION_DATE_TRAIT = 'firstActivationDate';
const $1f55678574e67c8a$export$bbe7d46982302b03 = ({ onboardingStateData: onboardingStateData, onboardingStateLoading: onboardingStateLoading, onboardingStateError: onboardingStateError, skip: skip })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const hasLicensedAccess = accessStatus === 'LICENSED_USE_ACCESS' || accessStatus === 'LICENSED_ADMIN_ACCESS';
    const { data: siteUserTraitsData, loading: siteUserTraitsLoading, error: siteUserTraitsError } = (0, $f7MuR.useSiteUserTraits)({
        skipBootstrap: skip
    });
    const { data: siteTraitsData, loading: siteTraitsDataLoading, error: siteTraitsDataError } = (0, $kOUwv.useSiteTraits)({
        skipBootstrap: skip
    });
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const entries = onboardingStateData?.onboardingState;
    const isInCfindLandCreationFocusedNavExperiment = !!entries?.find((s)=>s.key === (0, $dBcar.CREATION_FOCUSED_NAV_START_TIME))?.value;
    const isInActivationExperiment = entries?.find(({ key: key })=>key === (0, $dBcar.SIMPLIFY_NAV_NEW_USER).NTH_USER_D0_SIMPLIFIED_NAV_ELIGIBLE)?.value === 'true';
    const xflowStartAt = entries?.find(({ key: key })=>key === (0, $dBcar.CFIND_5565_CREATION_FOCUSED_NAV_XFLOW).START_AT)?.value;
    const isReturningEnrolledUser = !!xflowStartAt;
    const firstActiveTrait = siteUserTraitsData?.attributes?.find(({ name: name })=>name === $1f55678574e67c8a$var$CONFLUENCE_FIRST_ACTIVE_TRAIT)?.value;
    const siteActivationDateTrait = siteTraitsData?.attributes?.find(({ name: name })=>name === $1f55678574e67c8a$var$FIRST_ACTIVATION_DATE_TRAIT)?.value;
    let hoursSinceFirstActiveTrait, hoursSinceSiteActivationDate;
    try {
        hoursSinceFirstActiveTrait = firstActiveTrait ? (0, $8uR5k.default)(Date.now(), new Date(firstActiveTrait)) : -1;
        hoursSinceSiteActivationDate = siteActivationDateTrait ? (0, $8uR5k.default)(Date.now(), new Date(siteActivationDateTrait)) : -1;
    } catch  {
        hoursSinceFirstActiveTrait = -2;
        hoursSinceSiteActivationDate = -2;
    }
    const isLoading = !!(onboardingStateLoading || siteUserTraitsLoading || siteTraitsDataLoading);
    const hasError = !!(onboardingStateError || siteUserTraitsError || siteTraitsDataError);
    // A new user is eligible if their site's firstActivationDate is non-null and
    // after the experiment start date. Returning enrolled users are always eligible.
    const isSiteActivationAfterExperimentStart = ()=>{
        if (!siteActivationDateTrait) return false;
        const experimentStartDate = (0, $1KHQh.getXflowExperimentStartDate)();
        if (!experimentStartDate) return false;
        try {
            return new Date(siteActivationDateTrait) >= experimentStartDate;
        } catch  {
            return false;
        }
    };
    const isEligible = !skip && !isLoading && !hasError && hasLicensedAccess && !isInCfindLandCreationFocusedNavExperiment && !isInActivationExperiment && (isReturningEnrolledUser || isSiteActivationAfterExperimentStart());
    const hasWrittenStartAt = (0, $42omo.useRef)(false);
    (0, $42omo.useEffect)(()=>{
        if (isEligible && !isReturningEnrolledUser && !hasWrittenStartAt.current && (0, $9wGTI.fg)('cfind_5565_creation_focused_nav_xflow_preload')) {
            hasWrittenStartAt.current = true;
            setOnboardingState({
                key: (0, $dBcar.CFIND_5565_CREATION_FOCUSED_NAV_XFLOW).START_AT,
                value: new Date().toISOString()
            });
        }
    }, [
        isEligible,
        isReturningEnrolledUser,
        setOnboardingState
    ]);
    const hasFiredAnalytic = (0, $42omo.useRef)(false);
    (0, $42omo.useEffect)(()=>{
        if (!isLoading && !hasError && !isInCfindLandCreationFocusedNavExperiment && !isInActivationExperiment && !hasFiredAnalytic.current && !skip && hasLicensedAccess) {
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'eligible',
                    actionSubject: 'cfind-5565-simplify-nav-xflow',
                    actionSubjectId: 'cfind-5565-simplify-nav-xflow',
                    source: 'cfind-5565-simplify-nav-xflow',
                    attributes: {
                        firstActive: firstActiveTrait,
                        hoursSinceFirstActiveTrait: hoursSinceFirstActiveTrait,
                        siteActivationDate: siteActivationDateTrait,
                        hoursSinceSiteActivationDate: hoursSinceSiteActivationDate
                    }
                }
            }).fire();
            hasFiredAnalytic.current = true;
        }
    }, [
        createAnalyticsEvent,
        hasLicensedAccess,
        isLoading,
        isInCfindLandCreationFocusedNavExperiment,
        isInActivationExperiment,
        firstActiveTrait,
        hasError,
        hoursSinceFirstActiveTrait,
        hoursSinceSiteActivationDate,
        siteActivationDateTrait,
        skip
    ]);
    return {
        isLoading: isLoading,
        hasError: hasError,
        isEligible: isEligible,
        // For returning enrolled users, use their START_AT timestamp to determine if they're
        // within the D0 window. For first-time users (no START_AT yet), they're implicitly
        // within their D0 window if and only if they're eligible.
        isWithinD0Window: xflowStartAt ? (0, $6Dfc9.isWithinD0Window)(xflowStartAt) : isEligible
    };
};
module.exports["useIsEligibleForSimplifyNavXflow"] = $1f55678574e67c8a$export$bbe7d46982302b03;

});

parcelRegister("1KHQh", function(module, exports) {
// eslint-disable-next-line confluence-feature-gating/unsafe-no-exposure

var $6mKj3 = parcelRequire("6mKj3");

const $47ca1d22622dd352$export$9aeee5d7687bf679 = ()=>{
    // eslint-disable-next-line confluence-feature-gating/unsafe-no-exposure
    const [expConfig] = (0, $6mKj3.UNSAFE_noExposureExp)('cfind_5565_creation_focused_nav_xflow'); // Experiment exposure is fired elsewhere
    const rawValue = expConfig.get('experimentStartDate', null);
    if (!rawValue) return null;
    const date = new Date(rawValue);
    return isNaN(date.getTime()) ? null : date;
};
module.exports["getXflowExperimentStartDate"] = $47ca1d22622dd352$export$9aeee5d7687bf679;

});

parcelRegister("i4dNk", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $dBcar = parcelRequire("dBcar");


var $ivb8S = parcelRequire("ivb8S");

const $0451aea256d3610a$export$5ff0b879ab65d0b0 = 'd1';
const $0451aea256d3610a$export$46c1c92549715335 = 'loading';
const $0451aea256d3610a$export$61c0af74ec47d243 = 'd0';
const $0451aea256d3610a$export$f883a24d5edde77c = 'none';
const $0451aea256d3610a$export$a226a5c24cc00b77 = (updateState = false)=>{
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const { cohort: cohort, delayInMinutes: delayInMinutes } = $0451aea256d3610a$var$getExperimentData();
    const hasUpdatedState = (0, $42omo.useRef)(false);
    const isInExperimentControl = cohort !== 'treatment';
    const { data: onboardingStateData, loading: onboardingStateLoading, error: onboardingStateError } = (0, $ivb8S.useGetOnboardingState)((0, $9wGTI.fg)('cc_activation_simplify_nav_preloader_enabled') ? [
        ...(0, $dBcar.NAV_EXPERIMENT_ONBOARDING_KEYS)
    ] : [
        (0, $dBcar.CREATION_FOCUSED_NAV_SHOULD_SHOW_SPOTLIGHT),
        (0, $dBcar.CREATION_FOCUSED_NAV_START_TIME)
    ], isInExperimentControl);
    const spotlightShown = ()=>{
        setOnboardingState({
            key: (0, $dBcar.CREATION_FOCUSED_NAV_SHOULD_SHOW_SPOTLIGHT),
            value: 'false'
        });
    };
    if (isInExperimentControl) return {
        isSpotlightVisible: false,
        areBannersHidden: false,
        navCustomization: $0451aea256d3610a$export$f883a24d5edde77c
    };
    if (onboardingStateLoading) // Simplify nav and hide banners while loading, to minimize flashing
    return {
        isSpotlightVisible: false,
        areBannersHidden: true,
        navCustomization: $0451aea256d3610a$export$46c1c92549715335
    };
    if (onboardingStateError) // Control behavior if there are any errors
    return {
        isSpotlightVisible: false,
        areBannersHidden: false,
        navCustomization: $0451aea256d3610a$export$f883a24d5edde77c
    };
    const { shouldShowSpotlight: shouldShowSpotlight, startTime: startTime } = (0, $ivb8S.deserializeState)(onboardingStateData);
    if ($0451aea256d3610a$var$isSiteOlderThanDelay(delayInMinutes, startTime)) {
        if (shouldShowSpotlight) // Spotlight ready to show --> Show spotlight, bring nav features back, but don't bring banners back
        return {
            isSpotlightVisible: true,
            areBannersHidden: true,
            navCustomization: $0451aea256d3610a$export$5ff0b879ab65d0b0,
            onSpotlightShown: spotlightShown
        };
        else if (shouldShowSpotlight === false) // Spotlight has already shown --> Don't show spotlight, bring nav features back, but don't bring banners back
        return {
            isSpotlightVisible: false,
            areBannersHidden: true,
            navCustomization: $0451aea256d3610a$export$5ff0b879ab65d0b0
        };
        // This account was created before the experiment started, so we won't change anything even though statsig returned "treatment"
        return {
            isSpotlightVisible: false,
            areBannersHidden: false,
            navCustomization: $0451aea256d3610a$export$f883a24d5edde77c
        };
    } else if (shouldShowSpotlight === undefined && updateState && !hasUpdatedState.current) {
        hasUpdatedState.current = true;
        setOnboardingState({
            key: (0, $dBcar.CREATION_FOCUSED_NAV_SHOULD_SHOW_SPOTLIGHT),
            value: 'true'
        });
    }
    return {
        isSpotlightVisible: false,
        areBannersHidden: true,
        navCustomization: $0451aea256d3610a$export$61c0af74ec47d243
    };
};
const $0451aea256d3610a$var$getExperimentData = ()=>{
    // eslint-disable-next-line confluence-feature-gating/unsafe-no-exposure
    const [expConfig] = (0, $6mKj3.UNSAFE_noExposureExp)('cfind-4473-creation-focused-nav'); // Experiment exposure is fired in the backend
    const cohort = expConfig.get('cohort', 'control');
    const minutesPerHour = 60;
    const hoursPerDay = 24;
    const defaultDelayInMinutes = minutesPerHour * hoursPerDay;
    const delayInMinutes = expConfig.get('delayInMinutes', defaultDelayInMinutes.toString());
    return {
        cohort: cohort,
        delayInMinutes: parseInt(delayInMinutes)
    };
};
const $0451aea256d3610a$var$isSiteOlderThanDelay = (delayInMinutes, siteActivationDateString)=>{
    if (!siteActivationDateString) return true; // If site has no activation date, assume it is old
    const siteActivationDateNumber = Number(siteActivationDateString);
    const siteActivationDate = new Date(siteActivationDateNumber ?? '');
    if (isNaN(siteActivationDate.getTime())) return true; // If site has no activation date, assume it is old
    const createdAtTimestamp = siteActivationDate.getTime();
    const millisecondsSinceCreation = Date.now() - createdAtTimestamp;
    const secondsPerMinute = 60;
    const millisecondsPerSecond = 1000;
    const millisecondsInDelayTime = delayInMinutes * secondsPerMinute * millisecondsPerSecond;
    return millisecondsSinceCreation > millisecondsInDelayTime;
};
module.exports["d1"] = $0451aea256d3610a$export$5ff0b879ab65d0b0;
module.exports["loading"] = $0451aea256d3610a$export$46c1c92549715335;
module.exports["d0"] = $0451aea256d3610a$export$61c0af74ec47d243;
module.exports["useCfind4473CreationFocusedNav"] = $0451aea256d3610a$export$a226a5c24cc00b77;

});

parcelRegister("jh864", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $8njHX = parcelRequire("8njHX");


var $jvL0g = parcelRequire("jvL0g");

const $bf400a28e0f66299$export$6dc09b7c0ec1dfcd = /*#__PURE__*/ (0, $42omo.forwardRef)(({ testId: testId, actions: actions, children: children, description: description, elemAfter: elemAfter, isDisabled: isDisabled, isSelected: isSelected, elemBefore: elemBefore, actionsOnHover: actionsOnHover, onClick: onClick, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, interactionName: interactionName, isContentTooltipDisabled: isContentTooltipDisabled, visualContentRef: visualContentRef, listItemRef: listItemRef, isDragging: isDragging, hasDragIndicator: hasDragIndicator, dropIndicator: dropIndicator }, forwardedRef)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $jvL0g.MenuListItem), {
        ref: listItemRef,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $8njHX.MenuItemBase), {
            testId: testId,
            description: description,
            elemAfter: elemAfter,
            elemBefore: elemBefore,
            isDisabled: isDisabled,
            /**
					 * Not passing `actions` and `actionsOnHover` to MenuItemBase when `isDisabled`,
					 * so they aren't rendered in the disabled state.
					 */ actions: isDisabled ? undefined : actions,
            actionsOnHover: isDisabled ? undefined : actionsOnHover,
            onClick: onClick,
            ariaControls: ariaControls,
            ariaExpanded: ariaExpanded,
            ariaHasPopup: ariaHasPopup,
            isSelected: isSelected,
            ref: forwardedRef,
            visualContentRef: visualContentRef,
            interactionName: interactionName,
            isContentTooltipDisabled: isContentTooltipDisabled,
            isDragging: isDragging,
            hasDragIndicator: hasDragIndicator,
            dropIndicator: dropIndicator,
            children: children
        })
    });
});
module.exports["ButtonMenuItem"] = $bf400a28e0f66299$export$6dc09b7c0ec1dfcd;

});

parcelRegister("jItTa", function(module, exports) {
/* divider.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $5358d45118fa3975$var$styles = null; /**
                      * __Divider__
                      *
                      * A divider for use between menu sections.
                      */ 
const $5358d45118fa3975$export$2e0a83ec2e27ecbb = ()=>/*#__PURE__*/ (0, $l998X.jsx)("hr" /**
                                  * The existing usage of these dividers is presentational,
                                  * so we are removing the separator semantics by default.
                                  *
                                  * In the future we may consider allowing opt-in separator semantics,
                                  * but it probably isn't necessary.
                                  */ , {
        role: "none",
        className: (0, $gMc0m.default)([
            "_h7alglyw _179rglyw _mqm2ia51 _1bsb1osq"
        ])
    });
module.exports["Divider"] = $5358d45118fa3975$export$2e0a83ec2e27ecbb;

});

parcelRegister("63PsI", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $1ytiN = parcelRequire("1ytiN");

function $acec4613ff860ea3$export$e7c489d818076f3d() {
    let { companyHubName: companyHubName } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    const intl = (0, $aXWIB.useIntl)();
    if (!companyHubName) companyHubName = intl.formatMessage($acec4613ff860ea3$var$messages.defaultCompanyHubName);
    return companyHubName;
}
// eslint-disable-next-line check-i18n-id-prefix/i18n-id-prefix-with-package-name-defineMessages -- Moved from confluence/next/packages/app-navigation/src/Nav3/PrimaryItems/CompanyHubItem.tsx
const $acec4613ff860ea3$var$messages = (0, $aXWIB.defineMessages)({
    defaultCompanyHubName: {
        id: "app-navigation.company-hub.link",
        defaultMessage: "Company hub"
    }
});
module.exports["useCompanyHubName"] = $acec4613ff860ea3$export$e7c489d818076f3d;

});

parcelRegister("1pi2u", function(module, exports) {

let $10661e6feea9c578$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $10661e6feea9c578$var$load("aGsq7").then(()=>parcelRequire('eXmLL'));

});

parcelRegister("1LksZ", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $135393dc762a6338$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    customHome: {
        id: "side-navigation.global.home",
        defaultMessage: "Home"
    },
    forYou: {
        id: "side-navigation.global.for.you",
        defaultMessage: "For you"
    },
    yourWork: {
        id: "side-navigation.global.your.work",
        defaultMessage: "For you"
    },
    companyHub: {
        id: "side-navigation.global.company.hub",
        defaultMessage: "Company Hub"
    },
    recent: {
        id: "side-navigation.global.recent",
        defaultMessage: "Recent"
    },
    starred: {
        id: "side-navigation.global.starred",
        defaultMessage: "Starred"
    },
    spaces: {
        id: "side-navigation.global.spaces",
        defaultMessage: "Spaces"
    },
    apps: {
        id: "side-navigation.global.apps",
        defaultMessage: "Apps"
    },
    goals: {
        id: "side-navigation.global.goals",
        defaultMessage: "Goals"
    },
    topics: {
        id: "side-navigation.global.topics",
        defaultMessage: "Topics"
    },
    teams: {
        id: "side-navigation.global.teams",
        defaultMessage: "Teams"
    },
    drafts: {
        id: "side-navigation.global.drafts",
        defaultMessage: "Drafts"
    },
    tasks: {
        id: "side-navigation.global.tasks",
        defaultMessage: "Tasks"
    },
    more: {
        id: "side-navigation.global.more",
        defaultMessage: "More"
    },
    customize: {
        id: "side-navigation.global.customize.sidebar",
        defaultMessage: "Customize sidebar"
    },
    templates: {
        id: "side-navigation.global.customize.templates",
        defaultMessage: "Templates"
    },
    workflows: {
        id: "side-navigation.global.customize.workflows",
        defaultMessage: "Workflows"
    },
    separator: {
        id: "side-navigation.global.customize.separator",
        defaultMessage: "HIDE FROM SIDEBAR"
    },
    jiraShortcut: {
        id: "side-navigation.global.customize.jiraShortcut",
        defaultMessage: "Jira"
    },
    loomShortcut: {
        id: "side-navigation.global.customize.loomShortcut",
        defaultMessage: "Loom"
    },
    teamsShortcut: {
        id: "side-navigation.global.customize.teamsShortcut",
        defaultMessage: "Teams"
    },
    companyHubShortcut: {
        id: "side-navigation.global.customize.companyHubShortcut",
        // eslint-disable-next-line @atlassian/i18n/no-useless-message
        defaultMessage: "{companyHubName}"
    },
    notes: {
        id: "side-navigation.global.customize.notesShortcut",
        defaultMessage: "Notes"
    }
});
module.exports["i18n"] = $135393dc762a6338$export$a7357cdd1f0b0168;

});

parcelRegister("cxU8R", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $4wwVl = parcelRequire("4wwVl");


var $fJM5Q = parcelRequire("fJM5Q");


var $ctmPb = parcelRequire("ctmPb");


var $kevJM = parcelRequire("kevJM");


var $kfYj7 = parcelRequire("kfYj7");


var $buthI = parcelRequire("buthI");


var $tvI67 = parcelRequire("tvI67");


var $gJsgh = parcelRequire("gJsgh");


var $la4Nn = parcelRequire("la4Nn");


var $1dKyn = parcelRequire("1dKyn");


var $1Zr9M = parcelRequire("1Zr9M");


var $dmbve = parcelRequire("dmbve");


var $9VJDA = parcelRequire("9VJDA");


var $gXn1S = parcelRequire("gXn1S");


var $isYda = parcelRequire("isYda");


var $hbYDZ = parcelRequire("hbYDZ");


var $lAFHW = parcelRequire("lAFHW");


var $6mKj3 = parcelRequire("6mKj3");

const $b1654aa018846a1e$var$StyledIconComponent = /*#__PURE__*/ (0, $42omo.memo)((t0)=>{
    const $ = (0, $frIzR.c)(2);
    const { icon: icon } = t0;
    const IconComponent = icon;
    let t1;
    if ($[0] !== IconComponent) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(IconComponent, {
            label: "",
            color: "currentColor",
            spacing: "spacious"
        });
        $[0] = IconComponent;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
});
const $b1654aa018846a1e$var$StyledLogoComponent = /*#__PURE__*/ (0, $42omo.memo)((t0)=>{
    const $ = (0, $frIzR.c)(3);
    const { logo: logo, testId: testId } = t0;
    const LogoComponent = logo;
    let t1;
    if ($[0] !== LogoComponent || $[1] !== testId) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(LogoComponent, {
            label: "",
            size: "xsmall",
            shouldUseNewLogoDesign: true,
            testId: testId
        });
        $[0] = LogoComponent;
        $[1] = testId;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
});
const $b1654aa018846a1e$export$4370213f5e13a087 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b1654aa018846a1e$var$StyledIconComponent, {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($4wwVl)))
});
const $b1654aa018846a1e$export$fcf3ce494c961537 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b1654aa018846a1e$var$StyledIconComponent, {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($fJM5Q)))
});
const $b1654aa018846a1e$export$e25b0b35bcc6a6f4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b1654aa018846a1e$var$StyledIconComponent, {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($ctmPb)))
});
const $b1654aa018846a1e$export$22eb82a2d06386cd = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b1654aa018846a1e$var$StyledIconComponent, {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($kevJM)))
});
const $b1654aa018846a1e$export$e354edba2d87a80b = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b1654aa018846a1e$var$StyledIconComponent, {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($kfYj7)))
});
const $b1654aa018846a1e$export$815068847a2940cc = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b1654aa018846a1e$var$StyledIconComponent, {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($buthI)))
});
const $b1654aa018846a1e$export$1820ff183b9ac996 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b1654aa018846a1e$var$StyledIconComponent, {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($hbYDZ)))
});
const $b1654aa018846a1e$export$2ad8d00357381dab = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b1654aa018846a1e$var$StyledIconComponent, {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($tvI67)))
});
const $b1654aa018846a1e$export$b8743c92b35ba3d2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b1654aa018846a1e$var$StyledIconComponent, {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($gJsgh)))
});
const $b1654aa018846a1e$export$ea1e8de44637bcc8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b1654aa018846a1e$var$StyledIconComponent, {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($la4Nn)))
});
const $b1654aa018846a1e$export$85b08d1fd6c3c91e = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b1654aa018846a1e$var$StyledIconComponent, {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($1dKyn)))
});
const $b1654aa018846a1e$export$3ac9d636aeac90b = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b1654aa018846a1e$var$StyledIconComponent, {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($1Zr9M)))
});
const $b1654aa018846a1e$export$44d9bde334d7e007 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b1654aa018846a1e$var$StyledIconComponent, {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($dmbve)))
});
const $b1654aa018846a1e$export$296eedab7746f8f0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b1654aa018846a1e$var$StyledIconComponent, {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($gXn1S)))
});
const $b1654aa018846a1e$export$1f926db0b8c551ab = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b1654aa018846a1e$var$StyledIconComponent, {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($9VJDA)))
});
const $b1654aa018846a1e$export$553a8f8e72a63c41 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b1654aa018846a1e$var$StyledIconComponent, {
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($isYda)))
});
const $b1654aa018846a1e$export$7ef71e75b22027b6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b1654aa018846a1e$var$StyledLogoComponent, {
    logo: (0, $lAFHW.HubIcon)
});
const $b1654aa018846a1e$export$b98c953fd1e726cc = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b1654aa018846a1e$var$StyledLogoComponent, {
    logo: (0, $lAFHW.TeamsIcon)
});
const $b1654aa018846a1e$export$7ac757a6aec752f4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b1654aa018846a1e$var$StyledLogoComponent, {
    logo: (0, $lAFHW.JiraIcon)
});
const $b1654aa018846a1e$export$6e55f825f45b7145 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b1654aa018846a1e$var$StyledLogoComponent, {
    logo: (0, $lAFHW.LoomIcon)
});
const $b1654aa018846a1e$export$803815ff2adecad4 = {
    customHome: $b1654aa018846a1e$export$fcf3ce494c961537,
    yourWork: $b1654aa018846a1e$export$4370213f5e13a087,
    // Component has been updated to 'For you', key remains the same.
    companyHub: $b1654aa018846a1e$export$e25b0b35bcc6a6f4,
    recent: $b1654aa018846a1e$export$22eb82a2d06386cd,
    starred: $b1654aa018846a1e$export$e354edba2d87a80b,
    spaces: $b1654aa018846a1e$export$815068847a2940cc,
    apps: $b1654aa018846a1e$export$2ad8d00357381dab,
    goals: $b1654aa018846a1e$export$b8743c92b35ba3d2,
    topics: $b1654aa018846a1e$export$ea1e8de44637bcc8,
    teams: $b1654aa018846a1e$export$85b08d1fd6c3c91e,
    drafts: $b1654aa018846a1e$export$3ac9d636aeac90b,
    tasks: $b1654aa018846a1e$export$44d9bde334d7e007,
    templates: $b1654aa018846a1e$export$296eedab7746f8f0,
    customize: $b1654aa018846a1e$export$553a8f8e72a63c41,
    companyHubShortcut: $b1654aa018846a1e$export$7ef71e75b22027b6,
    teamsShortcut: $b1654aa018846a1e$export$b98c953fd1e726cc,
    jiraShortcut: $b1654aa018846a1e$export$7ac757a6aec752f4,
    loomShortcut: $b1654aa018846a1e$export$6e55f825f45b7145
};
const $b1654aa018846a1e$export$d7b6490d01f6dc6 = ()=>{
    if ((0, $6mKj3.expVal)('confluence_space_icon_update', 'isEnabled', false)) return {
        ...$b1654aa018846a1e$export$803815ff2adecad4,
        spaces: $b1654aa018846a1e$export$1820ff183b9ac996
    };
    return $b1654aa018846a1e$export$803815ff2adecad4;
};
module.exports["ForYouIconComponent"] = $b1654aa018846a1e$export$4370213f5e13a087;
module.exports["HomeIconComponent"] = $b1654aa018846a1e$export$fcf3ce494c961537;
module.exports["ClockIconComponent"] = $b1654aa018846a1e$export$22eb82a2d06386cd;
module.exports["StarIconComponent"] = $b1654aa018846a1e$export$e354edba2d87a80b;
module.exports["GlobeIconComponent"] = $b1654aa018846a1e$export$815068847a2940cc;
module.exports["SpacesIconComponent"] = $b1654aa018846a1e$export$1820ff183b9ac996;
module.exports["AppsIconComponent"] = $b1654aa018846a1e$export$2ad8d00357381dab;
module.exports["GoalIconComponent"] = $b1654aa018846a1e$export$b8743c92b35ba3d2;
module.exports["HashIconComponent"] = $b1654aa018846a1e$export$ea1e8de44637bcc8;
module.exports["TeamsIconComponent"] = $b1654aa018846a1e$export$85b08d1fd6c3c91e;
module.exports["EditIconComponent"] = $b1654aa018846a1e$export$3ac9d636aeac90b;
module.exports["TaskIconComponent"] = $b1654aa018846a1e$export$44d9bde334d7e007;
module.exports["TemplatesIconComponent"] = $b1654aa018846a1e$export$296eedab7746f8f0;
module.exports["MoreIconComponent"] = $b1654aa018846a1e$export$1f926db0b8c551ab;
module.exports["CustomizeIconComponent"] = $b1654aa018846a1e$export$553a8f8e72a63c41;
module.exports["useIconByMenuId"] = $b1654aa018846a1e$export$d7b6490d01f6dc6;

});

parcelRegister("iMhjI", function(module, exports) {

let $daba24797482346b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $daba24797482346b$var$load("7BaJE").then(()=>parcelRequire('1CCr3'));

});

parcelRegister("fydXz", function(module, exports) {

let $b524dc241e85ee28$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b524dc241e85ee28$var$load("7do1E"),
    $b524dc241e85ee28$var$load("77dkW"),
    $b524dc241e85ee28$var$load("ePlqt"),
    $b524dc241e85ee28$var$load("ksAow"),
    $b524dc241e85ee28$var$load("hyzoX"),
    $b524dc241e85ee28$var$load("Wowvf"),
    $b524dc241e85ee28$var$load("5KU6f")
]).then(()=>parcelRequire('l739x'));

});

parcelRegister("bfhzz", function(module, exports) {

let $82feba03f45a47c6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $82feba03f45a47c6$var$load("SepNY").then(()=>parcelRequire('3QuUN'));

});

parcelRegister("jQODQ", function(module, exports) {

let $e73a280bbe65e43c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e73a280bbe65e43c$var$load("j6Nec").then(()=>parcelRequire('lLYUy'));

});

parcelRegister("9cHD3", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gdv5Z = parcelRequire("gdv5Z");

var $eyWa4 = parcelRequire("eyWa4");


var $kpYGL = parcelRequire("kpYGL");

const $c13134ff3760e72f$var$skeletonProps = {
    height: '9px',
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage
    borderRadius: "var(--ds-radius-small, 3px)",
    isShimmering: true,
    color: "var(--ds-skeleton, #0515240F)",
    ShimmeringEndColor: "var(--ds-skeleton-subtle, #17171708)"
};
const $c13134ff3760e72f$export$a2ec9fdcdf0bd301 = ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            paddingBlock: "space.300"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
            space: "space.300",
            alignBlock: "center",
            alignInline: "center",
            grow: "fill",
            testId: "content-menu-loading"
        }, [
            ...Array(10)
        ].map($c13134ff3760e72f$var$_temp)));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
};
const $c13134ff3760e72f$export$feed0f481420fd40 = ()=>{
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            padding: "space.300"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
            space: "space.300",
            grow: "fill",
            testId: "content-menu-load-more"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
            width: "180px",
            ...$c13134ff3760e72f$var$skeletonProps
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
            width: "140px",
            ...$c13134ff3760e72f$var$skeletonProps
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
            width: "180px",
            ...$c13134ff3760e72f$var$skeletonProps
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
            width: "140px",
            ...$c13134ff3760e72f$var$skeletonProps
        })));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
};
function $c13134ff3760e72f$var$_temp(_, index) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
        key: index,
        width: "250px",
        ...$c13134ff3760e72f$var$skeletonProps
    });
}
module.exports["ContentMenuLoadingState"] = $c13134ff3760e72f$export$a2ec9fdcdf0bd301;
module.exports["ContentMenuLoadMoreState"] = $c13134ff3760e72f$export$feed0f481420fd40;

});

parcelRegister("c2Z3L", function(module, exports) {

let $8c550920086fc5c9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8c550920086fc5c9$var$load("5RR9C"),
    $8c550920086fc5c9$var$load("1ePSc"),
    $8c550920086fc5c9$var$load("3Bbwl"),
    $8c550920086fc5c9$var$load("Wowvf"),
    $8c550920086fc5c9$var$load("2yM8Y")
]).then(()=>parcelRequire('kIWbA'));

});

parcelRegister("5RIc1", function(module, exports) {

let $44542ecc93cf8f24$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $44542ecc93cf8f24$var$load("1ePSc"),
    $44542ecc93cf8f24$var$load("Wowvf"),
    $44542ecc93cf8f24$var$load("1cMUZ")
]).then(()=>parcelRequire('1IQhI'));

});

parcelRegister("5WLjq", function(module, exports) {

var $lyWac = parcelRequire("lyWac");


var $dYU3e = parcelRequire("dYU3e");


var $5IsL6 = parcelRequire("5IsL6");


var $gW6rh = parcelRequire("gW6rh");


var $4H4Pj = parcelRequire("4H4Pj");


var $4eIcx = parcelRequire("4eIcx");


var $5t9S7 = parcelRequire("5t9S7");

const $0075b8fcac3e7fa4$export$19b525d696aff959 = ({ isLicensed: isLicensed, selectedSpaceKey: selectedSpaceKey })=>{
    const preloadQueries = [];
    if (isLicensed) {
        preloadQueries.push((0, $dYU3e.query)({
            query: (0, $gW6rh.default),
            variables: {}
        }));
        if (selectedSpaceKey) preloadQueries.push((0, $dYU3e.query)({
            query: (0, $4eIcx.default),
            variables: {
                selectedSpaceKey: selectedSpaceKey
            }
        }));
        else preloadQueries.push((0, $dYU3e.query)({
            query: (0, $4H4Pj.default),
            variables: {}
        }));
    } else preloadQueries.push((0, $dYU3e.query)({
        query: (0, $5t9S7.default),
        variables: {}
    }));
    preloadQueries.push((0, $5IsL6.preloadCreateSpace)({
        isLicensed: isLicensed
    }));
    return (0, $lyWac.waitForAllReturnWhenError)(preloadQueries);
};
module.exports["preloadSpacesList"] = $0075b8fcac3e7fa4$export$19b525d696aff959;

});

parcelRegister("5IsL6", function(module, exports) {

var $fEhQK = parcelRequire("fEhQK");


var $dYU3e = parcelRequire("dYU3e");

/**
 * see next/packages/create-space/src/useCanCreateSpace.tsx for the query usage
 */ const $c4ac54148814de4b$var$PreloadCreateSpaceQuery = (0, $fEhQK.default);
const $c4ac54148814de4b$export$25bcc47d8ed557d4 = ({ isLicensed: isLicensed })=>{
    if (!isLicensed) return Promise.resolve({
        data: null
    });
    return (0, $dYU3e.query)({
        query: $c4ac54148814de4b$var$PreloadCreateSpaceQuery
    });
};
module.exports["preloadCreateSpace"] = $c4ac54148814de4b$export$25bcc47d8ed557d4;

});

parcelRegister("2QHO0", function(module, exports) {
/* SpacesDropdownContent.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $aXWIB = parcelRequire("aXWIB");


var $jSnXV = parcelRequire("jSnXV");


var $fpGTa = parcelRequire("fpGTa");

var $6f0Oj = parcelRequire("6f0Oj");

var $1GzhS = parcelRequire("1GzhS");

var $5dK2X = parcelRequire("5dK2X");


var $gj7hi = parcelRequire("gj7hi");


var $inPa6 = parcelRequire("inPa6");


var $kpYGL = parcelRequire("kpYGL");


var $irVI7 = parcelRequire("irVI7");


var $1eaCJ = parcelRequire("1eaCJ");


var $bQm3c = parcelRequire("bQm3c");


var $b3j2Y = parcelRequire("b3j2Y");


var $cEgMD = parcelRequire("cEgMD");


var $foQ4a = parcelRequire("foQ4a");


var $7W00p = parcelRequire("7W00p");


var $dVkip = parcelRequire("dVkip");


var $6adZX = parcelRequire("6adZX");


var $1NBp8 = parcelRequire("1NBp8");

var $0f58703e8c994460$exports = {};
$0f58703e8c994460$exports = new URL("fileCabinet.17ae0554.svg", import.meta.url).toString();


/* SpacesDropdownSection.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $a4TK8 = parcelRequire("a4TK8");


var $7p8VW = parcelRequire("7p8VW");

var $c8gOp = parcelRequire("c8gOp");

/* SpacesDropdownItem.tsx generated by @compiled/babel-plugin v0.36.1 */ 












var $9x2sR = parcelRequire("9x2sR");


var $5nBzc = parcelRequire("5nBzc");





var $lBYCH = parcelRequire("lBYCH");


var $bPgHy = parcelRequire("bPgHy");








var $d9tcB = parcelRequire("d9tcB");


var $iKskQ = parcelRequire("iKskQ");





var $epLE5 = parcelRequire("epLE5");


var $hXDOc = parcelRequire("hXDOc");

const $6c5d57d6e35c7884$var$i18n = (0, $aXWIB.defineMessages)({
    archived: {
        id: "spaces-dropdown.item.archived",
        defaultMessage: "Archived"
    }
});
const $6c5d57d6e35c7884$export$88bfe5142f12747e = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "li", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _2rko12b0 _kqswh2mm _14iyidpf _f23q1diz _d0altlke _irr31dpa _1soat94y _vajrdgkc",
            __cmplp.className
        ])
    });
});

const $6c5d57d6e35c7884$var$useLazyClickAnalytics = (0, $epLE5.createLazyCallbackHook)(async ()=>(await (parcelRequire("anmzt"))).fireSpacesMenuItemClickedAnalytics);
const $6c5d57d6e35c7884$export$d0fb286b588b32b1 = ({ space: space, listId: listId })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { resetStickySearchRef: resetStickySearchRef } = (0, $42omo.useContext)((0, $lBYCH.AppNavigationContext));
    const { isExternalCollaborator: isGuest } = (0, $foQ4a.useIsExternalCollaborator)();
    const { closeFlyout: closeFlyout } = (0, $6adZX.useFlyoutActions)();
    const fireSpacesItemClickedAnalytics = $6c5d57d6e35c7884$var$useLazyClickAnalytics(createAnalyticsEvent, '4', {
        componentType: 'customItem',
        itemType: 'space',
        itemId: space.id,
        section: listId,
        isGuest: isGuest
    });
    const onItemClick = ()=>{
        closeFlyout();
        resetStickySearchRef?.current?.();
        fireSpacesItemClickedAnalytics();
    };
    const fireStarClickAnalytics = $6c5d57d6e35c7884$var$useLazyClickAnalytics(createAnalyticsEvent, '4', {
        componentType: 'customItemAction',
        itemId: 'star',
        parentItemType: 'space',
        parentItemId: space.id
    });
    const fireUnstarClickAnalytics = $6c5d57d6e35c7884$var$useLazyClickAnalytics(createAnalyticsEvent, '4', {
        componentType: 'customItemAction',
        itemId: 'unstar',
        parentItemType: 'space',
        parentItemId: space.id
    });
    const spaceAlias = space.alias || space.key;
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const allowStarring = accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).EXTERNAL_COLLABORATOR_ACCESS;
    if (!space.id || !space.key) return null;
    const spaceOverviewHref = (0, $1NBp8.SPACE_OVERVIEW).toUrl({
        spaceKey: spaceAlias
    });
    const isStarred = Boolean(space.currentUser?.isFavourited);
    const starButton = allowStarring ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bPgHy.SpaceStarButton), {
        spaceId: space.id,
        spaceKey: spaceAlias,
        isStarred: isStarred,
        size: "small",
        tooltipPosition: "top",
        onStar: fireStarClickAnalytics,
        onUnstar: fireUnstarClickAnalytics,
        spacing: "none"
    }) : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hXDOc.HoverPreloader), {
        name: "spaces-dropdown-nav4",
        preloadUrl: spaceOverviewHref,
        preloadOptions: (0, $hXDOc.PreloadingPresets).onlyJSAndCriticalData
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9x2sR.LinkMenuItem), {
        href: spaceOverviewHref,
        actions: isStarred ? starButton : undefined,
        actionsOnHover: !isStarred ? starButton : undefined,
        onClick: onItemClick,
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iKskQ.SpaceIcon), {
            size: "xsmall",
            src: space.icon?.path
        }),
        elemAfter: space.status === 'archived' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5nBzc.default), {
            appearance: "default"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $6c5d57d6e35c7884$var$i18n.archived)) : undefined
    }, space.name));
};


const $52cb9eba0a847ec9$export$e4faaa94f915535b = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "ul", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _2mzuglyw _1bsb1osq",
            __cmplp.className
        ])
    });
});
const $52cb9eba0a847ec9$var$SECTION_TITLE_ID_PREFIX = 'spaces-dropdown-section-header-';
const $52cb9eba0a847ec9$export$e6cdabc425aa1b57 = /*#__PURE__*/ (0, $42omo.memo)(({ listId: listId, heading: heading, spaces: spaces, currentSpace: currentSpace })=>{
    const spaceList = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($52cb9eba0a847ec9$export$e4faaa94f915535b, {
        "aria-labelledby": `${$52cb9eba0a847ec9$var$SECTION_TITLE_ID_PREFIX}${listId}`
    }, currentSpace && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6c5d57d6e35c7884$export$d0fb286b588b32b1), {
        space: currentSpace,
        key: currentSpace.alias || currentSpace.id,
        listId: listId
    }), spaces && spaces.map((space)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6c5d57d6e35c7884$export$d0fb286b588b32b1), {
            space: space,
            key: space.id,
            listId: listId
        });
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7p8VW.MenuSection), null, heading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c8gOp.MenuSectionHeading), null, heading), spaceList);
}, (0, (/*@__PURE__*/$parcel$interopDefault($a4TK8))));



var $4Mc9Z = parcelRequire("4Mc9Z");

var $ea1682964355a26f$exports = {};
$ea1682964355a26f$exports = new URL("noResultsDark.90199792.svg", import.meta.url).toString();


var $77cdf19c9d72db22$exports = {};
$77cdf19c9d72db22$exports = new URL("noResultsLight.5ffcf568.svg", import.meta.url).toString();


const $4aa9f354e9fc699f$export$a431988949589239 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_y3gn1h6o _otyrv47k _1r5s1mxl _1o9nhwvj _28uc1ule",
            __cmplp.className
        ])
    });
});
const $4aa9f354e9fc699f$export$5e3f251c730829 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_ca0q1ul9 _u5f3idpf _n3td1ul9 _19bvidpf _y3gn1h6o _1bsb1osq",
            __cmplp.className
        ])
    });
});
const $4aa9f354e9fc699f$var$i18n = (0, $aXWIB.defineMessages)({
    starredHeading: {
        id: "spaces-dropdown.starred",
        defaultMessage: "Starred"
    },
    currentHeading: {
        id: "spaces-dropdown.current",
        defaultMessage: "Current"
    },
    recentHeading: {
        id: "spaces-dropdown.recent",
        defaultMessage: "Recent"
    },
    empty: {
        id: "spaces-dropdown.empty",
        defaultMessage: "Once you view a space, or create a space, they appear here."
    },
    noResults: {
        id: "spaces-dropdown.no-results",
        defaultMessage: "We couldn\u2019t find what you\u2019re looking for."
    },
    advancedSearchLink: {
        id: "spaces-dropdown.advanced-search-link",
        defaultMessage: "Try advanced search instead"
    }
});
const $4aa9f354e9fc699f$var$EmptyState = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4aa9f354e9fc699f$export$a431988949589239, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($0f58703e8c994460$exports))),
        alt: "file cabinet icon"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $4aa9f354e9fc699f$var$i18n.empty));
const $4aa9f354e9fc699f$export$62aa48085237e36f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        paddingBlock: "space.300"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
        space: "space.300",
        alignBlock: "center",
        alignInline: "center",
        grow: "fill",
        testId: "content-menu-loading"
    }, [
        ...Array(10)
    ].map((_, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
            key: index,
            width: "250px",
            height: "9px",
            borderRadius: "3px"
        }))));
const $4aa9f354e9fc699f$var$NoFilteredResultsState = ({ filterText: filterText })=>{
    const { closeFlyout: closeFlyout } = (0, $6adZX.useFlyoutActions)();
    const searchHref = (0, $1NBp8.ADVANCED_SEARCH).toUrl({}, {
        query: {
            text: filterText,
            product: 'confluence',
            type: 'space'
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        paddingBlockStart: "space.800",
        paddingBlockEnd: "space.300",
        paddingInline: "space.800"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
        alignInline: "center",
        alignBlock: "center",
        space: "space.100",
        grow: "fill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj7hi.default), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($77cdf19c9d72db22$exports))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($ea1682964355a26f$exports))),
        alt: "",
        width: "160px",
        height: "160px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
        alignInline: "center",
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
        size: "small",
        color: "color.text.subtle",
        align: "center",
        className: (0, $gMc0m.default)([
            "_3fcw10xh"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $4aa9f354e9fc699f$var$i18n.noResults)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
        size: "small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fpGTa.default), {
        href: searchHref,
        onClick: ()=>closeFlyout(),
        className: (0, $gMc0m.default)([
            "_4bfu1r31 _1hms8stv _ajmmnqa1"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $4aa9f354e9fc699f$var$i18n.advancedSearchLink))))));
};
const $4aa9f354e9fc699f$var$StarredHeading = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $4aa9f354e9fc699f$var$i18n.starredHeading);
const $4aa9f354e9fc699f$var$RecentHeading = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $4aa9f354e9fc699f$var$i18n.recentHeading);
const $4aa9f354e9fc699f$var$CurrentHeading = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $4aa9f354e9fc699f$var$i18n.currentHeading);
const $4aa9f354e9fc699f$export$30edcb7cbec996b0 = ({ filterText: filterText })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { isLicensed: isLicensed } = (0, $bQm3c.useSessionData)();
    const { starredSpaces: starredSpaces, recentSpaces: recentSpaces, currentSpace: currentSpace, loading: loading, errors: errors } = (0, $dVkip.useSpacesData)();
    const { spaceSearchResults: spaceSearchResults, loading: searchLoading, searchSpaces: searchSpaces } = (0, $dVkip.useSpaceSearchData)();
    const { isExternalCollaborator: isGuest } = (0, $foQ4a.useIsExternalCollaborator)();
    const [hideRequestToUpgrade, setHideRequestToUpgrade] = (0, $42omo.useState)(false);
    const hideRequestToUpgradeHandler = (0, $42omo.useCallback)(()=>setHideRequestToUpgrade(true), [
        setHideRequestToUpgrade
    ]);
    const debouncedSearch = (0, $42omo.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))((query)=>{
            searchSpaces(query);
        }, 200, {
            leading: true
        }), [
        searchSpaces
    ]);
    (0, $42omo.useEffect)(()=>{
        if (filterText) debouncedSearch(filterText);
        return ()=>{
            debouncedSearch.cancel();
        };
    }, [
        filterText,
        debouncedSearch
    ]);
    (0, $42omo.useEffect)(()=>{
        if (loading || errors.length > 0) return;
        createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                action: 'done',
                actionSubject: 'spacesDropdown',
                source: 'confluenceFrontend',
                attributes: {
                    starredSpacesCount: isLicensed ? starredSpaces.length : 0,
                    navVersion: '4'
                }
            }
        }).fire();
    }, [
        loading,
        errors.length,
        isLicensed,
        starredSpaces.length,
        createAnalyticsEvent
    ]);
    if (errors.length > 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, errors.map((error)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
            key: error.name,
            error: error
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4Mc9Z.SpacesDropdownError), {
        error: errors[0]
    }));
    if (loading || searchLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4aa9f354e9fc699f$export$62aa48085237e36f, null);
    if (starredSpaces.length === 0 && recentSpaces.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, isGuest && !hideRequestToUpgrade && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7W00p.GuestRequestToUpgradeSpacesMenu), {
        onPermissionDenied: hideRequestToUpgradeHandler,
        onPermissionError: hideRequestToUpgradeHandler
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4aa9f354e9fc699f$var$EmptyState, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1eaCJ.ExperienceSuccess), {
        name: (0, $irVI7.APP_NAV_SPACES_DROPDOWN_EXPERIENCE),
        attributes: {
            navVersion: '4'
        }
    }));
    if (filterText && spaceSearchResults.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4aa9f354e9fc699f$var$NoFilteredResultsState, {
        filterText: filterText
    });
    const isCompanyHub = (0, $cEgMD.isCompanyHubSpaceKey)(currentSpace?.key);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), null, isGuest && !hideRequestToUpgrade && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7W00p.GuestRequestToUpgradeSpacesMenu), {
        onPermissionDenied: hideRequestToUpgradeHandler,
        onPermissionError: hideRequestToUpgradeHandler
    }), filterText ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $52cb9eba0a847ec9$export$e6cdabc425aa1b57), {
        heading: "",
        spaces: spaceSearchResults,
        listId: "searchResults"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, currentSpace && !isCompanyHub && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $52cb9eba0a847ec9$export$e6cdabc425aa1b57), {
        heading: $4aa9f354e9fc699f$var$CurrentHeading,
        currentSpace: currentSpace,
        listId: "current"
    }), starredSpaces.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $52cb9eba0a847ec9$export$e6cdabc425aa1b57), {
        heading: isLicensed && $4aa9f354e9fc699f$var$StarredHeading,
        spaces: starredSpaces,
        listId: "starred"
    }), recentSpaces.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $52cb9eba0a847ec9$export$e6cdabc425aa1b57), {
        heading: $4aa9f354e9fc699f$var$RecentHeading,
        spaces: recentSpaces,
        listId: "recent"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1eaCJ.ExperienceSuccess), {
        name: (0, $irVI7.APP_NAV_SPACES_DROPDOWN_EXPERIENCE)
    }));
};
module.exports["LoadingState"] = $4aa9f354e9fc699f$export$62aa48085237e36f;
module.exports["SpacesDropdownContent"] = $4aa9f354e9fc699f$export$30edcb7cbec996b0;

});

parcelRegister("foQ4a", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");

const $19052bf55936e796$export$e581bd1f88227e0a = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return {
        isExternalCollaborator: accessStatus === (0, $d9tcB.AccessStatus).EXTERNAL_COLLABORATOR_ACCESS
    };
};
module.exports["useIsExternalCollaborator"] = $19052bf55936e796$export$e581bd1f88227e0a;

});

parcelRegister("bPgHy", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $3gadb = parcelRequire("3gadb");


var $eEA8O = parcelRequire("eEA8O");


var $6GD8y = parcelRequire("6GD8y");


var $4tOXV = parcelRequire("4tOXV");


var $gnkil = parcelRequire("gnkil");


var $clKWq = parcelRequire("clKWq");


var $cf6nm = parcelRequire("cf6nm");


var $6JTqt = parcelRequire("6JTqt");


var $iCPvv = parcelRequire("iCPvv");

const $6c068a04f330fe02$export$8a54a88ee586a4ef = ({ size: size = 'medium', outlineAppearance: outlineAppearance = 'subtle', tooltipPosition: tooltipPosition = 'bottom', shortcut: shortcut, label: label, ...props })=>{
    const intl = (0, $aXWIB.useIntl)();
    const spacing = size === 'small' ? 'compact' : 'default';
    const buttonComponent = outlineAppearance === 'subtle' ? (0, $clKWq.HoverButton) : undefined;
    const tooltipLabel = props.isStarred ? intl.formatMessage((0, $6JTqt.spaceStarI18n).unstar) : intl.formatMessage((0, $6JTqt.spaceStarI18n).star);
    const shortcutStrings = (0, $4tOXV.useShortcutStrings)({
        shortcut: shortcut
    });
    const buttonLabel = label ?? intl.formatMessage((0, $6JTqt.spaceStarI18n).star);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iCPvv.SpaceStar), props, ({ toggle: toggleStar })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: tooltipLabel,
            shortcut: shortcutStrings,
            position: tooltipPosition,
            hideTooltipOnClick: true,
            hideTooltipOnMouseDown: true
        }, props.isStarred ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
            id: `star-button-${props.spaceKey}`,
            onClick: toggleStar,
            spacing: spacing,
            appearance: "subtle",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cf6nm.StarIcon), {
                isStarred: true,
                spacing: "spacious"
            }),
            "aria-label": buttonLabel,
            "aria-labelledby": `star-button-${props.spaceKey} space-link-${props.spaceKey}`,
            "aria-pressed": true,
            testId: "star-button-starred"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $clKWq.HiddenAction), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
            id: `star-button-${props.spaceKey}`,
            onClick: toggleStar,
            spacing: spacing,
            appearance: "subtle",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cf6nm.StarIcon), {
                isStarred: false,
                spacing: "spacious"
            }),
            component: buttonComponent,
            "aria-label": buttonLabel,
            "aria-labelledby": `star-button-${props.spaceKey} space-link-${props.spaceKey}`,
            "aria-pressed": false,
            testId: "star-button-unstarred"
        }))), shortcut && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
            deprecatedAccelerator: (0, $gnkil.STAR_BUTTON_SHORTCUT),
            accelerator: (0, $gnkil.UNIVERSAL_STAR_BUTTON_SHORTCUT),
            listener: toggleStar
        })));
};
module.exports["SpaceStarButton"] = $6c068a04f330fe02$export$8a54a88ee586a4ef;

});

parcelRegister("clKWq", function(module, exports) {
/* PresentationalComponents.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");


var $eEA8O = parcelRequire("eEA8O");

const $c778e820ae925f4a$var$buttonStyle = null;
const $c778e820ae925f4a$export$51d63fc44de8b04c = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19itglyw _2rkofajl _11q7sm61 _1e0c1txw _4cvr1h6o _1bah1h6o _4t3izwfg _1bsbzwfg _80omtlke _19lc1dpa",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $c778e820ae925f4a$export$d4589334c0881f2b = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19itglyw _2rkofajl _11q7sm61 _1e0c1txw _4cvr1h6o _1bah1h6o _4t3izwfg _1bsbzwfg _80omtlke _syaz173l _19lc1dpa _1fh11q3r",
            __cmplp.className
        ])
    });
});
const $c778e820ae925f4a$export$7099540c149f2cd6 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1t4p14lu _ll8p1q3r",
            __cmplp.className
        ])
    });
});
const $c778e820ae925f4a$export$4fba02bb1c3a731d = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_bgrb1eg2 _yfoxkb7n",
            __cmplp.className
        ])
    });
});
const $c778e820ae925f4a$export$5df393b96cc674b9 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19itglyw _2rkofajl _11q7sm61 _1e0c1txw _4cvr1h6o _1bah1h6o _4t3izwfg _1bsbzwfg _80omtlke _bgrb1eg2 _yfoxkb7n _19lc1dpa",
            __cmplp.className
        ])
    });
});
const $c778e820ae925f4a$export$e74173003a1ed83f = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isHidden: isHidden, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1dgtmw9": (0, $7sObp.default)(__cmplp.isHidden ? 'var(--show-action)' : '1')
        },
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_bgrb1dxe _yfoxkb7n",
            __cmplp.className
        ])
    });
});
const $c778e820ae925f4a$export$bba53dc78bc0e0ef = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = (0, $eEA8O.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "",
            __cmplp.isSubtle && "_1s9r14lu _ewrd1q3r",
            __cmplp.className
        ])
    });
});
module.exports["FilledIconButton"] = $c778e820ae925f4a$export$51d63fc44de8b04c;
module.exports["UnfilledIconButton"] = $c778e820ae925f4a$export$d4589334c0881f2b;
module.exports["HoverButton"] = $c778e820ae925f4a$export$7099540c149f2cd6;
module.exports["HiddenAction"] = $c778e820ae925f4a$export$4fba02bb1c3a731d;
module.exports["ConditionalHiddenAction"] = $c778e820ae925f4a$export$e74173003a1ed83f;
module.exports["ConditionalSubtleHoverButton"] = $c778e820ae925f4a$export$bba53dc78bc0e0ef;

});

parcelRegister("6JTqt", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $cb829b43ff2427a0$export$8fb02cdb4f1f9040 = (0, $aXWIB.defineMessages)({
    star: {
        id: "action-buttons.space.star.label",
        defaultMessage: "Star this space"
    },
    unstar: {
        id: "action-buttons.space.unstar.label",
        defaultMessage: "Unstar this space"
    }
});
module.exports["spaceStarI18n"] = $cb829b43ff2427a0$export$8fb02cdb4f1f9040;

});

parcelRegister("anmzt", function(module, exports) {

let $78dd8f8989dab87a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $78dd8f8989dab87a$var$load("SepNY").then(()=>parcelRequire('7Hd8C'));

});

parcelRegister("4Mc9Z", function(module, exports) {
/* SpacesDropdownError.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $aXWIB = parcelRequire("aXWIB");


var $irVI7 = parcelRequire("irVI7");


var $hjygH = parcelRequire("hjygH");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $388eee5f4f8f00b0$var$WarningContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt4pxbi _bfhk1917 _y3gn1h6o",
            __cmplp.className
        ])
    });
});
const $388eee5f4f8f00b0$var$i18n = (0, $aXWIB.defineMessages)({
    viewAll: {
        id: "spaces-dropdown.view-all",
        defaultMessage: "View all spaces"
    },
    error: {
        id: "spaces-dropdown.error",
        defaultMessage: "We are unable to show your spaces at this time. Refresh or try again later."
    }
});
const $388eee5f4f8f00b0$var$experienceAttributes = {
    navVersion: '4'
};
const $388eee5f4f8f00b0$export$d099c22b74880430 = ({ error: error })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($388eee5f4f8f00b0$var$WarningContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hjygH.ExperienceStop), {
        name: (0, $irVI7.APP_NAV_SPACES_DROPDOWN_EXPERIENCE),
        error: error,
        attributes: $388eee5f4f8f00b0$var$experienceAttributes
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $388eee5f4f8f00b0$var$i18n.error));
};
module.exports["SpacesDropdownError"] = $388eee5f4f8f00b0$export$d099c22b74880430;

});

parcelRegister("hjygH", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $1kHsc = parcelRequire("1kHsc");

function $1aeb691895c5954d$export$85823f26dca064c3(t0) {
    const $ = (0, $frIzR.c)(6);
    const { name: name, error: error, attributes: attributes } = t0;
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    let t1;
    let t2;
    if ($[0] !== attributes || $[1] !== error || $[2] !== experienceTracker || $[3] !== name) {
        t1 = ()=>{
            if (error) experienceTracker.stopOnError({
                name: name,
                error: error,
                attributes: attributes
            });
            else experienceTracker.succeed({
                name: name,
                attributes: attributes
            });
        };
        t2 = [
            experienceTracker,
            name,
            attributes,
            error
        ];
        $[0] = attributes;
        $[1] = error;
        $[2] = experienceTracker;
        $[3] = name;
        $[4] = t1;
        $[5] = t2;
    } else {
        t1 = $[4];
        t2 = $[5];
    }
    (0, $42omo.useEffect)(t1, t2);
    return null;
}
module.exports["ExperienceStop"] = $1aeb691895c5954d$export$85823f26dca064c3;

});

parcelRegister("eHV9G", function(module, exports) {

let $ab516aa82e67ffe5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ab516aa82e67ffe5$var$load("7QQL7"),
    $ab516aa82e67ffe5$var$load("Wowvf"),
    $ab516aa82e67ffe5$var$load("7JfxY")
]).then(()=>parcelRequire('lOSbK'));

});

parcelRegister("1CdLs", function(module, exports) {
/* expandable-menu-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $6mkwk = parcelRequire("6mkwk");


var $jvL0g = parcelRequire("jvL0g");


var $6BXcn = parcelRequire("6BXcn");

const $417a895b4429e145$var$relativeStyles = {
    root: "_kqswh2mm"
}; /**
    * __ExpandableMenuItem__
    *
    * A composable component for nested menu items that can be revealed and hidden by interacting witih the parent menu item.
    *
    * Follows the [disclosure pattern](https://www.w3.org/WAI/ARIA/apg/patterns/disclosure/).
    *
    * Should be used with `ExpandableMenuItemTrigger` as the parent menu item, and children menu items should be wrapped in a `ExpandableMenuItemContent`.
    *
    * Usage example:
    * ```jsx
    * <ExpandableMenuItem>
    *   <ExpandableMenuItemTrigger>Parent menu item</ExpandableMenuItemTrigger>
    *   <ExpandableMenuItemContent>
    *     <ButtonMenuItem>Item 1</ButtonMenuItem>
    *     <ButtonMenuItem>Item 2</ButtonMenuItem>
    *   </ExpandableMenuItemContent>
    * </ExpandableMenuItem>
    * ```
    */ 
const $417a895b4429e145$export$341dea48c30b36ff = /*#__PURE__*/ (0, $42omo.forwardRef)(({ isExpanded: isExpandedControlled, isDefaultExpanded: isDefaultExpanded = false, onExpansionToggle: onExpansionToggle, children: children, dropIndicator: dropIndicator, testId: testId }, forwardedRef)=>{
    const [isExpanded, setIsExpanded] = (0, $6mkwk.default)(isExpandedControlled, ()=>isDefaultExpanded);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6BXcn.IsExpandedContext).Provider, {
        value: isExpanded,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $6BXcn.SetIsExpandedContext).Provider, {
            value: setIsExpanded,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $6BXcn.OnExpansionToggleContext).Provider, {
                value: onExpansionToggle ?? null,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $jvL0g.MenuListItem), {
                    ref: forwardedRef,
                    testId: testId,
                    children: /*#__PURE__*/ (0, $l998X.jsxs)("div", {
                        className: (0, $gMc0m.default)([
                            dropIndicator && $417a895b4429e145$var$relativeStyles.root
                        ]),
                        children: [
                            children,
                            dropIndicator
                        ]
                    })
                })
            })
        })
    });
});
module.exports["ExpandableMenuItem"] = $417a895b4429e145$export$341dea48c30b36ff;

});

parcelRegister("YQCfa", function(module, exports) {
/* expandable-menu-item-content.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $1bHXt = parcelRequire("1bHXt");


var $aJT7b = parcelRequire("aJT7b");


var $6BXcn = parcelRequire("6BXcn");

const $73667a40c01a69a2$var$styles = {
    content: "_bozg1crf",
    collapsedContent: "_1e0cglyw"
};
const $73667a40c01a69a2$export$bd680a81504a92e9 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children }, forwardedRef)=>{
    const isExpanded = (0, $6BXcn.useIsExpanded)();
    const level = (0, $6BXcn.useLevel)();
    const hasExpanded = (0, $42omo.useRef)(false);
    const areAllAncestorsExpanded = (0, $6BXcn.useAreAllAncestorsExpanded)();
    if (!isExpanded && !hasExpanded.current) return null;
    hasExpanded.current = true;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6BXcn.LevelContext).Provider, {
        value: level + 1,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $6BXcn.AreAllAncestorsExpandedContext).Provider, {
            value: /**
     * By combining the current ancestor and with the current menu item's state, all nested menu items will know if their
     * ancestor menu items are all expanded.
     */ areAllAncestorsExpanded && isExpanded,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aJT7b.List), {
                ref: forwardedRef,
                xcss: (0, $1bHXt.cx)($73667a40c01a69a2$var$styles.content, !isExpanded && $73667a40c01a69a2$var$styles.collapsedContent),
                children: children
            })
        })
    });
});
module.exports["ExpandableMenuItemContent"] = $73667a40c01a69a2$export$bd680a81504a92e9;

});

parcelRegister("8INvs", function(module, exports) {
/* expandable-menu-item-trigger.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $1qfLF = parcelRequire("1qfLF");


var $3hoG4 = parcelRequire("3hoG4");


var $ghftu = parcelRequire("ghftu");


var $6R5uz = parcelRequire("6R5uz");


var $dh538 = parcelRequire("dh538");


var $8njHX = parcelRequire("8njHX");


var $fDC7w = parcelRequire("fDC7w");


var $6BXcn = parcelRequire("6BXcn");

const $675a107b26f743ab$var$chevronDisplayCssVar = '--expandable-chevron-display';
const $675a107b26f743ab$var$providedElemBeforeDisplayCssVar = '--expandable-provided-elembefore-display';
const $675a107b26f743ab$var$wrapperStyles = {
    root: "_1mmi1txw _165nglyw",
    showProvidedElemBefore: "_1mmiglyw _165n1bgi _v9u71txw _1hl9glyw _b31z1txw _1vnl1txw _12xsglyw _p8btglyw"
};
const $675a107b26f743ab$var$nestedOpenPopupStylesOld = {
    showProvidedElemBefore: "_v9u71txw _1hl9glyw"
}; // Merge back into the `wrapperStyles` after cleanup
const $675a107b26f743ab$var$nestedOpenPopupStylesNew = {
    showProvidedElemBefore: "_1ddp1txw _pnu5glyw"
};
const $675a107b26f743ab$var$iconStyles = {
    chevron: "_1e0ciw0t _1tz3r0mg",
    providedElemBefore: "_1e0c1xb2",
    providedElemBeforeSelected: "_syazxl6c"
};
const $675a107b26f743ab$var$ExpandableMenuItemIcon = ({ iconProps: iconProps, isExpanded: isExpanded, isSelected: isSelected, providedElemBefore: providedElemBefore })=>{
    const ChevronIcon = isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($ghftu))) : (0, (/*@__PURE__*/$parcel$interopDefault($6R5uz)));
    const chevronElem = /*#__PURE__*/ (0, $l998X.jsx)(ChevronIcon, {
        ...iconProps,
        label: "",
        color: isSelected ? "var(--ds-icon-selected, #1868DB)" : undefined,
        size: "small"
    });
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("div", {
                className: (0, $gMc0m.default)([
                    $675a107b26f743ab$var$iconStyles.chevron
                ]),
                children: chevronElem
            }),
            providedElemBefore && /*#__PURE__*/ (0, $l998X.jsx)("div", {
                className: (0, $gMc0m.default)([
                    $675a107b26f743ab$var$iconStyles.providedElemBefore,
                    isSelected && $675a107b26f743ab$var$iconStyles.providedElemBeforeSelected
                ]),
                children: providedElemBefore
            })
        ]
    });
};
const $675a107b26f743ab$export$fe6fe51056867f4d = (0, $3hoG4.default)(({ actions: actions, isSelected: isSelected, href: href, elemBefore: providedElemBefore, elemAfter: elemAfter, actionsOnHover: actionsOnHover, onClick: onClick, children: children, testId: testId, interactionName: interactionName, isContentTooltipDisabled: isContentTooltipDisabled, visualContentRef: visualContentRef, isDragging: isDragging, hasDragIndicator: hasDragIndicator, dropIndicator: dropIndicator }, forwardedRef)=>{
    const id = (0, $42omo.useId)();
    const onExpansionToggle = (0, $6BXcn.useOnExpansionToggle)();
    const isExpanded = (0, $6BXcn.useIsExpanded)();
    const setIsExpanded = (0, $6BXcn.useSetIsExpanded)();
    const itemRef = (0, $42omo.useRef)(null);
    const handleIconClick = (0, $42omo.useCallback)(()=>{
        onExpansionToggle?.(!isExpanded);
        setIsExpanded(!isExpanded);
    }, [
        isExpanded,
        onExpansionToggle,
        setIsExpanded
    ]);
    const handleMenuContentClick = (0, $42omo.useCallback)((event, analyticsEvent)=>{
        const newValue = !isExpanded;
        onClick?.(event, analyticsEvent, {
            isExpanded: newValue
        });
        onExpansionToggle?.(newValue);
        setIsExpanded(newValue);
    }, [
        onClick,
        onExpansionToggle,
        isExpanded,
        setIsExpanded
    ]);
    const isSelectable = typeof href !== 'undefined';
    (0, $fDC7w.useScrollMenuItemIntoView)({
        elementRef: itemRef,
        isSelected: Boolean(isSelectable && isSelected)
    }); // Wrapped in an IconButton if the expandable menu item trigger is selectable
    const elemBefore = isSelectable ? /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
        icon: (iconProps)=>/*#__PURE__*/ (0, $l998X.jsx)($675a107b26f743ab$var$ExpandableMenuItemIcon, {
                iconProps: iconProps,
                isExpanded: isExpanded,
                isSelected: isSelected,
                providedElemBefore: providedElemBefore
            }),
        "aria-expanded": isExpanded,
        // screen readers on what will actually be expanded or collapsed. Screen readers will also use the
        // `aria-expanded` attribute to indicate the expanded state of the menu item.
        // We are not using the `aria-label` attribute here as it is not supported by the `IconButton` component.
        "aria-labelledby": id,
        // `aria-labelledby`, which will be used instead.
        label: "",
        appearance: "subtle",
        spacing: "compact",
        onClick: handleIconClick,
        interactionName: interactionName,
        testId: testId ? `${testId}--elem-before-button` : undefined
    }) : /*#__PURE__*/ (0, $l998X.jsx)($675a107b26f743ab$var$ExpandableMenuItemIcon, {
        isExpanded: isExpanded,
        isSelected: isSelected,
        providedElemBefore: providedElemBefore
    }); // For expandable menu items, we shouldn't wrap in a `li` here. The `li` is instead at a higher level (`ExpandableMenuItem`), grouping the expandable menu item trigger and its content
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        ref: itemRef,
        className: (0, $gMc0m.default)([
            $675a107b26f743ab$var$wrapperStyles.root,
            providedElemBefore && $675a107b26f743ab$var$wrapperStyles.showProvidedElemBefore,
            (0, $dh538.fg)('platform_dst_nav4_flyout_menu_slots_close_button') ? $675a107b26f743ab$var$nestedOpenPopupStylesNew.showProvidedElemBefore : $675a107b26f743ab$var$nestedOpenPopupStylesOld.showProvidedElemBefore
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $8njHX.MenuItemBase), {
            id: id,
            actions: actions,
            actionsOnHover: actionsOnHover,
            elemBefore: elemBefore,
            ariaExpanded: isExpanded,
            elemAfter: elemAfter,
            href: href,
            isSelected: isSelected,
            onClick: handleMenuContentClick,
            ref: forwardedRef,
            visualContentRef: visualContentRef,
            testId: testId,
            interactionName: interactionName,
            isContentTooltipDisabled: isContentTooltipDisabled,
            isDragging: isDragging,
            hasDragIndicator: hasDragIndicator,
            dropIndicator: dropIndicator,
            children: children
        })
    });
});
module.exports["ExpandableMenuItemTrigger"] = $675a107b26f743ab$export$fe6fe51056867f4d;

});

parcelRegister("3b6WO", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $aXWIB = parcelRequire("aXWIB");


var $42omo = parcelRequire("42omo");


var $9wGTI = parcelRequire("9wGTI");


var $dTb09 = parcelRequire("dTb09");


var $7zIsq = parcelRequire("7zIsq");


var $ep3mz = parcelRequire("ep3mz");


var $bQm3c = parcelRequire("bQm3c");


var $kqIWy = parcelRequire("kqIWy");


var $bFDX4 = parcelRequire("bFDX4");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $6qkXi = parcelRequire("6qkXi");

const $8eb9026be26e0c85$export$cab421e039d23b2 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(18);
    const { moduleType: moduleType, queryOptions: queryOptions, returnBlockedExtensions: t1, skipQuery: t2, spaceContextOnly: spaceContextOnly } = t0;
    const returnBlockedExtensions = t1 === undefined ? false : t1;
    const skipQuery = t2 === undefined ? false : t2;
    const { locale: locale } = (0, $aXWIB.useIntl)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { error: spaceError } = (0, $kqIWy.useSpaceDetail)(spaceKey);
    let t3;
    if ($[0] !== cloudId || $[1] !== contentId || $[2] !== locale || $[3] !== moduleType || $[4] !== queryOptions || $[5] !== returnBlockedExtensions || $[6] !== skipQuery || $[7] !== spaceContextOnly || $[8] !== spaceKey) {
        t3 = (0, $6qkXi.getUsePrefilteredExtensionListOptions)({
            cloudId: cloudId,
            locale: locale,
            moduleType: moduleType,
            queryOptions: {
                ...queryOptions,
                skip: skipQuery
            },
            includeHidden: returnBlockedExtensions,
            spaceKey: spaceKey,
            contentId: contentId,
            spaceContextOnly: spaceContextOnly
        });
        $[0] = cloudId;
        $[1] = contentId;
        $[2] = locale;
        $[3] = moduleType;
        $[4] = queryOptions;
        $[5] = returnBlockedExtensions;
        $[6] = skipQuery;
        $[7] = spaceContextOnly;
        $[8] = spaceKey;
        $[9] = t3;
    } else t3 = $[9];
    const options = t3;
    const { extensions: extsData, loading: extsLoading, error: extsError } = $8eb9026be26e0c85$var$usePrefilteredExtensionList(options);
    let t4;
    let t5;
    if ($[10] !== extsError || $[11] !== spaceError) {
        t4 = ()=>{
            if (extsError && (0, $1uFM6.isUnauthorizedError)(extsError)) (0, $7Sm4c.markErrorAsHandled)(extsError);
            if ((0, $bFDX4.isTooManyRequestsError)(extsError)) (0, $7Sm4c.markErrorAsHandled)(extsError);
            if (spaceError) (0, $7Sm4c.markErrorAsHandled)(spaceError);
        };
        t5 = [
            extsError,
            spaceError
        ];
        $[10] = extsError;
        $[11] = spaceError;
        $[12] = t4;
        $[13] = t5;
    } else {
        t4 = $[12];
        t5 = $[13];
    }
    (0, $42omo.useEffect)(t4, t5);
    let t6;
    if ($[14] !== extsData || $[15] !== extsError || $[16] !== extsLoading) {
        t6 = {
            extensions: extsData,
            loading: extsLoading,
            error: extsError
        };
        $[14] = extsData;
        $[15] = extsError;
        $[16] = extsLoading;
        $[17] = t6;
    } else t6 = $[17];
    return t6;
} : ({ moduleType: moduleType, queryOptions: queryOptions, returnBlockedExtensions: returnBlockedExtensions = false, skipQuery: skipQuery = false, spaceContextOnly: spaceContextOnly })=>{
    const { locale: locale } = (0, $aXWIB.useIntl)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { error: spaceError } = (0, $kqIWy.useSpaceDetail)(spaceKey);
    const options = (0, $42omo.useMemo)(()=>(0, $6qkXi.getUsePrefilteredExtensionListOptions)({
            cloudId: cloudId,
            locale: locale,
            moduleType: moduleType,
            queryOptions: {
                ...queryOptions,
                skip: skipQuery
            },
            includeHidden: returnBlockedExtensions,
            spaceKey: spaceKey,
            contentId: contentId,
            spaceContextOnly: spaceContextOnly
        }), [
        cloudId,
        locale,
        moduleType,
        queryOptions,
        returnBlockedExtensions,
        skipQuery,
        spaceKey,
        contentId,
        spaceContextOnly
    ]);
    const { extensions: extsData, loading: extsLoading, error: extsError } = $8eb9026be26e0c85$var$usePrefilteredExtensionList(options);
    (0, $42omo.useEffect)(()=>{
        // suppress 403 errors as we can't do much with them
        if (extsError && (0, $1uFM6.isUnauthorizedError)(extsError)) (0, $7Sm4c.markErrorAsHandled)(extsError);
        // suppress 429 errors for offending users
        if ((0, $bFDX4.isTooManyRequestsError)(extsError)) (0, $7Sm4c.markErrorAsHandled)(extsError);
        if (spaceError) (0, $7Sm4c.markErrorAsHandled)(spaceError);
    }, [
        extsError,
        spaceError
    ]);
    return {
        extensions: extsData,
        loading: extsLoading,
        error: extsError
    };
};
const $8eb9026be26e0c85$var$usePrefilteredExtensionList = (0, $dTb09.conditionalHooksFactory)(()=>(0, $9wGTI.fg)('forge-ui-migrate-extension-list-query-to-relay'), (0, $7zIsq.usePrefilteredExtensionListRelay), (0, $7zIsq.usePrefilteredExtensionList));
module.exports["useExtensionList"] = $8eb9026be26e0c85$export$cab421e039d23b2;

});

parcelRegister("dTb09", function(module, exports) {
// Shorthand alias for the global cache map key because it's (intentionally) a long name
const $7b24741974f5c34f$var$CACHE_MAP_KEY = '__conditionalHooksFactory_conditionCacheMap_dont_modify_this_manually_unless_you_want_react_to_blow_up';
// Initialize the global cache map once
globalThis[$7b24741974f5c34f$var$CACHE_MAP_KEY] = globalThis[$7b24741974f5c34f$var$CACHE_MAP_KEY] || new WeakMap();
function $7b24741974f5c34f$export$e328888e5cffce88() {
    globalThis[$7b24741974f5c34f$var$CACHE_MAP_KEY] = new WeakMap();
}
function $7b24741974f5c34f$export$691e93bad45e6f07(condition, newHook, oldHook) {
    const hookFn = (...args)=>{
        // call each time so we can track exposures
        const conditionResult = condition();
        const cache = globalThis[$7b24741974f5c34f$var$CACHE_MAP_KEY];
        if (!cache.has(hookFn)) cache.set(hookFn, conditionResult);
        if (cache.get(hookFn)) return newHook(...args);
        else return oldHook(...args);
    };
    return hookFn;
}
module.exports["conditionalHooksFactory"] = $7b24741974f5c34f$export$691e93bad45e6f07;

});

parcelRegister("bFDX4", function(module, exports) {

var $aMcHK = parcelRequire("aMcHK");

const $8182af0d2f396edd$export$5df30e64c619846d = (error)=>(0, $aMcHK.isStatusCodeError)(error, '429');
module.exports["isTooManyRequestsError"] = $8182af0d2f396edd$export$5df30e64c619846d;

});

parcelRegister("6qkXi", function(module, exports) {

var $gKr8t = parcelRequire("gKr8t");

const $26379cee560cb131$export$4b3c44afb1a70b38 = ({ cloudId: cloudId, locale: locale, moduleType: moduleType, queryOptions: queryOptions, includeHidden: includeHidden, spaceKey: spaceKey, contentId: contentId, spaceContextOnly: spaceContextOnly = false })=>{
    const options = {
        client: (0, $gKr8t.getAGGClient)(),
        cloudId: cloudId,
        types: [
            moduleType
        ],
        queryOptions: {
            ...queryOptions
        },
        locale: locale,
        context: spaceContextOnly ? {
            spaceKey: spaceKey
        } : {
            spaceKey: spaceKey,
            contentId: contentId
        },
        includeHidden: includeHidden
    };
    return options;
};
module.exports["getUsePrefilteredExtensionListOptions"] = $26379cee560cb131$export$4b3c44afb1a70b38;

});

parcelRegister("9fBoq", function(module, exports) {
parcelRequire("1c598");
var $1Aku8 = parcelRequire("1Aku8");

const $6ca0453d93f30f16$var$capitalize = (str)=>{
    if (!str || !str.length) return '';
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};
const $6ca0453d93f30f16$export$9dd0cb91ff7c8b7e = (extension, overriddenTitle)=>{
    const title = overriddenTitle || extension.properties.title;
    const { environmentType: environmentType, environmentKey: environmentKey } = extension;
    if (environmentType === (0, $1Aku8.ProductEnvironment).PRODUCTION) return title;
    if (environmentType === (0, $1Aku8.ProductEnvironment).DEVELOPMENT && environmentKey !== 'default') return `${title} - ${environmentKey} (Dev)`;
    return `${title} (${$6ca0453d93f30f16$var$capitalize(environmentType)})`;
};
module.exports["extensionTitle"] = $6ca0453d93f30f16$export$9dd0cb91ff7c8b7e;

});

parcelRegister("1c598", function(module, exports) {
$parcel$export(module.exports, "ProductEnvironment", () => (parcelRequire("1Aku8")).ProductEnvironment);
$parcel$export(module.exports, "ForgeCDNEnvironment", () => (parcelRequire("1Aku8")).ForgeCDNEnvironment);
$parcel$export(module.exports, "ExtensionEnvironment", () => (parcelRequire("2JC3k")).ExtensionEnvironment);
$parcel$export(module.exports, "ConfluenceExtension", () => (parcelRequire("2JC3k")).ConfluenceExtension);
$parcel$export(module.exports, "JiraExtension", () => (parcelRequire("2JC3k")).JiraExtension);
parcelRequire("i3Ypo");
var $2JC3k = parcelRequire("2JC3k");
var $1Aku8 = parcelRequire("1Aku8");

parcelRequire("jUCNB");
var $gUjm2 = parcelRequire("gUjm2");
var $kg3OT = parcelRequire("kg3OT");
var $fsQJy = parcelRequire("fsQJy");


});

parcelRegister("i3Ypo", function(module, exports) {
$parcel$export(module.exports, "ProductEnvironment", () => (parcelRequire("1Aku8")).ProductEnvironment);
$parcel$export(module.exports, "ForgeCDNEnvironment", () => (parcelRequire("1Aku8")).ForgeCDNEnvironment);
$parcel$export(module.exports, "ConfluenceExtension", () => (parcelRequire("2JC3k")).ConfluenceExtension);
$parcel$export(module.exports, "ExtensionEnvironment", () => (parcelRequire("2JC3k")).ExtensionEnvironment);
$parcel$export(module.exports, "JiraExtension", () => (parcelRequire("2JC3k")).JiraExtension);

var $9dbGT = parcelRequire("9dbGT");


var $1Aku8 = parcelRequire("1Aku8");


var $6sM2K = parcelRequire("6sM2K");


var $2JC3k = parcelRequire("2JC3k");


});

parcelRegister("9dbGT", function(module, exports) {
const $1ec3e8240f57817b$export$3b98ab6402702476 = [
    'Em',
    'Link',
    'Strike',
    'String',
    'Strong',
    'User'
];
const $1ec3e8240f57817b$export$3ee8c58bb87b9685 = [
    ...$1ec3e8240f57817b$export$3b98ab6402702476,
    'Badge',
    'Code',
    'DateLozenge',
    'StatusLozenge',
    'Tag',
    'UserGroup'
];

});

parcelRegister("1Aku8", function(module, exports) {
var $d128cc36ec70c56c$export$2688cec3c24cb60b = /*#__PURE__*/ function(ProductEnvironment) {
    ProductEnvironment["DEVELOPMENT"] = "DEVELOPMENT";
    ProductEnvironment["STAGING"] = "STAGING";
    ProductEnvironment["PRODUCTION"] = "PRODUCTION";
    return ProductEnvironment;
}({});
var $d128cc36ec70c56c$export$beaef1891b3e7ca3 = /*#__PURE__*/ function(ForgeCDNEnvironment) {
    ForgeCDNEnvironment["DEVELOPMENT"] = "dev";
    ForgeCDNEnvironment["STAGING"] = "stg";
    ForgeCDNEnvironment["PRODUCTION"] = "prod";
    return ForgeCDNEnvironment;
}({});
module.exports["ProductEnvironment"] = $d128cc36ec70c56c$export$2688cec3c24cb60b;
module.exports["ForgeCDNEnvironment"] = $d128cc36ec70c56c$export$beaef1891b3e7ca3;

});

parcelRegister("6sM2K", function(module, exports) {
const $0e3337cb4407ef3b$export$21b318cfdd670495 = (error)=>({
        type: 'render',
        aux: {
            type: 'View',
            children: [
                {
                    type: 'ErrorPanel',
                    props: {
                        error: error
                    },
                    children: []
                }
            ]
        },
        state: {}
    });

});

parcelRegister("2JC3k", function(module, exports) {
var $d977f97374f9d2c9$export$6e95f5308d9156f9 = /*#__PURE__*/ function(ExtensionEnvironment) {
    ExtensionEnvironment["DEVELOPMENT"] = "DEVELOPMENT";
    ExtensionEnvironment["STAGING"] = "STAGING";
    ExtensionEnvironment["PRODUCTION"] = "PRODUCTION";
    return ExtensionEnvironment;
}({});
const $d977f97374f9d2c9$export$9a2372818e2520c6 = {
    BYLINE: 'confluence:contentBylineItem',
    CONTEXT_MENU: 'confluence:contextMenu',
    CONTENT_ACTION: 'confluence:contentAction',
    FULL_PAGE: 'confluence:fullPage',
    GLOBAL_PAGE: 'confluence:globalPage',
    GLOBAL_SETTINGS: 'confluence:globalSettings',
    HOMEPAGE_FEED: 'confluence:homepageFeed',
    SPACE_PAGE: 'confluence:spacePage',
    SPACE_SETTINGS: 'confluence:spaceSettings',
    CUSTOM_CONTENT: 'confluence:customContent',
    MACRO: 'xen:macro',
    TEST_MODULE: 'test:module'
};
const $d977f97374f9d2c9$export$f06ffa3aa6bfec95 = {
    BACKLOG_ACTION: 'jira:backlogAction',
    BOARD_ACTION: 'jira:boardAction',
    PERSONAL_SETTINGS_PAGE: 'jira:personalSettingsPage',
    FULL_PAGE: 'jira:fullPage',
    ISSUE_PANEL: 'jira:issuePanel',
    ISSUE_ACTION: 'jira:issueAction',
    ISSUE_GLANCE: 'jira:issueGlance',
    ISSUE_CONTEXT: 'jira:issueContext',
    ISSUE_ACTIVITY: 'jira:issueActivity',
    UI_MODIFICATIONS: 'jira:uiModifications',
    CUSTOM_FIELD: 'jira:customField',
    CUSTOM_FIELD_TYPE: 'jira:customFieldType',
    ADMIN_PAGE: 'jira:adminPage',
    GLOBAL_PAGE: 'jira:globalPage',
    PROJECT_PAGE: 'jira:projectPage',
    PROJECT_SETTINGS_PAGE: 'jira:projectSettingsPage',
    DASHBOARD_BACKGROUND_SCRIPT: 'jira:dashboardBackgroundScript',
    ISSUE_VIEW_BACKGROUND_SCRIPT: 'jira:issueViewBackgroundScript',
    DASHBOARD_GADGET: 'jira:dashboardGadget',
    WORKFLOW_VALIDATOR: 'jira:workflowValidator',
    WORKFLOW_CONDITION: 'jira:workflowCondition',
    WORKFLOW_POST_FUNCTION: 'jira:workflowPostFunction',
    SERVICE_DESK_QUEUE_PAGE: 'jiraServiceManagement:queuePage',
    SERVICE_DESK_ORGANIZATION_PANEL: 'jiraServiceManagement:organizationPanel'
};
module.exports["ExtensionEnvironment"] = $d977f97374f9d2c9$export$6e95f5308d9156f9;
module.exports["ConfluenceExtension"] = $d977f97374f9d2c9$export$9a2372818e2520c6;
module.exports["JiraExtension"] = $d977f97374f9d2c9$export$f06ffa3aa6bfec95;

});

parcelRegister("jUCNB", function(module, exports) {

var $fsQJy = parcelRequire("fsQJy");


var $kg3OT = parcelRequire("kg3OT");


var $gUjm2 = parcelRequire("gUjm2");


});

parcelRegister("fsQJy", function(module, exports) {
// DELETE FILE http://go/j/FUI-1091
const $8d78496ee677e86d$export$7e816460364ed464 = (effect)=>{
    return effect.type === 'initialize';
};
const $8d78496ee677e86d$export$eb5bd7f371e458af = (effect)=>{
    return effect.type === 'action';
};
const $8d78496ee677e86d$export$f632ad3064955f31 = (effect)=>{
    return effect.type === 'event';
};
const $8d78496ee677e86d$export$dfeb34e64fee2572 = (effect)=>{
    return effect.type === 'render';
};
function $8d78496ee677e86d$export$20b9f6acb0888554(effect) {
    return $8d78496ee677e86d$export$7e816460364ed464(effect) || $8d78496ee677e86d$export$eb5bd7f371e458af(effect) || $8d78496ee677e86d$export$f632ad3064955f31(effect);
}

});

parcelRegister("kg3OT", function(module, exports) {
const $bc3454970f51a505$export$709a27a9f80556b8 = (effect)=>{
    return effect.type === 'event';
};
const $bc3454970f51a505$export$65d7078e01574f24 = (effect)=>{
    return effect.type === 'action';
};
const $bc3454970f51a505$export$8089f608f1d0c22d = (effect)=>{
    return effect.type === 'render';
};
const $bc3454970f51a505$export$84909efba3133df = (effect)=>{
    return effect.type === 'result';
};
function $bc3454970f51a505$export$caa8cab0db5b0a61(effect) {
    return $bc3454970f51a505$export$65d7078e01574f24(effect) || $bc3454970f51a505$export$709a27a9f80556b8(effect) || $bc3454970f51a505$export$8089f608f1d0c22d(effect);
}

});

parcelRegister("gUjm2", function(module, exports) {
// From forge.ts
const $ce9f8921033c0d6d$export$3ab8eca5875a9c7e = (auxNode)=>{
    return auxNode !== null && typeof auxNode !== 'boolean' && auxNode !== undefined;
};
var $ce9f8921033c0d6d$export$c8914e6b1e019577 = /*#__PURE__*/ function(EcosystemLicenseMode) {
    EcosystemLicenseMode["USER_ACCESS"] = "USER_ACCESS";
    return EcosystemLicenseMode;
}({});
const $ce9f8921033c0d6d$export$a3b8d8814f1b9262 = (context)=>context.type === 'jira';
const $ce9f8921033c0d6d$export$d8e8de7bd6b731b7 = (extensionContext)=>extensionContext.type === 'issuePanel';
const $ce9f8921033c0d6d$export$1404d10ac8f82a03 = (extensionContext)=>extensionContext.type === 'contextConfig';
const $ce9f8921033c0d6d$export$9e5e0ca9e718a261 = (extensionContext)=>extensionContext.type === 'customField' || extensionContext.type === 'customFieldType';
const $ce9f8921033c0d6d$export$2f4ddb77a2467d4a = (extensionContext)=>extensionContext.type === 'contextMenu';
const $ce9f8921033c0d6d$export$dfe2b8f5623b1a39 = (extensionContext)=>extensionContext.type === 'contentAction';
const $ce9f8921033c0d6d$export$aee7a41cc3ed0e4 = (extensionContext)=>extensionContext.type === 'dashboardGadget';
var $ce9f8921033c0d6d$export$24835b97bd9481e3 = /*#__PURE__*/ function(CompassContextTypes) {
    CompassContextTypes["AdminPage"] = "compass:adminPage";
    CompassContextTypes["ComponentPage"] = "compass:componentPage";
    CompassContextTypes["TeamPage"] = "compass:teamPage";
    CompassContextTypes["ComponentImporter"] = "compass:componentImporter";
    return CompassContextTypes;
}({});
var $ce9f8921033c0d6d$export$1718b7e1799fa866 = /*#__PURE__*/ function(RenderingLocations) {
    RenderingLocations["AppConfigurationPage"] = "appConfigurationPage";
    RenderingLocations["OnboardingFlow"] = "onboardingFlow";
    return RenderingLocations;
}({});

});

parcelRegister("5tgcI", function(module, exports) {
const $696759caf06ef68c$export$af39e4edc5e74 = 'com.atlassian.confluence.plugins.confluence-space-ia:header-spaces-link';
const $696759caf06ef68c$export$97c436ccc42cbac9 = 'com.atlassian.confluence.plugins.confluence-space-ia:header-people-link';
const $696759caf06ef68c$export$3a7ae658938afc39 = 'com.atlassian.plugins.atlassian-connect-plugin:com.atlassian.confluence.emcee__enduser-discover';
const $696759caf06ef68c$export$ee99bc1ad01a63ae = 'com.atlassian.confluence.plugins.confluence-space-ia:header-automation-link';
const $696759caf06ef68c$export$8a23ae6ca6b0c9ee = 'com.atlassian.confluence.extra.team-calendars:header-mycalendar-link';
const $696759caf06ef68c$export$38788381122702f5 = 'com.atlassian.plugins.atlassian-connect-plugin:com.addonengine.analytics__analytics-instance-settings-menu-item-adg3';
const $696759caf06ef68c$export$6c3d789a4f56bea2 = 'com.atlassian.plugins.atlassian-connect-plugin:com.addonengine.analytics.moderate__analytics-instance-settings-menu-item-adg3';
module.exports["SPACES_KEY"] = $696759caf06ef68c$export$af39e4edc5e74;
module.exports["PEOPLE_KEY"] = $696759caf06ef68c$export$97c436ccc42cbac9;
module.exports["DISCOVER_KEY"] = $696759caf06ef68c$export$3a7ae658938afc39;
module.exports["AUTOMATION_KEY"] = $696759caf06ef68c$export$ee99bc1ad01a63ae;
module.exports["CALENDAR_KEY"] = $696759caf06ef68c$export$8a23ae6ca6b0c9ee;
module.exports["ANALYTICS_KEY"] = $696759caf06ef68c$export$38788381122702f5;
module.exports["ANALYTICS_KEY_MODERATE"] = $696759caf06ef68c$export$6c3d789a4f56bea2;

});

parcelRegister("g0ob9", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $jdPfT = parcelRequire("jdPfT");


var $fxBfz = parcelRequire("fxBfz");


var $8DN9t = parcelRequire("8DN9t");


var $cyLm6 = parcelRequire("cyLm6");


var $5tgcI = parcelRequire("5tgcI");

const $e8563bcd391eebd4$var$iconOverrides = {
    [(0, $5tgcI.AUTOMATION_KEY)]: (0, (/*@__PURE__*/$parcel$interopDefault($fxBfz))),
    [(0, $5tgcI.CALENDAR_KEY)]: (0, (/*@__PURE__*/$parcel$interopDefault($8DN9t))),
    [(0, $5tgcI.ANALYTICS_KEY)]: (0, (/*@__PURE__*/$parcel$interopDefault($cyLm6))),
    [(0, $5tgcI.ANALYTICS_KEY_MODERATE)]: (0, (/*@__PURE__*/$parcel$interopDefault($cyLm6)))
};
const $e8563bcd391eebd4$export$5153830bdfb71453 = (t0)=>{
    const $ = (0, $frIzR.c)(7);
    const { url: url, completeKey: completeKey } = t0;
    if (completeKey) {
        const IconOverride = $e8563bcd391eebd4$var$iconOverrides[completeKey];
        if (IconOverride) {
            let t1;
            if ($[0] !== IconOverride) {
                t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(IconOverride, null);
                $[0] = IconOverride;
                $[1] = t1;
            } else t1 = $[1];
            return t1;
        }
    }
    if (!url) {
        let t1;
        if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jdPfT))), {
                label: "",
                color: "currentColor"
            });
            $[2] = t1;
        } else t1 = $[2];
        return t1;
    }
    let t1;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("filter", {
            id: "changeFillColor"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("feColorMatrix", {
            type: "matrix",
            values: "0.02, 0, 0, 0, 0, 0, 0.04, 0, 0, 0, 0, 0, 0.07, 0, 0, 0, 0, 0, 1, 0"
        })));
        $[3] = t1;
    } else t1 = $[3];
    const t2 = $e8563bcd391eebd4$var$isSvg(url) ? "url(#changeFillColor)" : "";
    let t3;
    if ($[4] !== t2 || $[5] !== url) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
            viewBox: "0 0 16 16",
            width: "16",
            height: "16",
            "aria-hidden": "true",
            "data-testid": "app-icon"
        }, t1, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("image", {
            xmlnsXlink: "http://www.w3.org/1999/xlink",
            xlinkHref: url,
            width: "16",
            height: "16",
            x: "0",
            y: "0",
            filter: t2
        }));
        $[4] = t2;
        $[5] = url;
        $[6] = t3;
    } else t3 = $[6];
    return t3;
};
const $e8563bcd391eebd4$var$isSvg = (url)=>{
    const fileType = url.split(/\#|\?/)[0].split('.').pop();
    return !!fileType && fileType.trim() === 'svg';
};
module.exports["AppIcon"] = $e8563bcd391eebd4$export$5153830bdfb71453;

});

parcelRegister("2yoLO", function(module, exports) {

let $1dc1f892a40525fc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1dc1f892a40525fc$var$load("9jGiN").then(()=>parcelRequire('kvRiJ'));

});

parcelRegister("h8IEo", function(module, exports) {

let $c7a5d1aa3c18c86a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c7a5d1aa3c18c86a$var$load("SepNY").then(()=>parcelRequire('7vGOX'));

});

parcelRegister("8dUjs", function(module, exports) {

var $d9tcB = parcelRequire("d9tcB");


var $eSLr0 = parcelRequire("eSLr0");


var $7Ndnw = parcelRequire("7Ndnw");


var $5tgcI = parcelRequire("5tgcI");

const $84cd59e06a85be4f$export$a9c446837cd59ef8 = [
    (0, $5tgcI.SPACES_KEY),
    (0, $5tgcI.PEOPLE_KEY),
    (0, $5tgcI.DISCOVER_KEY)
];
const $84cd59e06a85be4f$export$a56df56fab66279e = ({ edition: edition, accessStatus: accessStatus })=>{
    const isAdmin = accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS;
    const hideAutomation = edition !== 'PREMIUM' || !isAdmin;
    const notAllowedWebItems = [
        ...$84cd59e06a85be4f$export$a9c446837cd59ef8,
        hideAutomation ? (0, $5tgcI.AUTOMATION_KEY) : ''
    ];
    return {
        webItemParams: {
            location: (0, $eSLr0.SYSTEM_HEADER_LEFT),
            notAllowedWebItems: notAllowedWebItems
        },
        forgeExtensionParams: {
            moduleType: (0, $7Ndnw.FORGE_MODULE_GLOBAL_PAGE),
            spaceKey: ''
        }
    };
};
module.exports["getGlobalAppsParams"] = $84cd59e06a85be4f$export$a56df56fab66279e;

});

parcelRegister("7Ndnw", function(module, exports) {
const $af2b0e533822f413$export$77aa6bcc53373193 = 'confluence:contentBylineItem';
const $af2b0e533822f413$export$dfd79dc5aae7414d = 'confluence:contextMenu';
const $af2b0e533822f413$export$93827e7f1bb6974c = 'confluence:contentAction';
const $af2b0e533822f413$export$6a8e7521883fbbdb = 'confluence:fullPage';
const $af2b0e533822f413$export$931827627b89a6ba = 'confluence:globalPage';
const $af2b0e533822f413$export$109ae14a8174901f = 'confluence:globalSettings';
const $af2b0e533822f413$export$e31530da5c277984 = 'confluence:homepageFeed';
const $af2b0e533822f413$export$54edc26d40e1a8eb = 'confluence:pageBanner';
const $af2b0e533822f413$export$75695e15f2aab495 = 'confluence:spacePage';
const $af2b0e533822f413$export$f17386882264cfae = 'confluence:spaceSettings';
const $af2b0e533822f413$export$3e9f3e416c5066aa = 'confluence:customContent';
const $af2b0e533822f413$export$b9c5c98eb97dff92 = 'confluence:backgroundScript';
const $af2b0e533822f413$export$c0df8ab57c5edc2a = 'test:module';
const $af2b0e533822f413$export$769f3a278705a683 = 'xen:macro';
const $af2b0e533822f413$export$492ceb220fc48ad2 = [
    $af2b0e533822f413$export$6a8e7521883fbbdb,
    $af2b0e533822f413$export$931827627b89a6ba,
    $af2b0e533822f413$export$109ae14a8174901f,
    $af2b0e533822f413$export$e31530da5c277984,
    $af2b0e533822f413$export$b9c5c98eb97dff92
];
const $af2b0e533822f413$export$ec6cdf0e930aca0a = [
    $af2b0e533822f413$export$75695e15f2aab495,
    $af2b0e533822f413$export$f17386882264cfae,
    $af2b0e533822f413$export$3e9f3e416c5066aa
];
const $af2b0e533822f413$export$344b997b63ff6612 = [
    $af2b0e533822f413$export$77aa6bcc53373193,
    $af2b0e533822f413$export$dfd79dc5aae7414d,
    $af2b0e533822f413$export$93827e7f1bb6974c,
    $af2b0e533822f413$export$3e9f3e416c5066aa
];
module.exports["FORGE_MODULE_BYLINE"] = $af2b0e533822f413$export$77aa6bcc53373193;
module.exports["FORGE_MODULE_CONTEXT_MENU"] = $af2b0e533822f413$export$dfd79dc5aae7414d;
module.exports["FORGE_MODULE_CONTENT_ACTION"] = $af2b0e533822f413$export$93827e7f1bb6974c;
module.exports["FORGE_MODULE_GLOBAL_PAGE"] = $af2b0e533822f413$export$931827627b89a6ba;
module.exports["FORGE_MODULE_GLOBAL_SETTINGS"] = $af2b0e533822f413$export$109ae14a8174901f;
module.exports["FORGE_MODULE_HOMEPAGE_FEED"] = $af2b0e533822f413$export$e31530da5c277984;
module.exports["FORGE_MODULE_PAGE_BANNER"] = $af2b0e533822f413$export$54edc26d40e1a8eb;
module.exports["FORGE_MODULE_SPACE_PAGE"] = $af2b0e533822f413$export$75695e15f2aab495;
module.exports["FORGE_MODULE_SPACE_SETTINGS"] = $af2b0e533822f413$export$f17386882264cfae;
module.exports["FORGE_MODULE_CUSTOM_CONTENT"] = $af2b0e533822f413$export$3e9f3e416c5066aa;
module.exports["FORGE_MODULE_BACKGROUND_SCRIPT"] = $af2b0e533822f413$export$b9c5c98eb97dff92;
module.exports["FORGE_MODULE_XEN_MACRO"] = $af2b0e533822f413$export$769f3a278705a683;

});

parcelRegister("gJfOY", function(module, exports) {

let $c2dd1f0a26410bc8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c2dd1f0a26410bc8$var$load("FBIp4").then(()=>parcelRequire('cHhL0'));

});

parcelRegister("hcKPT", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $87d6e462347f520d$export$4bb4a114d280c175 = (globalShortcutsItemMap, customizationMenuConfig)=>{
    return (0, $42omo.useMemo)(()=>{
        // return the original config if no customizationMenuConfig is provided
        if (!customizationMenuConfig || customizationMenuConfig.length === 0) return Object.values(globalShortcutsItemMap);
        // Create a map for low complexity lookups
        const configMap = new Map(customizationMenuConfig.map((config)=>[
                config.menuId,
                config
            ]));
        const result = [];
        const addedKeys = new Set();
        // First pass: add items in the order specified by customizationMenuConfig
        customizationMenuConfig.forEach(({ menuId: menuId, visible: visible })=>{
            if (visible && globalShortcutsItemMap[menuId]) {
                result.push(globalShortcutsItemMap[menuId]);
                addedKeys.add(menuId);
            }
        });
        // Second pass: add remaining items that aren't in customizationMenuConfig or aren't visible
        Object.entries(globalShortcutsItemMap).forEach(([key, value])=>{
            if (!addedKeys.has(key)) {
                const config = configMap.get(key);
                // Add if not in config (assume visible) or if in config but not visible
                if (!config) result.push(value);
            }
        });
        return result;
    }, [
        globalShortcutsItemMap,
        customizationMenuConfig
    ]);
};
module.exports["useOrderedAppShortcuts"] = $87d6e462347f520d$export$4bb4a114d280c175;

});

parcelRegister("1PYmG", function(module, exports) {

let $156961165326888c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $156961165326888c$var$load("6wr18"),
    $156961165326888c$var$load("gbrgG"),
    $156961165326888c$var$load("ksAow"),
    $156961165326888c$var$load("7EorR"),
    $156961165326888c$var$load("Wowvf"),
    $156961165326888c$var$load("ffEVr"),
    $156961165326888c$var$load("borwc")
]).then(()=>parcelRequire('jhdHU'));

});

parcelRegister("aQN68", function(module, exports) {
/**
 * @generated SignedSource<<58da371268f638bef9623eaa8b79dd30>>
 * @relayHash efbccdac5bb753d6ce419c019fa1aaca
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2c716a297065a0b32d13d0ef655d0af2eb808e17bfd7325a7ecbc232e2971439
const $ede2af096215976f$var$node = function() {
    var v0 = [
        {
            "concreteType": "ConfluenceTenantContext",
            "kind": "LinkedField",
            "name": "confluence_tenantContext",
            "plural": false,
            "selections": [
                {
                    "concreteType": "LicensedProduct",
                    "kind": "LinkedField",
                    "name": "licensedProducts",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "licenseStatus"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "productKey"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useLicensedProductsQueryForGlobalAppShortcutsQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useLicensedProductsQueryForGlobalAppShortcutsQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "efbccdac5bb753d6ce419c019fa1aaca",
            "id": "2c716a297065a0b32d13d0ef655d0af2eb808e17bfd7325a7ecbc232e2971439",
            "metadata": {},
            "name": "useLicensedProductsQueryForGlobalAppShortcutsQuery",
            "operationKind": "query",
            "text": "query useLicensedProductsQueryForGlobalAppShortcutsQuery{confluence_tenantContext{licensedProducts{licenseStatus,productKey}}}"
        }
    };
}();
$ede2af096215976f$var$node.hash = "4173fb2f98b7988a84dc02df0399a348";
var $ede2af096215976f$export$2e2bcd8739ae039 = $ede2af096215976f$var$node;
module.exports["default"] = $ede2af096215976f$export$2e2bcd8739ae039;

});

parcelRegister("1ggpj", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $lx6jn = parcelRequire("lx6jn");

var $2aa2bdb281c6889a$export$e2e108cbe2e4f865 = /*#__PURE__*/ function(ContentType) {
    ContentType["WHITEBOARD"] = "whiteboard";
    ContentType["PAGE"] = "page";
    ContentType["BLOGPOST"] = "blogpost";
    ContentType["DATABASE"] = "database";
    ContentType["SLIDE"] = "slide";
    ContentType["EMBED"] = "embed";
    ContentType["FOLDER"] = "folder";
    return ContentType;
}({});
const $2aa2bdb281c6889a$export$31930b8b7828306b = [
    (0, $1NBp8.DATABASE_VIEW).name,
    (0, $1NBp8.VIEW_PAGE).name,
    (0, $1NBp8.WHITEBOARD_BOARD).name,
    (0, $1NBp8.SLIDES_VIEW).name,
    (0, $1NBp8.EMBED_VIEW).name
];
const $2aa2bdb281c6889a$export$e8b4d9d0d681efa4 = [
    (0, $1NBp8.DATABASE_VIEW).name,
    (0, $1NBp8.VIEW_PAGE).name,
    (0, $1NBp8.WHITEBOARD_BOARD).name,
    (0, $1NBp8.SLIDES_VIEW).name,
    (0, $1NBp8.EMBED_VIEW).name,
    (0, $1NBp8.EDIT_PAGE).name,
    (0, $1NBp8.EDIT_PAGE_V2).name
];
const $2aa2bdb281c6889a$export$142530096b49b828 = [
    "whiteboard",
    "database",
    "slide",
    "embed",
    "page",
    "folder",
    "blogpost"
];
const $2aa2bdb281c6889a$export$de22146d402d9bdd = {
    ["whiteboard"]: (0, $lx6jn.FeedbackSource).WHITEBOARD,
    ["embed"]: (0, $lx6jn.FeedbackSource).EMBED,
    ["database"]: (0, $lx6jn.FeedbackSource).DATABASE,
    ["slide"]: (0, $lx6jn.FeedbackSource).SLIDE
};
const $2aa2bdb281c6889a$export$4aba9c2e2995f563 = [
    "whiteboard",
    "slide"
];
const $2aa2bdb281c6889a$export$ea7ca1acbbc07168 = (contentType)=>!!contentType && $2aa2bdb281c6889a$export$4aba9c2e2995f563.includes(contentType);
const $2aa2bdb281c6889a$export$10c6f1bef31d587c = [
    'database',
    'slide',
    'embed',
    'folder'
];
const $2aa2bdb281c6889a$export$544bad8872c0b7ed = 400;
module.exports["ContentType"] = $2aa2bdb281c6889a$export$e2e108cbe2e4f865;
module.exports["ARCHIVE_SUCCESS_REDIRECT_ROUTES"] = $2aa2bdb281c6889a$export$31930b8b7828306b;
module.exports["DELETE_SUCCESS_REDIRECT_ROUTES"] = $2aa2bdb281c6889a$export$e8b4d9d0d681efa4;
module.exports["VALID_OPERATION_TARGETS"] = $2aa2bdb281c6889a$export$142530096b49b828;
module.exports["CONTENT_TYPE_FEEDBACK_SOURCE"] = $2aa2bdb281c6889a$export$de22146d402d9bdd;
module.exports["isCanvasContentType"] = $2aa2bdb281c6889a$export$ea7ca1acbbc07168;
module.exports["TYPES_WITH_ACTIVATIONID"] = $2aa2bdb281c6889a$export$10c6f1bef31d587c;
module.exports["onChangeTitleDebounceTime"] = $2aa2bdb281c6889a$export$544bad8872c0b7ed;

});

parcelRegister("lx6jn", function(module, exports) {
var $4d57d476a3596595$export$1953473fc535c5c1 = /*#__PURE__*/ function(FeedbackSource) {
    FeedbackSource["EDITOR"] = "Editor";
    FeedbackSource["HELP_PANEL"] = "Help Panel";
    FeedbackSource["THEME_SELECTOR"] = "Theme Selector";
    FeedbackSource["WHITEBOARD"] = "Whiteboard";
    FeedbackSource["EMBED"] = "Embed";
    FeedbackSource["DATABASE"] = "Database";
    FeedbackSource["NAV_4"] = "Nav4";
    FeedbackSource["SHARE_DIALOG"] = "Share Dialog";
    FeedbackSource["CONTENT_WRAPPER"] = "Content Wrapper";
    FeedbackSource["LIVE_DOCS"] = "Live Docs";
    FeedbackSource["EDITOR_CONTROLS"] = "Editor Controls";
    FeedbackSource["NOTES"] = "Notes";
    FeedbackSource["CREATE_WITH_ROVO"] = "Create with Rovo";
    FeedbackSource["SLIDE"] = "Slide";
    return FeedbackSource;
}({});
module.exports["FeedbackSource"] = $4d57d476a3596595$export$1953473fc535c5c1;

});

parcelRegister("2fgSf", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");

const $e7508444bbfb347b$export$69ed422375389c7 = ()=>{
    if ((0, $6mKj3.expValEquals)('cc_migrate_activity_v3_recents_queries_to_agg', 'isEnabled', true)) return true;
    // We are migrating Activity V3 queries for custom domain tenants earlier due to a cc-graphql bug
    const isDefaultDomain = window.location.hostname.endsWith('.atlassian.net') || window.location.hostname.endsWith('.jira-dev.com');
    return !isDefaultDomain;
};
module.exports["shouldUseAGGActivityV3"] = $e7508444bbfb347b$export$69ed422375389c7;

});

parcelRegister("882hS", function(module, exports) {
$parcel$export(module.exports, "pointerOutsideOfPreview", () => (parcelRequire("85Mv7")).pointerOutsideOfPreview);

var $85Mv7 = parcelRequire("85Mv7");


});

parcelRegister("85Mv7", function(module, exports) {

var $ic3Jg = parcelRequire("ic3Jg");


var $iFRCn = parcelRequire("iFRCn");


var $76xc7 = parcelRequire("76xc7");

function $30069a8958953d8b$export$427e20518819fabc(point) {
    return function getOffset({ container: container }) {
        /**
		 * **Approach: transparent borders.**
		 *
		 * The only reliable cross browser technique found to push a
		 * drag preview away from the cursor is to use transparent borders on the container.
		 *
		 * **🙅📱 Not pushing the preview away on touch devices**
		 *
		 * _On iOS_
		 *
		 * Safari will set the transparent border color to be black
		 *
		 * `iOS@18.4.1` on May 7th 2025:
		 * - If you set the background color on the `container` the border color will be that
		 * - Setting a transparent background color on the `container` still results in a
		 *   black border
		 * - The `<body>` text or background color does not change the black border color
		 *
		 * While dragging, the drag preview will shift under the center of the users pointer.
		 * So if you start at {x: 0, y: 0} (top left), almost immediately the preview will move
		 * to be under the middle of the users pointer.
		 *
		 * _On Android_
		 *
		 * Chrome will put the center of the drag preview under the users pointer immediately.
		 *
		 * Tested on `Chrome@137` on `Android 14` on June 20th 2025
		 *
		 * _What we do_
		 *
		 * We don't add the transparent border
		 *
		 * - Avoid the black color on iOS
		 * - It isn't needed on Android anyway as the preview will be under the center
		 *   of the users pointer
		 *
		 * We put the center of the drag preview under the users pointer
		 *
		 * - Avoids the drag preview quickly moving from a top corner to be centered under
		 *   the users pointer on iOS
		 * - It will be under the center on Android no matter what we do
		 *
		 * We previously had a isTouchDevice() check, but it felt safer for now
		 * to have a more targeted check, as these are the devices that have been
		 * tested on.
		 */ if ((0, $iFRCn.isSafariOnIOS)() || (0, $ic3Jg.isAndroid)()) return (0, $76xc7.centerUnderPointer)({
            container: container
        });
        Object.assign(container.style, {
            borderInlineStart: `${point.x} solid transparent`,
            borderTop: `${point.y} solid transparent`
        });
        // Unfortunate that we need to use `getComputedStyle`,
        // but it's only a single call when the drag is starting.
        const computed = window.getComputedStyle(container);
        if (computed.direction === 'rtl') {
            // The DOMRect will include the new border we added
            const box = container.getBoundingClientRect();
            // Use the top right corner (including the new border) as the offset.
            // The border will push the preview away from the pointer.
            return {
                x: box.width,
                y: 0
            };
        }
        // Use the top left corner as the offset. The border will
        // push the preview away from the pointer.
        return {
            x: 0,
            y: 0
        };
    };
}
module.exports["pointerOutsideOfPreview"] = $30069a8958953d8b$export$427e20518819fabc;

});

parcelRegister("iFRCn", function(module, exports) {

var $aYpzB = parcelRequire("aYpzB");


var $e880Z = parcelRequire("e880Z");

const $3720fb1a551ae595$export$52fc40c68fea4952 = (0, $aYpzB.once)(function isSafariOnIOS() {
    return (0, $e880Z.isSafari)() && 'ontouchend' in document;
});
module.exports["isSafariOnIOS"] = $3720fb1a551ae595$export$52fc40c68fea4952;

});

parcelRegister("76xc7", function(module, exports) {
const $54acc06d1c628398$export$81d8e72a15eef435 = function centerUnderPointer({ container: container }) {
    const rect = container.getBoundingClientRect();
    return {
        x: rect.width / 2,
        y: rect.height / 2
    };
};
module.exports["centerUnderPointer"] = $54acc06d1c628398$export$81d8e72a15eef435;

});

parcelRegister("afUmf", function(module, exports) {
$parcel$export(module.exports, "setCustomNativeDragPreview", () => (parcelRequire("3ts5j")).setCustomNativeDragPreview);

var $3ts5j = parcelRequire("3ts5j");


});

parcelRegister("3ts5j", function(module, exports) {

var $3CnSH = parcelRequire("3CnSH");


var $e880Z = parcelRequire("e880Z");


var $f7qXf = parcelRequire("f7qXf");

/** By default we use the build in values for the native drag preview: {x: 0, y: 0} */ function $90430ceac724b72d$var$defaultOffset() {
    return {
        x: 0,
        y: 0
    };
}
function $90430ceac724b72d$export$52d889c66db0f96e({ render: render, nativeSetDragImage: nativeSetDragImage, getOffset: getOffset = $90430ceac724b72d$var$defaultOffset }) {
    const container = document.createElement('div');
    Object.assign(container.style, {
        // Ensuring we don't cause reflow when adding the element to the page
        // Using `position:fixed` rather than `position:absolute` so we are
        // positioned on the current viewport.
        // `position:fixed` also creates a new stacking context, so we don't need to do that here
        position: 'fixed',
        // According to `mdn`, the element can be offscreen:
        // https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/setDragImage#imgelement
        //
        // However, that  information does not appear in the specs:
        // https://html.spec.whatwg.org/multipage/dnd.html#dom-datatransfer-setdragimage-dev
        //
        // If the element is _completely_ offscreen, Safari@17.1 will cancel the drag
        top: 0,
        left: 0,
        // Using maximum possible z-index so that this element will always be on top
        // https://stackoverflow.com/questions/491052/minimum-and-maximum-value-of-z-index
        // Did not use `layers` in `@atlaskit/theme` because:
        // 1. This element is not a 'layer' in the conventional sense, as this element
        //    is only created for a single frame for the browser to take a photo of it,
        //    and then it is destroyed
        // 2. Did not want to add a dependency onto `@atlaskit/theme`
        // 3. Want to always be on top of product UI which might have higher z-index's
        zIndex: (0, $f7qXf.maxZIndex),
        // Avoiding any additional events caused by the new element (being super safe)
        pointerEvents: 'none'
    });
    document.body.append(container);
    const unmount = render({
        container: container
    });
    /**
	 * Some frameworks (eg `react`) don't render into the container until the next microtask.
	 * - This will run before the browser takes it's picture of the element
	 * - This will run before the animation frame that removes `container`.
	 * */ queueMicrotask(()=>{
        const previewOffset = getOffset({
            container: container
        });
        /**
		 * **Problem**
		 * On `Safari@17.1` if a drag preview element has some opacity,
		 * Safari will include elements behind the drag preview element
		 * in the drag preview.
		 * Bug: https://bugs.webkit.org/show_bug.cgi?id=266025
		 *
		 * **Fix**
		 * We push the drag preview so it is _almost_ completely offscreen so that
		 * there won't be any elements behind the drag preview element.
		 * If the element is _completely_ offscreen, then the drag is cancelled by Safari.
		 *
		 * Using `-0.0001` so that any potential "see through" on the drag preview element
		 * is effectively invisible 👻
		 *
		 * **Unsuccessful alternatives**
		 * Setting a background color (eg "white") on the `container`
		 * → Wrecks the opacity of the drag preview element
		 *
		 * Adding a parent element of the `container` with a background color (eg "white")
		 * → Wrecks the opacity of the drag preview element
		 */ if ((0, $e880Z.isSafari)()) {
            const rect = container.getBoundingClientRect();
            // We cannot apply this fix if nothing has been rendered into the `container`
            if (rect.width === 0) return;
            container.style.left = `-${rect.width - 0.0001}px`;
        }
        nativeSetDragImage?.(container, previewOffset.x, previewOffset.y);
    });
    function cleanup() {
        unbindMonitor();
        unmount?.();
        document.body.removeChild(container);
    }
    const unbindMonitor = (0, $3CnSH.monitorForElements)({
        // Remove portal in the dragstart event so that the user will never see it
        onDragStart: cleanup,
        // Backup: remove portal when the drop finishes (this would be an error case)
        onDrop: cleanup
    });
}
module.exports["setCustomNativeDragPreview"] = $90430ceac724b72d$export$52d889c66db0f96e;

});

parcelRegister("2n8po", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $31bj1 = parcelRequire("31bj1");


var $9JSVA = parcelRequire("9JSVA");

function $f0c37d2844a91b76$export$62ed72bc21f6b8a6({ appearance: appearance = 'default', edge: edge, gap: gap, indent: indent, type: type }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $31bj1.Line), {
        edge: edge,
        gap: gap,
        strokeColor: (0, $9JSVA.presetStrokeColors)[appearance],
        type: type,
        indent: indent
    });
}
var // This default export is intended for usage with React.lazy
$f0c37d2844a91b76$export$2e2bcd8739ae039 = $f0c37d2844a91b76$export$62ed72bc21f6b8a6;
module.exports["DropIndicator"] = $f0c37d2844a91b76$export$62ed72bc21f6b8a6;
module.exports["default"] = $f0c37d2844a91b76$export$2e2bcd8739ae039;

});

parcelRegister("31bj1", function(module, exports) {
/* line.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $9JSVA = parcelRequire("9JSVA");

const $1707735fc36ab082$var$edgeToOrientationMap = {
    top: 'horizontal',
    bottom: 'horizontal',
    left: 'vertical',
    right: 'vertical'
};
const $1707735fc36ab082$var$baseStyles = {
    root: "_1e0c1ule _kqswstnw _1pbykb7n _lcxvglyw _bfhkys7w _rfx31ssb _3l8810ly _kzdanqa1 _15m6ys7w _cfu11ld9 _1kt9b3bt _1cs8stnw _13y0usvi _1mp4vjfa _kfgtvjfa"
};
const $1707735fc36ab082$var$orientationStyles = {
    horizontal: "_4t3i10ly _1e02fghn _rjxpidpf _z5wtuj5p",
    vertical: "_1bsb10ly _154ifghn _94n5idpf _1aukuj5p"
};
const $1707735fc36ab082$var$edgeStyles = {
    top: "_154ihv0e _1auk70hn",
    right: "_1xi2hv0e _ooun70hn",
    bottom: "_94n5hv0e _19wo70hn",
    left: "_1ltvhv0e _qnec70hn"
};
const $1707735fc36ab082$var$lineStartFrom = {
    // - half the terminal bleeding out the containing element
    // - half the terminal inside the containing element (we need to position the line next to this)
    terminal: ({ indent: indent })=>`calc(var(--terminal-radius) + ${indent})`,
    // The full terminal is inside the containing element (we need to position the line next to this)
    'terminal-no-bleed': ({ indent: indent })=>`calc(var(--terminal-diameter) + ${indent})`,
    // No terminal to worry about, line should take up all the space
    'no-terminal': ({ indent: indent })=>indent
};
function $1707735fc36ab082$export$17d680238e50603e({ edge: edge, gap: gap = '0px', indent: indent = '0px', strokeColor: strokeColor = (0, $9JSVA.presetStrokeColors).default, strokeWidth: strokeWidth = (0, $9JSVA.presetStrokeWidth), type: type = 'terminal' }) {
    const orientation = $1707735fc36ab082$var$edgeToOrientationMap[edge];
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        style: {
            // ## All
            '--stroke-color': strokeColor,
            '--stroke-width': strokeWidth,
            // Shift line and terminal on the main access to account for gaps between items
            '--main-axis-offset': `calc(-0.5 * (${gap} + var(--stroke-width)))`,
            // ## Line
            // If there is a terminal, we want the line to start from next to it
            '--line-main-axis-start': $1707735fc36ab082$var$lineStartFrom[type]({
                indent: indent
            }),
            // ## Terminal
            '--terminal-display': type === 'no-terminal' ? 'none' : 'block',
            '--terminal-diameter': 'calc(var(--stroke-width) * 4)',
            '--terminal-radius': 'calc(var(--terminal-diameter) / 2)',
            // The line is positioned to account for the the terminal (--line-main-axis-start).
            // The terminal is rendered relative to the line (it's a `::before`)
            // We need to pull the terminal backwards so it sits before the start of the line
            '--terminal-main-axis-start': 'calc(-1 * var(--terminal-diameter))',
            // Pull the terminal backwards on the cross axis (eg "up" on "vertical")
            // so the center of the terminal lines up with the center of the line
            '--terminal-cross-axis-offset': 'calc(calc(var(--stroke-width) - var(--terminal-diameter)) / 2)'
        },
        className: (0, $gMc0m.default)([
            $1707735fc36ab082$var$baseStyles.root,
            $1707735fc36ab082$var$orientationStyles[orientation],
            $1707735fc36ab082$var$edgeStyles[edge]
        ])
    });
} // For React.lazy
var $1707735fc36ab082$export$2e2bcd8739ae039 = $1707735fc36ab082$export$17d680238e50603e;
module.exports["Line"] = $1707735fc36ab082$export$17d680238e50603e;

});

parcelRegister("9JSVA", function(module, exports) {
const $795a0d6001dc944e$export$477fafec326bfca0 = {
    default: "var(--ds-border-selected, #1868DB)",
    warning: "var(--ds-border-warning, #E06C00)"
};
const $795a0d6001dc944e$export$45db03aa04b685e3 = "var(--ds-border-width-selected, 2px)";
module.exports["presetStrokeColors"] = $795a0d6001dc944e$export$477fafec326bfca0;
module.exports["presetStrokeWidth"] = $795a0d6001dc944e$export$45db03aa04b685e3;

});

parcelRegister("eB56w", function(module, exports) {

var $fOAkx = parcelRequire("fOAkx");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/confluence/blogpost/manifest.ts
var $aa087af90d1c8aca$var$confluenceBlogpostAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $fOAkx.ConfluenceBlogpostAriResourceOwner),
    resourceType: (0, $fOAkx.ConfluenceBlogpostAriResourceType),
    resourceIdSlug: "{blogpostId}",
    resourceIdSegmentFormats: {
        blogpostId: /[0-9]+/
    }
};
// src/confluence/blogpost/index.ts
var $aa087af90d1c8aca$export$8602a2c2f6ac09bc = class _ConfluenceBlogpostAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get blogpostId() {
        return this._blogpostId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $aa087af90d1c8aca$var$confluenceBlogpostAriStaticOpts.qualifier,
            platformQualifier: $aa087af90d1c8aca$var$confluenceBlogpostAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $aa087af90d1c8aca$var$confluenceBlogpostAriStaticOpts.resourceOwner,
            resourceType: $aa087af90d1c8aca$var$confluenceBlogpostAriStaticOpts.resourceType,
            resourceId: `${opts.blogpostId}`,
            resourceIdSegmentValues: {
                blogpostId: opts.blogpostId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $aa087af90d1c8aca$var$confluenceBlogpostAriStaticOpts);
        return new _ConfluenceBlogpostAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $aa087af90d1c8aca$var$confluenceBlogpostAriStaticOpts);
        return new _ConfluenceBlogpostAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            blogpostId: this.blogpostId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._blogpostId = opts.resourceIdSegmentValues.blogpostId;
    }
};
module.exports["ConfluenceBlogpostAri"] = $aa087af90d1c8aca$export$8602a2c2f6ac09bc;

});

parcelRegister("fOAkx", function(module, exports) {
// src/confluence/blogpost/types.ts
var $b837b4f269c93ee4$export$9389f06bd1d0765c = "confluence", $b837b4f269c93ee4$export$fb777a2d645a4129 = "blogpost";
module.exports["ConfluenceBlogpostAriResourceOwner"] = $b837b4f269c93ee4$export$9389f06bd1d0765c;
module.exports["ConfluenceBlogpostAriResourceType"] = $b837b4f269c93ee4$export$fb777a2d645a4129;

});

parcelRegister("a5Dk4", function(module, exports) {

var $aOBEU = parcelRequire("aOBEU");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/confluence/whiteboard/manifest.ts
var $7588dfadc8876fc5$var$confluenceWhiteboardAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $aOBEU.ConfluenceWhiteboardAriResourceOwner),
    resourceType: (0, $aOBEU.ConfluenceWhiteboardAriResourceType),
    resourceIdSlug: "{whiteboardId}",
    resourceIdSegmentFormats: {
        whiteboardId: /[0-9]+/
    }
};
// src/confluence/whiteboard/index.ts
var $7588dfadc8876fc5$export$ba3d25b6768ddb10 = class _ConfluenceWhiteboardAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get whiteboardId() {
        return this._whiteboardId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $7588dfadc8876fc5$var$confluenceWhiteboardAriStaticOpts.qualifier,
            platformQualifier: $7588dfadc8876fc5$var$confluenceWhiteboardAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $7588dfadc8876fc5$var$confluenceWhiteboardAriStaticOpts.resourceOwner,
            resourceType: $7588dfadc8876fc5$var$confluenceWhiteboardAriStaticOpts.resourceType,
            resourceId: `${opts.whiteboardId}`,
            resourceIdSegmentValues: {
                whiteboardId: opts.whiteboardId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $7588dfadc8876fc5$var$confluenceWhiteboardAriStaticOpts);
        return new _ConfluenceWhiteboardAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $7588dfadc8876fc5$var$confluenceWhiteboardAriStaticOpts);
        return new _ConfluenceWhiteboardAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            whiteboardId: this.whiteboardId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._whiteboardId = opts.resourceIdSegmentValues.whiteboardId;
    }
};
module.exports["ConfluenceWhiteboardAri"] = $7588dfadc8876fc5$export$ba3d25b6768ddb10;

});

parcelRegister("aOBEU", function(module, exports) {
// src/confluence/whiteboard/types.ts
var $7dfbc92767b8c664$export$6130ea1abbb885ef = "confluence", $7dfbc92767b8c664$export$d3070d1568a10e2d = "whiteboard";
module.exports["ConfluenceWhiteboardAriResourceOwner"] = $7dfbc92767b8c664$export$6130ea1abbb885ef;
module.exports["ConfluenceWhiteboardAriResourceType"] = $7dfbc92767b8c664$export$d3070d1568a10e2d;

});

parcelRegister("a2xFu", function(module, exports) {

var $5KmYv = parcelRequire("5KmYv");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/confluence/page/manifest.ts
var $74f4351b9cae92fc$var$confluencePageAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $5KmYv.ConfluencePageAriResourceOwner),
    resourceType: (0, $5KmYv.ConfluencePageAriResourceType),
    resourceIdSlug: "{pageId}",
    resourceIdSegmentFormats: {
        pageId: /[0-9]+/
    }
};
// src/confluence/page/index.ts
var $74f4351b9cae92fc$export$3f931dd15d96caff = class _ConfluencePageAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get pageId() {
        return this._pageId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $74f4351b9cae92fc$var$confluencePageAriStaticOpts.qualifier,
            platformQualifier: $74f4351b9cae92fc$var$confluencePageAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $74f4351b9cae92fc$var$confluencePageAriStaticOpts.resourceOwner,
            resourceType: $74f4351b9cae92fc$var$confluencePageAriStaticOpts.resourceType,
            resourceId: `${opts.pageId}`,
            resourceIdSegmentValues: {
                pageId: opts.pageId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $74f4351b9cae92fc$var$confluencePageAriStaticOpts);
        return new _ConfluencePageAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $74f4351b9cae92fc$var$confluencePageAriStaticOpts);
        return new _ConfluencePageAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            pageId: this.pageId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._pageId = opts.resourceIdSegmentValues.pageId;
    }
};
module.exports["ConfluencePageAri"] = $74f4351b9cae92fc$export$3f931dd15d96caff;

});

parcelRegister("5KmYv", function(module, exports) {
// src/confluence/page/types.ts
var $42f311f8b7b6730c$export$da53e4f7db4c6a71 = "confluence", $42f311f8b7b6730c$export$636fc622562a2c5b = "page";
module.exports["ConfluencePageAriResourceOwner"] = $42f311f8b7b6730c$export$da53e4f7db4c6a71;
module.exports["ConfluencePageAriResourceType"] = $42f311f8b7b6730c$export$636fc622562a2c5b;

});

parcelRegister("c7GB4", function(module, exports) {

var $eB56w = parcelRequire("eB56w");

var $iH7AG = parcelRequire("iH7AG");

var $dM0Qh = parcelRequire("dM0Qh");

var $lb1Mg = parcelRequire("lb1Mg");

var $a2xFu = parcelRequire("a2xFu");

var $1LZHF = parcelRequire("1LZHF");

var $a5Dk4 = parcelRequire("a5Dk4");


var $1ggpj = parcelRequire("1ggpj");

const $c96e0d62cf176fc6$export$84dfa7fadd8a006b = ({ ari: ari, resourceType: resourceType })=>{
    if (!ari) return null;
    switch(resourceType){
        case (0, $1ggpj.ContentType).PAGE:
            return (0, $a2xFu.ConfluencePageAri).parse(ari).pageId;
        case (0, $1ggpj.ContentType).BLOGPOST:
            return (0, $eB56w.ConfluenceBlogpostAri).parse(ari).blogpostId;
        case (0, $1ggpj.ContentType).WHITEBOARD:
            return (0, $a5Dk4.ConfluenceWhiteboardAri).parse(ari).whiteboardId;
        case (0, $1ggpj.ContentType).DATABASE:
            return (0, $iH7AG.ConfluenceDatabaseAri).parse(ari).databaseId;
        case (0, $1ggpj.ContentType).EMBED:
            return (0, $dM0Qh.ConfluenceEmbedAri).parse(ari).embedId;
        case (0, $1ggpj.ContentType).FOLDER:
            return (0, $lb1Mg.ConfluenceFolderAri).parse(ari).folderId;
        case (0, $1ggpj.ContentType).SLIDE:
            return (0, $1LZHF.ConfluenceSlideAri).parse(ari).slideId;
    }
};
module.exports["getIdFromConfluenceContentAri"] = $c96e0d62cf176fc6$export$84dfa7fadd8a006b;

});

parcelRegister("iH7AG", function(module, exports) {

var $hIjpx = parcelRequire("hIjpx");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/confluence/database/manifest.ts
var $d9c22183dba005c8$var$confluenceDatabaseAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $hIjpx.ConfluenceDatabaseAriResourceOwner),
    resourceType: (0, $hIjpx.ConfluenceDatabaseAriResourceType),
    resourceIdSlug: "activation/{activationId}/{databaseId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        databaseId: /[0-9]+/
    }
};
// src/confluence/database/index.ts
var $d9c22183dba005c8$export$317cd32472deea7e = class _ConfluenceDatabaseAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get databaseId() {
        return this._databaseId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $d9c22183dba005c8$var$confluenceDatabaseAriStaticOpts.qualifier,
            platformQualifier: $d9c22183dba005c8$var$confluenceDatabaseAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $d9c22183dba005c8$var$confluenceDatabaseAriStaticOpts.resourceOwner,
            resourceType: $d9c22183dba005c8$var$confluenceDatabaseAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.databaseId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                databaseId: opts.databaseId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $d9c22183dba005c8$var$confluenceDatabaseAriStaticOpts);
        return new _ConfluenceDatabaseAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $d9c22183dba005c8$var$confluenceDatabaseAriStaticOpts);
        return new _ConfluenceDatabaseAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            databaseId: this.databaseId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._databaseId = opts.resourceIdSegmentValues.databaseId;
    }
};
module.exports["ConfluenceDatabaseAri"] = $d9c22183dba005c8$export$317cd32472deea7e;

});

parcelRegister("hIjpx", function(module, exports) {
// src/confluence/database/types.ts
var $ce559a57d4ba003b$export$e83bc7b627335f1d = "confluence", $ce559a57d4ba003b$export$d26db9a1a0b750aa = "database";
module.exports["ConfluenceDatabaseAriResourceOwner"] = $ce559a57d4ba003b$export$e83bc7b627335f1d;
module.exports["ConfluenceDatabaseAriResourceType"] = $ce559a57d4ba003b$export$d26db9a1a0b750aa;

});

parcelRegister("dM0Qh", function(module, exports) {

var $dPsPU = parcelRequire("dPsPU");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/confluence/embed/manifest.ts
var $a070694ffdc5cb3b$var$confluenceEmbedAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $dPsPU.ConfluenceEmbedAriResourceOwner),
    resourceType: (0, $dPsPU.ConfluenceEmbedAriResourceType),
    resourceIdSlug: "activation/{activationId}/{embedId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        embedId: /[0-9]+/
    }
};
// src/confluence/embed/index.ts
var $a070694ffdc5cb3b$export$47d4b4205d0ac61a = class _ConfluenceEmbedAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get embedId() {
        return this._embedId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $a070694ffdc5cb3b$var$confluenceEmbedAriStaticOpts.qualifier,
            platformQualifier: $a070694ffdc5cb3b$var$confluenceEmbedAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $a070694ffdc5cb3b$var$confluenceEmbedAriStaticOpts.resourceOwner,
            resourceType: $a070694ffdc5cb3b$var$confluenceEmbedAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.embedId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                embedId: opts.embedId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $a070694ffdc5cb3b$var$confluenceEmbedAriStaticOpts);
        return new _ConfluenceEmbedAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $a070694ffdc5cb3b$var$confluenceEmbedAriStaticOpts);
        return new _ConfluenceEmbedAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            embedId: this.embedId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._embedId = opts.resourceIdSegmentValues.embedId;
    }
};
module.exports["ConfluenceEmbedAri"] = $a070694ffdc5cb3b$export$47d4b4205d0ac61a;

});

parcelRegister("dPsPU", function(module, exports) {
// src/confluence/embed/types.ts
var $a116681263506e39$export$7a02af293cacddd2 = "confluence", $a116681263506e39$export$f817d48842ea0d4a = "embed";
module.exports["ConfluenceEmbedAriResourceOwner"] = $a116681263506e39$export$7a02af293cacddd2;
module.exports["ConfluenceEmbedAriResourceType"] = $a116681263506e39$export$f817d48842ea0d4a;

});

parcelRegister("lb1Mg", function(module, exports) {

var $bYbE5 = parcelRequire("bYbE5");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/confluence/folder/manifest.ts
var $f6ac010730fe9d5d$var$confluenceFolderAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $bYbE5.ConfluenceFolderAriResourceOwner),
    resourceType: (0, $bYbE5.ConfluenceFolderAriResourceType),
    resourceIdSlug: "activation/{activationId}/{folderId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        folderId: /[0-9]+/
    }
};
// src/confluence/folder/index.ts
var $f6ac010730fe9d5d$export$501a782385a3f485 = class _ConfluenceFolderAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get folderId() {
        return this._folderId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $f6ac010730fe9d5d$var$confluenceFolderAriStaticOpts.qualifier,
            platformQualifier: $f6ac010730fe9d5d$var$confluenceFolderAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $f6ac010730fe9d5d$var$confluenceFolderAriStaticOpts.resourceOwner,
            resourceType: $f6ac010730fe9d5d$var$confluenceFolderAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.folderId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                folderId: opts.folderId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $f6ac010730fe9d5d$var$confluenceFolderAriStaticOpts);
        return new _ConfluenceFolderAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $f6ac010730fe9d5d$var$confluenceFolderAriStaticOpts);
        return new _ConfluenceFolderAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            folderId: this.folderId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._folderId = opts.resourceIdSegmentValues.folderId;
    }
};
module.exports["ConfluenceFolderAri"] = $f6ac010730fe9d5d$export$501a782385a3f485;

});

parcelRegister("bYbE5", function(module, exports) {
// src/confluence/folder/types.ts
var $8b6e54dbbb0b2632$export$77cf4e1b17902bfa = "confluence", $8b6e54dbbb0b2632$export$6256ff329bc25a9c = "folder";
module.exports["ConfluenceFolderAriResourceOwner"] = $8b6e54dbbb0b2632$export$77cf4e1b17902bfa;
module.exports["ConfluenceFolderAriResourceType"] = $8b6e54dbbb0b2632$export$6256ff329bc25a9c;

});

parcelRegister("1LZHF", function(module, exports) {

var $gFQkO = parcelRequire("gFQkO");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/confluence/slide/manifest.ts
var $14aa0b35cfffabf8$var$confluenceSlideAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $gFQkO.ConfluenceSlideAriResourceOwner),
    resourceType: (0, $gFQkO.ConfluenceSlideAriResourceType),
    resourceIdSlug: "activation/{activationId}/{slideId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        slideId: /[0-9]+/
    }
};
// src/confluence/slide/index.ts
var $14aa0b35cfffabf8$export$86048ac46024146a = class _ConfluenceSlideAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get slideId() {
        return this._slideId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $14aa0b35cfffabf8$var$confluenceSlideAriStaticOpts.qualifier,
            platformQualifier: $14aa0b35cfffabf8$var$confluenceSlideAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $14aa0b35cfffabf8$var$confluenceSlideAriStaticOpts.resourceOwner,
            resourceType: $14aa0b35cfffabf8$var$confluenceSlideAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.slideId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                slideId: opts.slideId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $14aa0b35cfffabf8$var$confluenceSlideAriStaticOpts);
        return new _ConfluenceSlideAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $14aa0b35cfffabf8$var$confluenceSlideAriStaticOpts);
        return new _ConfluenceSlideAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            slideId: this.slideId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._slideId = opts.resourceIdSegmentValues.slideId;
    }
};
module.exports["ConfluenceSlideAri"] = $14aa0b35cfffabf8$export$86048ac46024146a;

});

parcelRegister("gFQkO", function(module, exports) {
// src/confluence/slide/types.ts
var $c23912470bd9b644$export$204fa7edd529d4b3 = "confluence", $c23912470bd9b644$export$3de52c55a164daa4 = "slide";
module.exports["ConfluenceSlideAriResourceOwner"] = $c23912470bd9b644$export$204fa7edd529d4b3;
module.exports["ConfluenceSlideAriResourceType"] = $c23912470bd9b644$export$3de52c55a164daa4;

});

parcelRegister("bYUc2", function(module, exports) {

var $1dnxO = parcelRequire("1dnxO");

const $e2bf374f654691d1$export$bd6b49f42ca8817b = ()=>{
    try {
        return (0, $1dnxO.getIsNav4Enabled)();
    } catch  {
        return false;
    }
};
module.exports["getIsNav4EnabledSafe"] = $e2bf374f654691d1$export$bd6b49f42ca8817b;

});

parcelRegister("4qzKl", function(module, exports) {
// TODO: remove once @confluence-classic/confluence-urls is added to next

var $jlIaF = parcelRequire("jlIaF");

const $7b986e69785602e5$export$3b6a64cfeda8b00 = (accountId, src, context = '')=>{
    if (!accountId) return '';
    return `${context}/people/${accountId}?ref=confluence${src ? `&src=${encodeURIComponent(src)}` : ''}`;
};
const $7b986e69785602e5$export$5f1a0e9946984804 = async (accountId, src)=>{
    if (!accountId) return '';
    return `${0, $jlIaF.CONTEXT_PATH}/people/${accountId}?ref=confluence${src ? `&src=${encodeURIComponent(src)}` : ''}`;
};
const $7b986e69785602e5$export$cb80ef5511478588 = (teamId, src, context = '')=>{
    if (!teamId) return '';
    return `${context}/people/team/${teamId}?ref=confluence${src ? `&src=${encodeURIComponent(src)}` : ''}`;
};
const $7b986e69785602e5$export$470c1413f7223a06 = async (teamId, src)=>{
    if (!teamId) return '';
    return `${0, $jlIaF.CONTEXT_PATH}/people/team/${teamId}?ref=confluence${src ? `&src=${encodeURIComponent(src)}` : ''}`;
};
// Replacement for the getAttributeNames DOM API since it's not supported by IE
const $7b986e69785602e5$var$getAttributeNames = (element)=>Array.from(element.attributes).map((attribute)=>attribute.name);
// Return only DOM elements that have the data-account-id attribute
const $7b986e69785602e5$var$withAccountId = (element)=>element.getAttribute('data-account-id');
// Returns React props that can be used to recreate a DOM element
const $7b986e69785602e5$var$getReactPropsFromDOMElement = (element)=>{
    const attributeToProp = {
        class: 'className'
    };
    const props = {};
    $7b986e69785602e5$var$getAttributeNames(element).forEach((attribute)=>{
        props[attributeToProp[attribute] || attribute] = element.getAttribute(attribute);
    });
    props.dangerouslySetInnerHTML = {
        __html: element.innerHTML
    };
    return props;
};
function $7b986e69785602e5$export$a98860edfb97e545(userElements) {
    return userElements.filter($7b986e69785602e5$var$withAccountId).map((element)=>{
        const props = $7b986e69785602e5$var$getReactPropsFromDOMElement(element);
        // Set this attribute to stop the old user profile hovers from binding
        props['data-user-hover-bound'] = 'true';
        // Ensure that links go to the same location as the profile card
        props.href = $7b986e69785602e5$export$3b6a64cfeda8b00(props['data-account-id'], null);
        const placeholder = window.document.createElement('span');
        if (!element.parentNode) return {};
        element.parentNode.replaceChild(placeholder, element);
        return {
            props: props,
            placeholder: placeholder
        };
    });
}
module.exports["getAtlassianPeopleProfileUrl"] = $7b986e69785602e5$export$3b6a64cfeda8b00;
module.exports["getAtlassianPeopleProfileUrlAsync"] = $7b986e69785602e5$export$5f1a0e9946984804;
module.exports["getTeamUrl"] = $7b986e69785602e5$export$cb80ef5511478588;
module.exports["replaceUserElementsWithPlaceholders"] = $7b986e69785602e5$export$a98860edfb97e545;

});

parcelRegister("lyF5K", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $bQm3c = parcelRequire("bQm3c");


var $f7B1p = parcelRequire("f7B1p");


var $ebwTS = parcelRequire("ebwTS");

const $14503a2aea2a4136$export$1ee9ed72ffc111c1 = [
    // If a guest has "direct access", they will simply upgrade to a user immediately upon submitting a request without needing admin approval.
    (0, $ebwTS.CapabilityValues).DIRECT_ACCESS,
    // ... otherwise, they have the ability to request access, and wait for admin approval.
    (0, $ebwTS.CapabilityValues).REQUEST_ACCESS
];
const $14503a2aea2a4136$export$3ed095546414dc67 = [
    // The ones a Guest should never get, but technically exist on the endpoint:
    (0, $ebwTS.CapabilityValues).ACCESS_EXISTS,
    (0, $ebwTS.CapabilityValues).APPROVED_REQUEST_EXISTS,
    // The ones we expect to potentially get:
    (0, $ebwTS.CapabilityValues).DENIED_REQUEST_EXISTS,
    (0, $ebwTS.CapabilityValues).FORBIDDEN
];
const $14503a2aea2a4136$export$4e4260b083de0708 = 'product/member';
const $14503a2aea2a4136$export$d3e4104c62036f39 = (skip = false)=>{
    // if skip is true, we are not going to fetch the status, so we're not loading anything and it can be false
    // if skip is false, we are going to fetch the status and invoke API immediately, so loading can be true (same as previous implementation)
    const [loading, setLoading] = (0, $42omo.useState)(!skip);
    const [error, setError] = (0, $42omo.useState)();
    const [upgradeStatus, setUpgradeStatus] = (0, $42omo.useState)(undefined);
    const [upgradeStatusReason, setUpgradeStatusReason] = (0, $42omo.useState)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const fetchGuestUpgradeRequestStatus = (0, $42omo.useCallback)(async ()=>{
        setLoading(true);
        const resource = `ari:cloud:confluence::site/${cloudId}`;
        const params = new URLSearchParams({
            resource: resource
        });
        return (0, $f7B1p.cfetch)(`/gateway/api/invitations/v1/access-requests/capabilities?${params.toString()}`, {
            method: 'GET',
            headers: {
                Accept: 'application/json'
            }
        }).then((response)=>response.json()).then((data)=>{
            const statusArray = data.resultsV2[resource];
            const userCapabilityEntry = statusArray.find((entry)=>entry.role === $14503a2aea2a4136$export$4e4260b083de0708) || {};
            const status = userCapabilityEntry.accessMode;
            setUpgradeStatusReason(status);
            if ($14503a2aea2a4136$export$3ed095546414dc67.includes(status)) setUpgradeStatus((0, $ebwTS.UpgradeStatus).NOT_ELIGIBLE_TO_UPGRADE_AT_ALL);
            else if (status === (0, $ebwTS.CapabilityValues).PENDING_REQUEST_EXISTS) setUpgradeStatus((0, $ebwTS.UpgradeStatus).AN_UPGRADE_REQUEST_IS_PENDING);
            else if ($14503a2aea2a4136$export$1ee9ed72ffc111c1.includes(status)) setUpgradeStatus((0, $ebwTS.UpgradeStatus).CAN_REQUEST);
            else // We didn't get a valid value
            throw Error(`Did not receive a valid value for the accessMode status: ${status}.`);
        }).catch((caughtError)=>{
            // If anything fails, we just state you're not eligible, because we can't confirm it.
            setUpgradeStatus((0, $ebwTS.UpgradeStatus).NOT_ELIGIBLE_TO_UPGRADE_AT_ALL);
            setError(caughtError instanceof Error ? caughtError : new Error('Guest request to upgrade status load error', {
                cause: caughtError
            }));
        }).finally(()=>setLoading(false));
    }, [
        cloudId
    ]);
    (0, $42omo.useEffect)(()=>{
        if (skip) return;
        fetchGuestUpgradeRequestStatus();
    }, [
        fetchGuestUpgradeRequestStatus,
        skip
    ]);
    return {
        upgradeStatus: upgradeStatus,
        upgradeStatusReason: upgradeStatusReason,
        loading: loading,
        error: error
    };
};
module.exports["useGuestRequestToUpgradeStatus"] = $14503a2aea2a4136$export$d3e4104c62036f39;

});

parcelRegister("ebwTS", function(module, exports) {
const $2f24b685c1e47a17$export$408edfc5a854220e = {
    ACCESS_EXISTS: 'ACCESS_EXISTS',
    DIRECT_ACCESS: 'DIRECT_ACCESS',
    APPROVED_REQUEST_EXISTS: 'APPROVED_REQUEST_EXISTS',
    DENIED_REQUEST_EXISTS: 'DENIED_REQUEST_EXISTS',
    FORBIDDEN: 'FORBIDDEN',
    PENDING_REQUEST_EXISTS: 'PENDING_REQUEST_EXISTS',
    REQUEST_ACCESS: 'REQUEST_ACCESS'
};
var $2f24b685c1e47a17$export$309264bca7eef03f = /*#__PURE__*/ function(UpgradeStatus) {
    UpgradeStatus["CAN_REQUEST"] = "CAN_REQUEST";
    UpgradeStatus["AN_UPGRADE_REQUEST_IS_PENDING"] = "AN_UPGRADE_REQUEST_IS_PENDING";
    UpgradeStatus["NOT_ELIGIBLE_TO_UPGRADE_AT_ALL"] = "NOT_ELIGIBLE_TO_UPGRADE_AT_ALL";
    return UpgradeStatus;
}({});
module.exports["CapabilityValues"] = $2f24b685c1e47a17$export$408edfc5a854220e;
module.exports["UpgradeStatus"] = $2f24b685c1e47a17$export$309264bca7eef03f;

});

parcelRegister("eh0mb", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $4708f874261747c2$var$Store = (0, $1P1Tu.createStore)({
    initialState: {
        requestAccessState: undefined
    },
    actions: {
        setRequestAccessState: (value)=>({ setState: setState })=>{
                setState({
                    requestAccessState: value
                });
            }
    },
    name: 'guestRequestUpgradeStore'
});
const $4708f874261747c2$export$b72090e4288882db = (0, $9zUhf.createHook)($4708f874261747c2$var$Store);
module.exports["useGuestRequestUpgradeStore"] = $4708f874261747c2$export$b72090e4288882db;

});

parcelRegister("ftdAe", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $9YwaJ = parcelRequire("9YwaJ");

const $141cc20ec350ae53$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    requestToUpgradeButton: {
        id: "external-collab-ui.guest-request-to-upgrade-page-tree.request-to-upgrade-button",
        defaultMessage: "Request full access"
    },
    requestToUpgradePendingButton: {
        id: "external-collab-ui.guest-request-to-upgrade-page-tree.request-to-upgrade-pending-button",
        defaultMessage: "Request pending approval"
    }
});
const $141cc20ec350ae53$export$2e85b5934aa19199 = ({ appearance: appearance, requestPending: requestPending, loading: loading, onClick: onClick })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9YwaJ.default), {
        appearance: appearance,
        isDisabled: requestPending,
        isLoading: loading,
        onClick: onClick
    }, requestPending ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $141cc20ec350ae53$export$a7357cdd1f0b0168.requestToUpgradePendingButton) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $141cc20ec350ae53$export$a7357cdd1f0b0168.requestToUpgradeButton));
module.exports["GuestRequestUpgradeButton"] = $141cc20ec350ae53$export$2e85b5934aa19199;

});

parcelRegister("e8W3S", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $bQm3c = parcelRequire("bQm3c");


var $hBkCm = parcelRequire("hBkCm");

var $f7B1p = parcelRequire("f7B1p");


var $eh0mb = parcelRequire("eh0mb");

const $b1ebfcc93144065b$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    upgradeRequestNote: {
        id: "external-collab-ui.guest-request-to-upgrade.upgrade-request-note",
        defaultMessage: "This guest requested a Confluence license"
    }
});
const $b1ebfcc93144065b$export$4f101f8b41ecae81 = (cloudId, upgradeRequestNote)=>JSON.stringify({
        resource: `ari:cloud:confluence::site/${cloudId}`,
        note: upgradeRequestNote
    });
const $b1ebfcc93144065b$export$1fcc21aa81264365 = '/gateway/api/invitations/v1/access-requests/request';
const $b1ebfcc93144065b$export$dce8274ecfbb9f9e = ({ onCompleted: onCompleted })=>{
    const intl = (0, $aXWIB.useIntl)();
    const [{ requestAccessState: requestAccessState }, { setRequestAccessState: setRequestAccessState }] = (0, $eh0mb.useGuestRequestUpgradeStore)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const submitGuestUpgradeRequest = (0, $42omo.useCallback)(async ()=>{
        setRequestAccessState('loading');
        return (0, $f7B1p.cfetch)($b1ebfcc93144065b$export$1fcc21aa81264365, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            },
            body: $b1ebfcc93144065b$export$4f101f8b41ecae81(cloudId, intl.formatMessage($b1ebfcc93144065b$export$a7357cdd1f0b0168.upgradeRequestNote))
        }).then((response)=>{
            if (response.ok && response.status === 200) {
                setRequestAccessState('submitted');
                onCompleted();
            } else {
                setRequestAccessState(undefined);
                throw new (0, $hBkCm.BadStatusError)(`${response.status}: ${response.statusText}`, response);
            }
        }).catch((caughtError)=>{
            setRequestAccessState(undefined);
            onCompleted(caughtError instanceof Error ? caughtError : new Error('Unknown error occurred during submission'));
        });
    }, [
        cloudId,
        intl,
        onCompleted,
        setRequestAccessState
    ]);
    return [
        submitGuestUpgradeRequest,
        {
            loading: requestAccessState === 'loading',
            isSubmitted: requestAccessState === 'submitted'
        }
    ];
};
module.exports["useSubmitGuestUpgradeRequest"] = $b1ebfcc93144065b$export$dce8274ecfbb9f9e;

});

parcelRegister("f9jv7", function(module, exports) {

var $aMcHK = parcelRequire("aMcHK");

const $b29e4bf652226e80$export$6ccdb59d3479f4f1 = (error)=>(0, $aMcHK.isStatusCodeError)(error, '404');
module.exports["isNotFoundError"] = $b29e4bf652226e80$export$6ccdb59d3479f4f1;

});

parcelRegister("fYKLM", function(module, exports) {
function $440eac8f72738c8c$export$2225b4c39d37f8b3(a, b) {
    const aKeys = Object.keys(a);
    const bKeys = Object.keys(b);
    if (aKeys.length !== bKeys.length) return false;
    return aKeys.every((key)=>Object.is(a[key], b[key]));
}
function $440eac8f72738c8c$export$3f55479a3469259f(isEqual = $440eac8f72738c8c$export$2225b4c39d37f8b3) {
    let cache = null;
    return (value)=>{
        if (cache && isEqual(cache.value, value)) return cache.value;
        cache = {
            value: value
        };
        return cache.value;
    };
}
module.exports["isShallowEqual"] = $440eac8f72738c8c$export$2225b4c39d37f8b3;
module.exports["stable"] = $440eac8f72738c8c$export$3f55479a3469259f;

});

parcelRegister("aTio4", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $8Mgg9 = parcelRequire("8Mgg9");


var $9JSVA = parcelRequire("9JSVA");

function $f32cc2f93c269bf0$export$62ed72bc21f6b8a6({ appearance: appearance = 'default', indent: indent }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $8Mgg9.Border), {
        strokeColor: (0, $9JSVA.presetStrokeColors)[appearance],
        indent: indent
    });
}
var // For React.lazy
$f32cc2f93c269bf0$export$2e2bcd8739ae039 = $f32cc2f93c269bf0$export$62ed72bc21f6b8a6;
module.exports["DropIndicator"] = $f32cc2f93c269bf0$export$62ed72bc21f6b8a6;

});

parcelRegister("8Mgg9", function(module, exports) {
/* border.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $9JSVA = parcelRequire("9JSVA");

const $e9c9b85493bf64c6$var$styles = null;
function $e9c9b85493bf64c6$export$d8e9c9d63e86d41e({ strokeColor: strokeColor = (0, $9JSVA.presetStrokeColors).default, strokeWidth: strokeWidth = (0, $9JSVA.presetStrokeWidth), borderRadius: borderRadius = '3px', indent: // TODO: update to radius.small (4px) token
indent = '0px' }) {
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        style: {
            '--stroke-color': strokeColor,
            '--stroke-width': strokeWidth,
            '--border-radius': borderRadius,
            '--indent': indent
        },
        className: (0, $gMc0m.default)([
            "_19it1ebc _2rko1koq _kqswstnw _152tidpf _u7coidpf _rjxpidpf _1e02armj _lcxvglyw"
        ])
    });
} // For React.lazy
var $e9c9b85493bf64c6$export$2e2bcd8739ae039 = $e9c9b85493bf64c6$export$d8e9c9d63e86d41e;
module.exports["Border"] = $e9c9b85493bf64c6$export$d8e9c9d63e86d41e;

});

parcelRegister("30D0J", function(module, exports) {

var $dK51B = parcelRequire("dK51B");


var $CIjCq = parcelRequire("CIjCq");

const $0f856dd8e4045e89$export$241fc4ad38d78de1 = ({ skip: skip, onError: onError, variables: variables })=>{
    return (0, $dK51B.useExperimentalQuery)({
        url: ({ userId: userId })=>`/gateway/api/tap-delivery/api/v3/personalization/user/${userId}`,
        method: 'GET',
        parseResult: (response)=>({
                experimentalUserPersonalization: {
                    attributes: (0, $CIjCq.stringifyPersonalizationAttributes)(response.attributes)
                }
            }),
        skip: skip,
        onError: onError,
        variables: variables
    });
};
module.exports["useExperimentalUserPersonalizationQuery"] = $0f856dd8e4045e89$export$241fc4ad38d78de1;

});

parcelRegister("2FNNv", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");

// Production trait: https://data-portal.internal.atlassian.com/targeting/traits/f0c5d949-91be-46e0-b440-7d7a953c9159
const $f30477d177bb95bd$var$IS_ESTABLISHED_USER_TRAIT_NAME = 'confluence_is_established_user';
// Staging trait: https://data-portal-stg.internal.atlassian.com/targeting/traits/4015e85e-221b-4d95-a945-c68548e21a8b
// NOTE: DO NOT USE Staging trait named as `confluence_is_established_user` - this is a legacy trait created with wrong evaluation type and won't work for staging
const $f30477d177bb95bd$var$IS_ESTABLISHED_USER_TRAIT_NAME_STAGING = 'confluence_is_established_user_stg';
const $f30477d177bb95bd$export$a284916a4d5ed017 = ()=>{
    const { environment: environment } = (0, $bQm3c.useSessionData)();
    if (environment !== 'PRODUCTION') return $f30477d177bb95bd$var$IS_ESTABLISHED_USER_TRAIT_NAME_STAGING;
    return $f30477d177bb95bd$var$IS_ESTABLISHED_USER_TRAIT_NAME;
};
module.exports["useIsEstablishedUserTraitName"] = $f30477d177bb95bd$export$a284916a4d5ed017;

});

parcelRegister("eFm27", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $3gadb = parcelRequire("3gadb");


var $inPa6 = parcelRequire("inPa6");


var $6GD8y = parcelRequire("6GD8y");


var $4tOXV = parcelRequire("4tOXV");


var $gnkil = parcelRequire("gnkil");


var $efvKr = parcelRequire("efvKr");


var $de2j9 = parcelRequire("de2j9");


var $clKWq = parcelRequire("clKWq");


var $cf6nm = parcelRequire("cf6nm");


var $77a1U = parcelRequire("77a1U");

const $75a2d6647cc04503$export$369212709d95b58d = ({ size: size, outlineAppearance: outlineAppearance, tooltipPosition: tooltipPosition, shortcut: shortcut, label: label, labelledBy: labelledBy, id: id, ...props })=>{
    const intl = (0, $aXWIB.useIntl)();
    const [{ isEditMode: isLiveEditMode }] = (0, $efvKr.useLivePageMode)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const spacing = size === 'small' ? 'compact' : 'default';
    const tooltipLabel = props.isStarred ? intl.formatMessage($75a2d6647cc04503$var$i18n.unstarContent) : intl.formatMessage($75a2d6647cc04503$var$i18n.starContent);
    const shortcutStrings = (0, $4tOXV.useShortcutStrings)({
        shortcut: shortcut
    });
    const buttonLabel = props.isStarred ? intl.formatMessage($75a2d6647cc04503$var$i18n.unstarContent) : intl.formatMessage($75a2d6647cc04503$var$i18n.starContent);
    const handleClick = (0, $42omo.useCallback)((starHandler, triggeredByKeyboardShortcut)=>(e)=>{
            starHandler(e);
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'pageStar',
                    attributes: {
                        triggeredByKeyboardShortcut: triggeredByKeyboardShortcut,
                        action: props.isStarred ? 'unstar' : 'star'
                    },
                    source: 'PageStarButton'
                }
            }).fire();
        }, [
        createAnalyticsEvent,
        props.isStarred
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $77a1U.PageStar), props, ({ toggle: toggleStar })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: tooltipLabel,
            shortcut: shortcutStrings,
            position: tooltipPosition || 'top',
            hideTooltipOnClick: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $clKWq.ConditionalHiddenAction), {
            isHidden: !props.isStarred
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $clKWq.ConditionalSubtleHoverButton), {
            id: id,
            isSubtle: outlineAppearance === 'subtle',
            "data-id": props.isStarred ? 'page-unstar-button' : 'page-star-button',
            testId: props.isStarred ? 'page-unstar-button' : 'page-star-button',
            spacing: spacing,
            appearance: "subtle",
            onClick: handleClick(toggleStar, false),
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cf6nm.StarIcon), {
                isStarred: props.isStarred,
                spacing: props.spacing
            }),
            "aria-label": buttonLabel,
            "aria-labelledby": labelledBy,
            "aria-pressed": props.isStarred,
            isDisabled: props.isDisabled
        }))), shortcut && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
            deprecatedAccelerator: !(isLiveEditMode || isOnEditRoute) ? (0, $gnkil.STAR_BUTTON_SHORTCUT) : undefined,
            accelerator: (0, $gnkil.UNIVERSAL_STAR_BUTTON_SHORTCUT),
            listener: handleClick(toggleStar, true)
        })));
};
const $75a2d6647cc04503$var$i18n = (0, $aXWIB.defineMessages)({
    starContent: {
        id: "action-buttons.content.starContent.label",
        defaultMessage: "Star this content"
    },
    unstarContent: {
        id: "action-buttons.content.unstarContent.label",
        defaultMessage: "Unstar this content"
    }
});
module.exports["PageStarButton"] = $75a2d6647cc04503$export$369212709d95b58d;

});

parcelRegister("7CeAz", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cEgMD = parcelRequire("cEgMD");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");


var $1ytiN = parcelRequire("1ytiN");


var $8NC5Z = parcelRequire("8NC5Z");

const $16ea73778f65e8da$export$1d4394ae12760637 = ()=>{
    const { frontCoverState: frontCoverState, isSiteAdmin: isSiteAdmin } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const shouldShowPremiumUpsell = (0, $8NC5Z.useCompanyHubPremiumGate)();
    const canPublish = isSiteAdmin || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS;
    const isAdminDiscoverable = // 1. If entitled (e.g. Premium), both site admin and product admin have the
    //    entry point in the top nav, because it leads to COMPANY_HUB.
    // 2. If not entitled (e.g. Free or Standard):
    //   a. only site admin has the entry point in the top nav, because it
    //      renders an upsell;
    //   b. product admin doesn't have the entry point in the top nav, because
    //      it automatically redirects to HOME.
    shouldShowPremiumUpsell ? isSiteAdmin : canPublish;
    const isCompanyHubFeatureAvailable = !shouldShowPremiumUpsell;
    const isCompanyHubPublished = Boolean(isCompanyHubFeatureAvailable && frontCoverState === (0, $cEgMD.FrontCoverStateEnum).SHOWN);
    const isCompanyHubShownToEditors = Boolean(isCompanyHubFeatureAvailable && frontCoverState === (0, $cEgMD.FrontCoverStateEnum).EDITORS_ONLY || isCompanyHubPublished);
    const isCompanyHubEntryPointEnabled = Boolean(isCompanyHubFeatureAvailable && (isCompanyHubPublished || isCompanyHubShownToEditors) || isAdminDiscoverable);
    return {
        canPublish: isCompanyHubFeatureAvailable && canPublish,
        isCompanyHubPublished: isCompanyHubPublished,
        isCompanyHubShownToEditors: isCompanyHubShownToEditors,
        isCompanyHubEntryPointEnabled: isCompanyHubEntryPointEnabled
    };
};
module.exports["useIsCompanyHubEnabled"] = $16ea73778f65e8da$export$1d4394ae12760637;

});

parcelRegister("8NC5Z", function(module, exports) {

var $896gY = parcelRequire("896gY");


var $7Sm4c = parcelRequire("7Sm4c");


var $euL71 = parcelRequire("euL71");


var $3IBnw = parcelRequire("3IBnw");


var $1uFM6 = parcelRequire("1uFM6");


var $f9jv7 = parcelRequire("f9jv7");


var $5ZqQS = parcelRequire("5ZqQS");


var $bQm3c = parcelRequire("bQm3c");


var $jMyy4 = parcelRequire("jMyy4");

const $1de3a5511529eed3$export$f032b5e8b485da1d = ({ skip: skip = false } = {})=>{
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const shouldSkip = skip || edition === (0, $euL71.ConfluenceEdition).PREMIUM;
    const { data: data, error: error } = (0, $jMyy4.useQueryInterop)((0, $896gY.default), {
        skip: shouldSkip
    });
    if (error) {
        if (!((0, $1uFM6.isUnauthorizedError)(error) || (0, $f9jv7.isNotFoundError)(error))) (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).MIGRATIONS_TOOLING
        });
        (0, $7Sm4c.markErrorAsHandled)(error);
    }
    return !shouldSkip && !data?.entitlements?.companyHub?.isEntitled;
};
module.exports["useCompanyHubPremiumGate"] = $1de3a5511529eed3$export$f032b5e8b485da1d;

});

parcelRegister("896gY", function(module, exports) {
/**
 * @generated SignedSource<<fd177939ba23d7eea0a5c1c1fd6fa501>>
 * @relayHash c31aa70a9a01e2207eb48c0b9be8b493
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 46122cb94f25a4d113917d2f15feffbc32da4a3126240723b7ca4eed1bf9dbd6
const $983e77d68212dc57$var$node = function() {
    var v0 = [
        {
            "concreteType": "Entitlements",
            "kind": "LinkedField",
            "name": "entitlements",
            "plural": false,
            "selections": [
                {
                    "concreteType": "CompanyHubFeature",
                    "kind": "LinkedField",
                    "name": "companyHub",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isEntitled"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useCompanyHubPremiumGateCompanyHubPremiumGateQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useCompanyHubPremiumGateCompanyHubPremiumGateQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "c31aa70a9a01e2207eb48c0b9be8b493",
            "id": "46122cb94f25a4d113917d2f15feffbc32da4a3126240723b7ca4eed1bf9dbd6",
            "metadata": {},
            "name": "useCompanyHubPremiumGateCompanyHubPremiumGateQuery",
            "operationKind": "query",
            "text": "query useCompanyHubPremiumGateCompanyHubPremiumGateQuery{entitlements{companyHub{isEntitled}}}"
        }
    };
}();
$983e77d68212dc57$var$node.hash = "a5508e7e7123c5675909c4f9214a5be2";
var $983e77d68212dc57$export$2e2bcd8739ae039 = $983e77d68212dc57$var$node;
module.exports["default"] = $983e77d68212dc57$export$2e2bcd8739ae039;

});

parcelRegister("jrref", function(module, exports) {
/* hide.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $7ca6755ada461d2d$var$styles = {
    'above.xs': "_114bglyw",
    'above.sm': "_181nglyw",
    'above.md': "_dm25glyw",
    'above.lg': "_je3oglyw",
    'above.xl': "_1uxvglyw",
    'below.xs': "_1m0aglyw",
    'below.sm': "_sugaglyw",
    'below.md': "_1mjbglyw",
    'below.lg': "_liwcglyw",
    'below.xl': "_14wzglyw"
};
const $7ca6755ada461d2d$export$bed28288a051538 = ({ above: above, below: below, children: children, as: AsElement = 'div', xcss: xcss })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(AsElement, {
        className: (0, $gMc0m.default)([
            above && $7ca6755ada461d2d$var$styles[`above.${above}`],
            below && $7ca6755ada461d2d$var$styles[`below.${below}`],
            xcss
        ]),
        children: children
    });
};
module.exports["Hide"] = $7ca6755ada461d2d$export$bed28288a051538;

});

parcelRegister("3Awqk", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $90247d71b6534bef$export$ce22f6f6b0034afd = (0, $aXWIB.defineMessages)({
    next: {
        id: "experiment-nth-user-orientation.spotlight.next",
        defaultMessage: "Next"
    },
    back: {
        id: "experiment-nth-user-orientation.spotlight.back",
        defaultMessage: "Back"
    },
    done: {
        id: "experiment-nth-user-orientation.spotlight.done",
        defaultMessage: "Done"
    },
    dismiss: {
        id: "experiment-nth-user-orientation.spotlight.dismiss",
        defaultMessage: "Dismiss Tour"
    },
    progress: {
        id: "experiment-nth-user-orientation.spotlight.progress",
        defaultMessage: "{step} of {steps}"
    }
});
const $90247d71b6534bef$export$9a4454cd199ce080 = (0, $aXWIB.defineMessages)({
    headline: {
        id: "experiment-nth-user-orientation.editorSpaceSpotlight.headline",
        defaultMessage: "Your space, your start"
    },
    body: {
        id: "experiment-nth-user-orientation.editorSpaceSpotlight.body",
        defaultMessage: "This is your personal space. Create more to organize your team\u2019s work."
    }
});
const $90247d71b6534bef$export$252e22890fb2efa6 = (0, $aXWIB.defineMessages)({
    headline: {
        id: "experiment-nth-user-orientation.editorForYouSpotlight.headline",
        defaultMessage: "Catch up on team activity here"
    },
    body: {
        id: "experiment-nth-user-orientation.editorForYouSpotlight.body",
        defaultMessage: "See recent pages, team updates, and quick links tailored for you."
    }
});
const $90247d71b6534bef$export$6794fada8079fe55 = (0, $aXWIB.defineMessages)({
    headline: {
        id: "experiment-nth-user-orientation.editorBpqaSpotlight.headline",
        defaultMessage: "Now let\u2019s create your first page!"
    },
    body: {
        id: "experiment-nth-user-orientation.editorBpqaSpotlight.body",
        defaultMessage: "With a template, a page is a click away. Hover on one for a preview."
    }
});
module.exports["spotlight"] = $90247d71b6534bef$export$ce22f6f6b0034afd;
module.exports["editorSpaceSpotlight"] = $90247d71b6534bef$export$9a4454cd199ce080;
module.exports["editorForYouSpotlight"] = $90247d71b6534bef$export$252e22890fb2efa6;
module.exports["editorBpqaSpotlight"] = $90247d71b6534bef$export$6794fada8079fe55;

});

parcelRegister("2AgON", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");

const $3c36b21fe0d55bcd$var$SPOTLIGHT_ACTION_SUBJECT_IDS = {
    'nth-user-orientation-editor-space-spotlight': 'nthUserOrientationEditorSpaceSpotlight',
    'nth-user-orientation-editor-for-you-spotlight': 'nthUserOrientationEditorForYouSpotlight',
    'nth-user-orientation-editor-bpqa-spotlight': 'nthUserOrientationEditorBpqaSpotlight'
};
function $3c36b21fe0d55bcd$export$b54fada573f13a91({ spotlightId: spotlightId, isVisible: isVisible, onNext: onNext, onBack: onBack, onDismiss: onDismiss }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    // Fire render event when spotlight becomes visible
    (0, $42omo.useEffect)(()=>{
        if (isVisible) createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'rendered',
                actionSubject: 'spotlight',
                actionSubjectId: $3c36b21fe0d55bcd$var$SPOTLIGHT_ACTION_SUBJECT_IDS[spotlightId],
                source: 'nth-user-orientation'
            }
        }).fire();
    }, [
        isVisible,
        createAnalyticsEvent,
        spotlightId
    ]);
    const handleNext = (0, $42omo.useCallback)(()=>{
        if (onNext) {
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'next',
                    source: spotlightId
                }
            }).fire();
            onNext();
        }
    }, [
        onNext,
        createAnalyticsEvent,
        spotlightId
    ]);
    const handleBack = (0, $42omo.useCallback)(()=>{
        if (onBack) {
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'back',
                    source: spotlightId
                }
            }).fire();
            onBack();
        }
    }, [
        onBack,
        createAnalyticsEvent,
        spotlightId
    ]);
    const handleDismiss = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'dismissTour',
                source: spotlightId
            }
        }).fire();
        onDismiss();
    }, [
        onDismiss,
        createAnalyticsEvent,
        spotlightId
    ]);
    return {
        handleNext: onNext ? handleNext : undefined,
        handleBack: onBack ? handleBack : undefined,
        handleDismiss: handleDismiss
    };
}
module.exports["useSpotlightAnalytics"] = $3c36b21fe0d55bcd$export$b54fada573f13a91;

});

parcelRegister("3SChL", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $751fcd22fac4dec6$export$7a357837346c6789 = {
    editor: [
        'nth-user-orientation-editor-space-spotlight',
        'nth-user-orientation-editor-for-you-spotlight',
        'nth-user-orientation-editor-bpqa-spotlight'
    ]
};
const $751fcd22fac4dec6$var$detectTour = (renderedSpotlights)=>{
    // Find the first tour where all required spotlights are registered
    for (const [tour, spotlights] of Object.entries($751fcd22fac4dec6$export$7a357837346c6789)){
        if (spotlights.every((spotlight)=>renderedSpotlights.has(spotlight))) return tour;
    }
    return null;
};
const $751fcd22fac4dec6$var$Store = (0, $1P1Tu.createStore)({
    initialState: {
        active: false,
        step: 0,
        renderedSpotlights: new Set(),
        hasInteracted: false
    },
    actions: {
        activate: ()=>({ setState: setState })=>{
                setState({
                    active: true,
                    step: 0
                });
            },
        reset: ()=>({ setState: setState })=>{
                setState({
                    active: false,
                    step: 0,
                    hasInteracted: false
                });
            },
        next: ()=>({ setState: setState, getState: getState })=>{
                const nextStep = Math.min(getState().step + 1, 2);
                setState({
                    step: nextStep,
                    hasInteracted: true
                });
            },
        back: ()=>({ setState: setState, getState: getState })=>{
                const prevStep = Math.max(getState().step - 1, 0);
                setState({
                    step: prevStep,
                    hasInteracted: true
                });
            },
        registerSpotlight: ({ spotlightId: spotlightId })=>({ setState: setState, getState: getState })=>{
                const newRegistered = new Set(getState().renderedSpotlights);
                newRegistered.add(spotlightId);
                setState({
                    renderedSpotlights: newRegistered
                });
            },
        deregisterSpotlight: ({ spotlightId: spotlightId })=>({ setState: setState, getState: getState })=>{
                const newRegistered = new Set(getState().renderedSpotlights);
                newRegistered.delete(spotlightId);
                setState({
                    renderedSpotlights: newRegistered
                });
            }
    },
    name: 'experiment-nth-user-orientation-store'
});
const $751fcd22fac4dec6$export$6d3060c9729a9bf7 = (0, $9zUhf.createStateHook)($751fcd22fac4dec6$var$Store);
const $751fcd22fac4dec6$export$31ec7099503725e8 = (0, $9zUhf.createActionsHook)($751fcd22fac4dec6$var$Store);
const $751fcd22fac4dec6$export$e9b94d8bc34db24 = (spotlightId)=>{
    const { next: next, back: back, reset: reset, registerSpotlight: registerSpotlight, deregisterSpotlight: deregisterSpotlight } = $751fcd22fac4dec6$export$31ec7099503725e8();
    const { step: step, active: active, renderedSpotlights: renderedSpotlights, hasInteracted: hasInteracted } = $751fcd22fac4dec6$export$6d3060c9729a9bf7();
    // Auto-register/deregister the spotlight when spotlights use this hook. This way
    // we can keep track of which spotlights are currently rendered, and use that list
    // to figure out if the user is eligible for a tour.
    (0, $42omo.useEffect)(()=>{
        registerSpotlight({
            spotlightId: spotlightId
        });
        return ()=>{
            deregisterSpotlight({
                spotlightId: spotlightId
            });
        };
    }, [
        spotlightId,
        registerSpotlight,
        deregisterSpotlight
    ]);
    const detectedTour = (0, $42omo.useMemo)(()=>$751fcd22fac4dec6$var$detectTour(renderedSpotlights), [
        renderedSpotlights
    ]);
    if (!active || !detectedTour) return {
        reset: reset,
        back: back,
        next: next,
        currentStep: null,
        progress: {
            step: 0,
            steps: 0
        },
        hasInteracted: hasInteracted,
        active: active
    };
    return {
        reset: reset,
        back: back,
        next: next,
        currentStep: $751fcd22fac4dec6$export$7a357837346c6789[detectedTour][step],
        progress: {
            step: step + 1,
            steps: detectedTour ? $751fcd22fac4dec6$export$7a357837346c6789[detectedTour].length : 0
        },
        hasInteracted: hasInteracted,
        active: active
    };
};
module.exports["useNthUserOrientationState"] = $751fcd22fac4dec6$export$6d3060c9729a9bf7;
module.exports["useNthUserOrientationActions"] = $751fcd22fac4dec6$export$31ec7099503725e8;
module.exports["useTour"] = $751fcd22fac4dec6$export$e9b94d8bc34db24;

});

parcelRegister("69QGC", function(module, exports) {
const $49e5b045f74dcd7a$var$COLLABORATION_GRAPH_MAX_RESULTS = 50;
const $49e5b045f74dcd7a$export$f757fae6e9facd6f = async (integration, cloudId, userId)=>{
    const payload = {
        context: {
            contextType: integration,
            principalId: userId,
            siteId: cloudId
        },
        modelRequestParams: {
            experience: 'CgUserNearbyUser'
        },
        expanded: true,
        maxNumberOfResults: $49e5b045f74dcd7a$var$COLLABORATION_GRAPH_MAX_RESULTS,
        userId: userId
    };
    const response = await fetch('/gateway/api/collaboration/v1/collaborationgraph/user/user', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
    });
    const result = (await response.json())?.collaborationGraphEntities?.filter((en)=>en?.userProfile !== undefined && en?.userProfile?.account_type !== 'app' && en?.userProfile?.account_status !== 'deactivated' && en?.userProfile?.account_status !== 'deleted').map(({ userProfile: { account_id: account_id, name: name, picture: picture } })=>({
            id: account_id,
            name: name,
            avatar: picture
        }));
    return result;
};
module.exports["getUsersFromCollaborationGraph"] = $49e5b045f74dcd7a$export$f757fae6e9facd6f;

});

parcelRegister("aDe4X", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $922yL = parcelRequire("922yL");

var $e0SBo = parcelRequire("e0SBo");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $ivb8S = parcelRequire("ivb8S");


var $b4VFP = parcelRequire("b4VFP");

var $dBcar = parcelRequire("dBcar");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");


var $2FNNv = parcelRequire("2FNNv");


var $30D0J = parcelRequire("30D0J");

const $d12c0291e106b88f$var$HOME_ONBOARDING_TAKEOVER_NTH_USER_DAYS = 14;
const $d12c0291e106b88f$export$de7bc1ba49cd35c5 = ()=>{
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { accessStatus: accessStatus, userId: userId } = (0, $bQm3c.useSessionData)();
    const isEstablishedUserTraitName = (0, $2FNNv.useIsEstablishedUserTraitName)();
    // User is licensed (site admin or nth user)
    const hasAdminOrUseAccess = accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    (0, $42omo.useEffect)(()=>{
        experienceTracker.start({
            name: (0, $irVI7.ONBOARDING_NTH_USER_HOME_ONBOARDING_TAKEOVER)
        });
    }, [
        experienceTracker
    ]);
    const { data: onboardingStateData, loading: onboardingStateLoading, error: onboardingStateError } = (0, $ivb8S.useGetOnboardingState)([
        (0, $dBcar.ONBOARDING_EXPERIENCES).IS_FOUNDING_ADMIN,
        ...Object.values((0, $b4VFP.HOME_ONBOARDING_TAKEOVER_V2_ONBOARDING_STATE_KEYS))
    ], !hasAdminOrUseAccess);
    const { isFoundingAdmin: isFoundingAdmin, takeoverSeenAt: takeoverSeenAt } = (0, $ivb8S.deserializeState)(onboardingStateData);
    const takeoverExpired = Boolean(takeoverSeenAt) && (0, $e0SBo.default)(Date.now(), (0, $922yL.default)(new Date(takeoverSeenAt), $d12c0291e106b88f$var$HOME_ONBOARDING_TAKEOVER_NTH_USER_DAYS));
    const { data: userPersonalizationQueryData, loading: userPersonalizationQueryLoading, error: userPersonalizationQueryError } = (0, $30D0J.useExperimentalUserPersonalizationQuery)({
        skip: !hasAdminOrUseAccess || takeoverExpired,
        variables: {
            userId: userId
        }
    });
    const attributes = userPersonalizationQueryData?.experimentalUserPersonalization?.attributes ?? [];
    const isEstablishedUser = attributes.find((attr)=>attr?.name === isEstablishedUserTraitName)?.value === 'true';
    const isEstablishedUserReady = !userPersonalizationQueryLoading && !userPersonalizationQueryError;
    const isNotEstablishedUser = isEstablishedUserReady && !isEstablishedUser;
    const isEligible = Boolean(hasAdminOrUseAccess && (takeoverSeenAt ?? isNotEstablishedUser) && !isFoundingAdmin);
    if (onboardingStateError || userPersonalizationQueryError) experienceTracker.stopOnError({
        name: (0, $irVI7.ONBOARDING_NTH_USER_HOME_ONBOARDING_TAKEOVER),
        error: onboardingStateError || userPersonalizationQueryError
    });
    return {
        isEligible: isEligible,
        isVisible: isEligible && !takeoverExpired,
        loading: onboardingStateLoading || userPersonalizationQueryLoading
    };
};
module.exports["useNthUserHomeOnboardingTakeoverV2Eligibility"] = $d12c0291e106b88f$export$de7bc1ba49cd35c5;

});

parcelRegister("35Nok", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cOrQJ = parcelRequire("cOrQJ");

const $cd2e96a49affba4b$export$4b64aca38e15f2eb = ({ gif: gif, placeholder: placeholder, skip: skip = false })=>{
    const { colorMode: colorMode } = (0, $cOrQJ.default)();
    const gifSrc = gif[colorMode ?? 'light'];
    const placeholderSrc = placeholder[colorMode ?? 'light'];
    const [isReady, setIsReady] = (0, $42omo.useState)(false);
    (0, $42omo.useEffect)(()=>{
        if (skip) return;
        setIsReady(false);
        const image = new Image();
        image.onload = ()=>{
            setIsReady(true);
        };
        image.onerror = ()=>{
            setIsReady(false);
        };
        image.src = gifSrc;
        // If the image has already loaded (cached), handle it immediately
        if (image.complete) setIsReady(true);
    }, [
        gifSrc,
        skip
    ]);
    return isReady ? gifSrc : placeholderSrc;
};
module.exports["usePreloadGif"] = $cd2e96a49affba4b$export$4b64aca38e15f2eb;

});


//# sourceMappingURL=GlobalNavigationComponent.6d650ff1.js.map
